/**
 * @owner @Appboy/frontend-ix
 */
import { postAlloysShopifyAppGroupIdBridgesBridgeIdCatalogItemErrorsExport } from "@dashboardApi/apis/alloysShopifyAppGroupIdBridgesBridgeIdCatalogItemErrorsExport";
import { postAppGroupsAppGroupIdPlacementsUpdateArchivedState } from "@dashboardApi/apis/appGroupsAppGroupIdPlacementsUpdateArchivedState";
import { getDataTableAppSettingsAppIdentifiers } from "@dashboardApi/apis/appSettingsAppIdentifiers";
import { postCancelCsvImport } from "@dashboardApi/apis/appsAppGroupIdCancelImport";
import { postInitializeCsvImport } from "@dashboardApi/apis/appsAppGroupIdInitializeCsvImport";
import { postQuickAddUserProfile } from "@dashboardApi/apis/appsAppGroupIdQuickAddUserProfile";
import { getAppsAppGroupIdUserImportsImportId } from "@dashboardApi/apis/appsAppGroupIdUserImportsImportId";
import { postCancelUserImportValidation } from "@dashboardApi/apis/appsAppGroupIdUserImportsImportIdCancelValidation";
import { postAppsAppGroupIdUserImportsImportIdDataMapsDataMapIdUpdateMap } from "@dashboardApi/apis/appsAppGroupIdUserImportsImportIdDataMapsDataMapIdUpdateMap";
import { postAppsAppGroupIdUserImportsImportIdEventCatalogSlice } from "@dashboardApi/apis/appsAppGroupIdUserImportsImportIdEventCatalogSlice";
import { postAppsAppGroupIdUserImportsImportIdInitializeMap } from "@dashboardApi/apis/appsAppGroupIdUserImportsImportIdInitializeMap";
import { getAppsAppGroupIdUserImportsImportIdScanEventNames } from "@dashboardApi/apis/appsAppGroupIdUserImportsImportIdScanEventNames";
import { getAppsAppGroupIdUserImportsImportIdSearchEventCatalog } from "@dashboardApi/apis/appsAppGroupIdUserImportsImportIdSearchEventCatalog";
import { postAppsAppGroupIdUserImportsImportIdTransformColumnMapping } from "@dashboardApi/apis/appsAppGroupIdUserImportsImportIdTransformColumnMapping";
import { postAppsCatalogFields } from "@dashboardApi/apis/appsCatalogFields/postAppsCatalogFields";
import { postUploadCsvChunk } from "@dashboardApi/apis/appsUploadCsvChunk";
import { getDataTableBannersConsumption } from "@dashboardApi/apis/bannersConsumption/getDataTableBannersConsumption";
import { getDataTableCampaignCanvasConsumption } from "@dashboardApi/apis/campaignCanvasConsumption/getDataTableCampaignCanvasConsumption";
import { getCompaniesCompanyIdCustomDomainsLimits } from "@dashboardApi/apis/companiesCompanyIdCustomDomainsLimits/getCompaniesCompanyIdCustomDomainsLimits";
import { getAudienceSyncAllotments } from "@dashboardApi/apis/company/getAudienceSyncAllotments";
import { getDataTableContentCardsConsumption } from "@dashboardApi/apis/contentCardsConsumption/getDataTableContentCardsConsumption";
import {
  getConversationHistoryDetail,
  getDataTableConversationHistory,
} from "@dashboardApi/apis/conversationHistory";
import { getConversationalInboundMessageTriggers } from "@dashboardApi/apis/conversationalInboundMessageTriggers/getConversationalInboundMessageTriggers";
import { getConversationalPreviewMessageHistory } from "@dashboardApi/apis/conversationalPreviewMessageHistory/getConversationalPreviewMessageHistory";
import { getConversationalPreviewSettingsWorkflows } from "@dashboardApi/apis/conversationalPreviewSettingsWorkflows/getConversationalPreviewSettingsWorkflows";
import { getConversationalReplyRouting } from "@dashboardApi/apis/conversationalReplyRouting/getConversationalReplyRouting";
import { getConversationalSettings } from "@dashboardApi/apis/conversationalSettings/getConversationalSettings";
import { postConversationalPreviewSettings } from "@dashboardApi/apis/conversationalSettings/postConversationalPreviewSettings";
import { putConversationalSettings } from "@dashboardApi/apis/conversationalSettings/putConversationalSettings";
import { deleteSimulationCase } from "@dashboardApi/apis/conversationalSimulation/deleteSimulationCase";
import { getSimulationCase } from "@dashboardApi/apis/conversationalSimulation/getSimulationCase";
import { getSimulationCases } from "@dashboardApi/apis/conversationalSimulation/getSimulationCases";
import { getSimulationRun } from "@dashboardApi/apis/conversationalSimulation/getSimulationRun";
import { getSimulationRuns } from "@dashboardApi/apis/conversationalSimulation/getSimulationRuns";
import { getSimulationWebhooks } from "@dashboardApi/apis/conversationalSimulation/getSimulationWebhooks";
import { postSimulationCase } from "@dashboardApi/apis/conversationalSimulation/postSimulationCase";
import { postSimulationRun } from "@dashboardApi/apis/conversationalSimulation/postSimulationRun";
import { putSimulationCase } from "@dashboardApi/apis/conversationalSimulation/putSimulationCase";
import { getConversationalTags } from "@dashboardApi/apis/conversationalTags/getConversationalTags";
import { getConversationalTerritories } from "@dashboardApi/apis/conversationalTerritories/getConversationalTerritories";
import { postConversationalTestWebhook } from "@dashboardApi/apis/conversationalTestWebhook/postConversationalTestWebhook";
import { postConversationalToolDefinition } from "@dashboardApi/apis/conversationalToolDefinition/postConversationalToolDefinition";
import { deleteConversationalToolDefinitionId } from "@dashboardApi/apis/conversationalToolDefinitionId/deleteConversationalToolDefinitionId";
import { getConversationalToolDefinitionId } from "@dashboardApi/apis/conversationalToolDefinitionId/getConversationalToolDefinitionId";
import { putConversationalToolDefinitionId } from "@dashboardApi/apis/conversationalToolDefinitionId/putConversationalToolDefinitionId";
import { getDataTableConversationalToolDefinitions } from "@dashboardApi/apis/conversationalToolDefinitions/getDataTableConversationalToolDefinitions";
import { deleteConversationalWorkflow } from "@dashboardApi/apis/conversationalWorkflow/deleteConversationalWorkflow";
import { getConversationalWorkflow } from "@dashboardApi/apis/conversationalWorkflow/getConversationalWorkflow";
import { postConversationalPreviewWorkflow } from "@dashboardApi/apis/conversationalWorkflow/postConversationalPreviewWorkflow";
import { postConversationalWorkflow } from "@dashboardApi/apis/conversationalWorkflow/postConversationalWorkflow";
import { putConversationalWorkflow } from "@dashboardApi/apis/conversationalWorkflow/putConversationalWorkflow";
import { getDataTableConversationalWorkflows } from "@dashboardApi/apis/conversationalWorkflows/getDataTableConversationalWorkflows";
import { getDataTableCreditRatios } from "@dashboardApi/apis/creditRatios";
import { getCustomObjectsCustomObjectTypeAttributes } from "@dashboardApi/apis/customObjectsCustomObjectTypeAttributes";
import { getCustomObjectsCustomObjectTypeRelationships } from "@dashboardApi/apis/customObjectsCustomObjectTypeRelationships";
import { getCustomObjectsCustomObjectTypeSchema } from "@dashboardApi/apis/customObjectsCustomObjectTypeSchema";
import { getCustomObjectsCustomObjectTypes } from "@dashboardApi/apis/customObjectsCustomObjectTypes";
import { postCustomObjectsObjectRelationshipTypeFields } from "@dashboardApi/apis/customObjectsObjectRelationshipTypeFields";
import { getCustomObjectsObjectRelationshipTypeSchema } from "@dashboardApi/apis/customObjectsObjectRelationshipTypeSchema";
import { getDataTableCustomObjectsTypeName } from "@dashboardApi/apis/customObjectsTypeName";
import {
  deleteCustomObjectsTypeNameObjectId,
  patchCustomObjectsTypeNameObjectId,
} from "@dashboardApi/apis/customObjectsTypeNameObjectId";
import {
  deleteCustomObjectsTypeNameObjectIdObjectRelationships,
  getDataTableCustomObjectsTypeNameObjectIdObjectRelationships,
  postCustomObjectsTypeNameObjectIdObjectRelationships,
} from "@dashboardApi/apis/customObjectsTypeNameObjectIdObjectRelationships";
import { getCustomObjectsTypeNameObjectIdUnlinkedObjects } from "@dashboardApi/apis/customObjectsTypeNameObjectIdUnlinkedObjects";
import { getCustomObjectsTypeNameObjectIdUnlinkedUsers } from "@dashboardApi/apis/customObjectsTypeNameObjectIdUnlinkedUsers";
import {
  getDataTableCustomObjectsTypeNameObjectIdUsers,
  postCustomObjectsTypeNameObjectIdUsers,
} from "@dashboardApi/apis/customObjectsTypeNameObjectIdUsers";
import {
  getDataTableCustomObjectsTypeNameSchemaFields,
  postCustomObjectsTypeNameSchemaFields,
} from "@dashboardApi/apis/customObjectsTypeNameSchemaFields";
import {
  deleteCustomObjectsTypeNameSchemaFieldsFieldName,
  patchCustomObjectsTypeNameSchemaFieldsFieldName,
} from "@dashboardApi/apis/customObjectsTypeNameSchemaFieldsFieldName";
import { getCustomObjectsUsage } from "@dashboardApi/apis/customObjectsUsage";
import { getCustomObjectsUserCustomObjectTypeRelationships } from "@dashboardApi/apis/customObjectsUserCustomObjectTypeRelationships";
import { getCustomObjectsUserLinkedCustomObjectTypes } from "@dashboardApi/apis/customObjectsUserLinkedCustomObjectTypes";
import { getCustomObjectsUserRelationshipTypeAttributes } from "@dashboardApi/apis/customObjectsUserRelationshipTypeAttributes";
import { postCustomObjectsUserRelationshipTypeFields } from "@dashboardApi/apis/customObjectsUserRelationshipTypeFields";
import { getCustomObjectsUserRelationshipTypeSchema } from "@dashboardApi/apis/customObjectsUserRelationshipTypeSchema";
import { getTransformationDetail } from "@dashboardApi/apis/dataTransformation";
import { getTransformationPackageDetail } from "@dashboardApi/apis/dataTransformation/getTransformationPackageDetail";
import { validateTransformation } from "@dashboardApi/apis/dataTransformation/validateTransformation";
import { refreshSegmentCohort } from "@dashboardApi/apis/engagementApiSegmentCohorts/refreshSegmentCohort";
import { getEngagementGetTableDefinitions } from "@dashboardApi/apis/engagementGetTableDefinitions/getEngagementTableDefinitions";
import { getEngagementRemoteFilterQuery } from "@dashboardApi/apis/engagementRemoteFilterQuery";
import { postEngagementReportDashboardDashboardIdCreateTileDataQuery } from "@dashboardApi/apis/engagementReportDashboardDashboardIdCreateTileDataQuery";
import { getDataTableEngagementReportDashboards } from "@dashboardApi/apis/engagementReportDashboards";
import { getSegmentStats } from "@dashboardApi/apis/engagementSegmentStats";
import { requestUserDirectoryPreview } from "@dashboardApi/apis/engagementUserDirectoryPreview/requestUserDirectoryPreview";
import { getCdiImportSyncsAll } from "@dashboardApi/apis/integrationsDirectCdiImportSyncsAll/getCdiImportSyncsAll";
import { getDataTableKakaoConsumption } from "@dashboardApi/apis/kakaoConsumption/getDataTableKakaoConsumption";
import { getDataTableLineConsumption } from "@dashboardApi/apis/lineConsumption/getDataTableLineConsumption";
import { getDataTableMessageArchivingConsumption } from "@dashboardApi/apis/messageArchivingConsumption/getDataTableMessageArchivingConsumption";
import { getDashboardReportTags } from "@dashboardApi/apis/reportDashboardTags";
import { putReportDashboardsUpdateTags } from "@dashboardApi/apis/reportDashboardsUpdateTags";
import { getWebhookMessageTemplateId } from "@dashboardApi/apis/webhookMessageTemplateId";
import { getDataTableWebhooksConsumption } from "@dashboardApi/apis/webhooksConsumption/getDataTableWebhooksConsumption";
import { getWhatsAppAccounts } from "@dashboardApi/apis/whatsAppAccounts";
import { getWhatsAppFlowListBySubscriptionGroup } from "@dashboardApi/apis/whatsappFlows/getWhatsAppFlowListBySubscriptionGroup";

import { deleteMessage } from "./canvas/step/message/delete";
import { getMessage } from "./canvas/step/message/get";
import { postMessage } from "./canvas/step/message/post";
import { putMessage } from "./canvas/step/message/put";
import { getMessages } from "./canvas/step/messages/get";
import { patchCanvasStepName } from "./canvas/step/name/patch";
import { patchCanvasStepPosition } from "./canvas/step/position/patch";
import { patchCanvasStepsPosition } from "./canvas/steps/position/patch";
import { postCanvasAudiencePreview } from "./canvas/audiencePreview/post";
import { getCanvasStep } from "./canvas/step/get";
import { patchCanvasStep } from "./canvas/step/patch";
import { postCanvasStep } from "./canvas/step/post";
import { putAppSettingsDeleteApiKey } from "././appSettingsDeleteApiKey";
import { postAppSettingsInternalUserGroupsInternalUserGroupCreate } from "././appSettingsInternalUserGroupsInternalUserGroupCreate";
import { putAppSettingsInternalUserGroupsInternalUserGroupUpdate } from "././appSettingsInternalUserGroupsInternalUserGroupUpdate";
import { getReportBuilderReportResults } from "././engagementReportBuilder2ReportIdResult";
import { postApiCalculatedFiltersAppGroupId } from "./apiCalculatedFiltersAppGroupId/postApiCalculatedFiltersAppGroupId";
import {
  deleteTestUser,
  getInternalUserGroups,
  getTestUserNames,
  postTestUser,
} from "./appSettings/internalUserGroups";
import { postEngagementCanvas } from "./canvas/canvas";
import { getCanvas } from "./canvas/canvasData";
import { getCanvasLastEdit } from "./canvas/canvasLastEdit";
import { getCanvasStepsPost } from "./canvas/canvasSteps";
import { getCanvasVersion } from "./canvas/canvasVersion";
import { getCanvasVersionStepsChunked } from "./canvas/canvasVersionSteps";
import { getCanvasVersions } from "./canvas/canvasVersions";
import { getCompaniesCompanyIdCustomDomains } from "./companiesCompanyIdCustomDomains/getCompaniesCompanyIdCustomDomains";
import { createTransformation } from "./dataTransformation/createTransformation";
import { getTransformation } from "./dataTransformation/getTransformation";
import { renameTransformation } from "./dataTransformation/renameTransformation";
import { submitTransformation } from "./dataTransformation/submitTransformation";
import { updateTransformation } from "./dataTransformation/updateTransformation";
import { getDevelopers } from "./developer/getDevelopers";
import { getEngagementCanvasCanvasTerritories } from "./engagementCanvasCanvasTerritories/getEngagementCanvasCanvasTerritories";
import { getEngagementApiSqlSegmentCohortsAccountUsage } from "./engagementSqlSegmentCohortsAccountUsage/getEngagementApiSqlSegmentCohortsAccountUsage";
import { postFreeTrialSubmitPreVerification } from "./freeTrialRegistration/freeTrialSubmitPreVerification";
import { submitRegistrationData } from "./freeTrialRegistration/submitRegistrationData";
import { validateEmail } from "./freeTrialRegistration/validateEmail";
import { validateSms } from "./freeTrialRegistration/validateSms";
import { verifyEmail } from "./freeTrialRegistration/verifyEmail";
import { verifySms } from "./freeTrialRegistration/verifySms";
import { getAdminGetImpersonationLogs } from "./adminGetImpersonationLogs";
import { postAdminImpersonate } from "./adminImpersonate";
import { getAdminImpersonation } from "./adminImpersonation";
import { getAdminImpersonationCapabilities } from "./adminImpersonationCapabilities";
import { postAdminRequestImpersonation } from "./adminRequestImpersonation";
import { getDataTableAgentConsoleConsumption } from "./agentConsoleConsumption";
import { getAgentConsoleCreditRatios } from "./agentConsoleCreditRatios";
import { postwsAiAgentAsyncDynamicPromptsAppGroupId } from "./aiAgentAsyncDynamicPromptsAppGroupId";
import { postAiAgentGeminiInteractionsAppGroupId } from "./aiAgentGeminiInteractionsAppGroupId";
import { postAiAgentOpenaiResponsesAppGroupId } from "./aiAgentOpenaiResponsesAppGroupId";
import {
  getAlloysAdjustCustomEventsAppGroupId,
  postAlloysAdjustCustomEventsAppGroupId,
} from "./alloysAdjustCustomEventsAppGroupId";
import { deleteAlloysAdjustCustomEventsAppGroupIdDisconnect } from "./alloysAdjustCustomEventsAppGroupIdDisconnect";
import {
  deleteAlloysGeminiAgenticAppGroupIdOauthDisconnect,
  getAlloysGeminiAgenticAppGroupIdOauthProjects,
  getAlloysGeminiAgenticAppGroupIdOauthVerifyProject,
  postAlloysGeminiAgenticAppGroupIdOauthConnect,
  postAlloysGeminiAgenticAppGroupIdOauthSelectProject,
} from "./alloysGeminiAgenticAppGroupIdOauth";
import { getAlloysIntegrationsIntegrationIdBridge } from "./alloysIntegrationsIntegrationIdBridge";
import {
  deleteAlloysPartnerAttributionAppGroupId,
  getAlloysPartnerAttributionAppGroupId,
  postAlloysPartnerAttributionAppGroupId,
} from "./alloysPartnerAttributionAppGroupId";
import {
  getAlloysPartnerCohortImportAppGroupId,
  postAlloysPartnerCohortImportAppGroupId,
} from "./alloysPartnerCohortImportAppGroupId";
import { getAlloysPartnersAlloysId } from "./alloysPartnersAlloysId";
import { postAlloysPartnersAlloysIdBreakingChangesExport } from "./alloysPartnersAlloysIdBreakingChangesExport";
import {
  deleteAlloysPartnersDatadogAppGroupId,
  getAlloysPartnersDatadogAppGroupId,
  postAlloysPartnersDatadogAppGroupId,
} from "./alloysPartnersDatadogAppGroupId";
import {
  deleteAlloysPartnersGooglePostmasterAppGroupId,
  getAlloysPartnersGooglePostmasterAppGroupId,
  postAlloysPartnersGooglePostmasterAppGroupIdConnect,
} from "./alloysPartnersGooglePostmasterAppGroupId";
import { getAlloysPartnersShopifyAppGroupIdBridges } from "./alloysPartnersShopifyAppGroupIdBridges";
import {
  deleteAlloysPartnersShopifyAppGroupIdBridgesBridgeId,
  getAlloysPartnersShopifyAppGroupIdBridgesBridgeId,
  patchAlloysPartnersShopifyAppGroupIdBridgesBridgeId,
} from "./alloysPartnersShopifyAppGroupIdBridgesBridgeId";
import { getAlloysPartnersShopifyAppGroupIdBridgesBridgeIdAppEmbed } from "./alloysPartnersShopifyAppGroupIdBridgesBridgeIdAppEmbed";
import { getAlloysPartnersShopifyAppGroupIdBridgesBridgeIdBackfillEstimates } from "./alloysPartnersShopifyAppGroupIdBridgesBridgeIdBackfillEstimates";
import { getAlloysPartnersShopifyAppGroupIdBridgesBridgeIdCatalogItemErrorCount } from "./alloysPartnersShopifyAppGroupIdBridgesBridgeIdCatalogItemErrorCount";
import { getAlloysPartnersShopifyFetchCollections } from "./alloysPartnersShopifyFetchCollections";
import { getAlloysPartnersShopifyFetchMarkets } from "./alloysPartnersShopifyFetchMarkets";
import { getAlloysPartnersShopifyFetchProductTags } from "./alloysPartnersShopifyFetchProductTags";
import { getAlloysPartnersShopifyFetchSegments } from "./alloysPartnersShopifyFetchSegments";
import { getAlloysPartnersShopifyIntegrationIdFetchCustomerMetafields } from "./alloysPartnersShopifyIntegrationIdFetchCustomerMetafields";
import { getAlloysPartnersShopifyIntegrationIdFetchProductMetafields } from "./alloysPartnersShopifyIntegrationIdFetchProductMetafields";
import {
  deleteAlloysAmazonBedrockAgenticExternalId,
  deleteAlloysProviderAgenticAppGroupId,
  getAlloysAmazonBedrockAgenticExternalId,
  getAlloysProviderAgenticAppGroupId,
  postAlloysAmazonBedrockAgenticExternalId,
  postAlloysProviderAgenticAppGroupId,
} from "./alloysProviderAgenticAppGroupId";
import { postAlloysShopifyAppGroupIdBridgesBridgeIdCatalogResync } from "./alloysShopifyAppGroupIdBridgesBridgeIdCatalogResync";
import {
  getAlloysZendeskSunshineAppGroupId,
  postAlloysZendeskSunshineAppGroupId,
} from "./alloysZendeskSunshineAppGroupId";
import { getAnalyticsDashboardAppGroupIdCreditConsumptionData } from "./analyticsDashboardAppGroupIdCreditConsumptionData";
import { getAnalyticsDashboardAppGroupIdCreditConsumptionTimePeriodData } from "./analyticsDashboardAppGroupIdCreditConsumptionTimePeriodData";
import { getAnalyticsDashboardAppGroupIdEmailEngagementByDeviceClassData } from "./analyticsDashboardAppGroupIdEmailEngagementByDeviceClassData";
import {
  getAnalyticsDashboardAppGroupIdEmailEngagementByProvidersData,
  postAnalyticsDashboardAppGroupIdEmailEngagementByProvidersData,
} from "./analyticsDashboardAppGroupIdEmailEngagementByProvidersData";
import { getAnalyticsDashboardAppGroupIdEmailEngagementByTimeData } from "./analyticsDashboardAppGroupIdEmailEngagementByTimeData";
import { getAnalyticsDashboardAppGroupIdGetCampaignsForFilter } from "./analyticsDashboardAppGroupIdGetCampaignsForFilter";
import { getAnalyticsDashboardAppGroupIdGetCanvasesForFilter } from "./analyticsDashboardAppGroupIdGetCanvasesForFilter";
import {
  getApiCalculatedAttributesAppGroupId,
  postApiCalculatedAttributesAppGroupId,
} from "./apiCalculatedAttributesAppGroupId";
import { postApiCalculatedAttributesAppGroupIdDeactivate } from "./apiCalculatedAttributesAppGroupIdDeactivate";
import { postApiCalculatedAttributesAppGroupIdReactivate } from "./apiCalculatedAttributesAppGroupIdReactivate";
import { getApiCalculatedAttributesIdAppGroupIdEngagements } from "./apiCalculatedAttributesIdAppGroupIdEngagements";
import { getApiCalculatedAttributesAppGroupIdTags } from "./apiCalculatedAttributesAppGroupIdTags";
import {
  getApiCalculatedAttributesIdAppGroupId,
  putApiCalculatedAttributesIdAppGroupId,
} from "./apiCalculatedAttributesIdAppGroupId";
import { postApiCalculatedAttributesIdAppGroupIdRefresh } from "./apiCalculatedAttributesIdAppGroupIdRefresh";
import { getApiCalculatedAttributesIdAppGroupIdUserLookup } from "./apiCalculatedAttributesIdAppGroupIdUserLookup";
import { getApiCalculatedFiltersAppGroupId } from "./apiCalculatedFiltersAppGroupId";
import { patchApiCalculatedFiltersAppGroupIdArchive } from "./apiCalculatedFiltersAppGroupIdArchive";
import { patchApiCalculatedFiltersAppGroupIdUnarchive } from "./apiCalculatedFiltersAppGroupIdUnarchive";
import {
  getApiCalculatedFiltersIdAppGroupId,
  putApiCalculatedFiltersIdAppGroupId,
} from "./apiCalculatedFiltersIdAppGroupId";
import { getApiCalculatedFiltersIdAppGroupIdEngagements } from "./apiCalculatedFiltersIdAppGroupIdEngagements";
import { postApiCalculatedFiltersIdAppGroupIdRefresh } from "./apiCalculatedFiltersIdAppGroupIdRefresh";
import { getApiEcommerceEventProperties } from "./apiEcommerceEventProperties";
import { getApiEcommerceRecommendedEvents } from "./apiEcommerceRecommendedEvents";
import { deleteApiUsageAlert, postApiUsageAlertUpsert } from "./apiUsageAlertUpsert";
import { postAppsApprovalSettings } from "./appApprovalSettings";
import { getAppBrazeDashboardConfig } from "./appBrazeDashboardConfig";
import { postAppGroupIdBrazeDocsFallbackSearch } from "./appGroupIdBrazeDocsFallbackSearch";
import { postAppGroupIdBrazeDocsLookup } from "./appGroupIdBrazeDocsLookup";
import { postAppGroupIdBrazeDocsSearch } from "./appGroupIdBrazeDocsSearch";
import { postAppGroupIdBrazeMcpCallTool } from "./appGroupIdBrazeMcpCallTool";
import { getAppGroupIdBrazeMcpTools } from "./appGroupIdBrazeMcpTools";
import { getCampaignMessageVariation } from "./appGroupIdCampaignCampaignIdMessagesMessageVariationId";
import { postwsAppGroupIdComparePreviewsAi } from "./appGroupIdComparePreviewsAi";
import { postAppGroupIdFigmaFileNodes } from "./appGroupIdFigmaFileNodes";
import { postAppGroupIdFigmaImages } from "./appGroupIdFigmaImages";
import { deleteAppGroupIdFigmaOauthDisconnect } from "./appGroupIdFigmaOauthDisconnect";
import { getAppGroupIdFigmaOauthStatus } from "./appGroupIdFigmaOauthStatus";
import { postwsAppGroupIdGenerateImage } from "./appGroupIdGenerateImage";
import { postAppGroupIdLiquidValidationCheckSyntax } from "./appGroupIdLiquidValidationCheckSyntax";
import { getAppGroupIdLiquidValidationFeatures } from "./appGroupIdLiquidValidationFeatures";
import {
  getAppGroupIdOperatorMcpConnections,
  postAppGroupIdOperatorMcpConnections,
} from "./appGroupIdOperatorMcpConnections";
import { deleteAppGroupIdOperatorMcpConnectionsConnectionId } from "./appGroupIdOperatorMcpConnectionsConnectionId";
import { postAppGroupIdOperatorMcpConnectionsConnectionIdCallTool } from "./appGroupIdOperatorMcpConnectionsConnectionIdCallTool";
import { deleteAppGroupIdOperatorMcpConnectionsConnectionIdTokens } from "./appGroupIdOperatorMcpConnectionsConnectionIdTokens";
import { getAppGroupIdOperatorMcpConnectionsTools } from "./appGroupIdOperatorMcpConnectionsTools";
import { getAppGroupIdPlaywrightScanA11y } from "./appGroupIdPlaywrightScanA11y";
import {
  getAppGroupsAppGroupIdBannerPriority,
  postAppGroupsAppGroupIdBannerPriority,
} from "./appGroupsAppGroupIdBannerPriority";
import {
  getDataTableAppGroupsAppGroupIdPlacements,
  postAppGroupsAppGroupIdPlacements,
} from "./appGroupsAppGroupIdPlacements";
import {
  getAppGroupsAppGroupIdPlacementsId,
  patchAppGroupsAppGroupIdPlacementsId,
} from "./appGroupsAppGroupIdPlacementsId";
import { getAppGroupsAppGroupIdPlacementsIdPreview } from "./appGroupsAppGroupIdPlacementsIdPreview";
import { getAppSettingsAllTags } from "./appSettingsAllTags";
import { getApiKeyDetails } from "./appSettingsApiKeyDetailsApiKey";
import { getDataTableAppSettingsApiSettingsInfoDatatableAppGroupId } from "./appSettingsApiSettingsInfoDatatableAppGroupId";
import { getAppSettingsAppGroupIdApiKeysApiKeyIdMetadata } from "./appSettingsAppGroupIdApiKeysApiKeyIdMetadata";
import { getMessagePrioritizationCategoriesData } from "./appSettingsAppGroupIdMessagePrioritizationCategoriesData";
import { postMessagePrioritizationCategory } from "./appSettingsAppGroupIdMessagePrioritizationCategory";
import { deleteMessagePrioritizationCategory } from "./appSettingsAppGroupIdMessagePrioritizationCategoryCategoryId";
import { getMessagePrioritizationCategoryDependencies } from "./appSettingsAppGroupIdMessagePrioritizationCategoryCategoryIdDependencies";
import { getMessagePrioritizationFrequencyCappingCoverage } from "./appSettingsAppGroupIdMessagePrioritizationFrequencyCappingCoverage";
import { getMessagePrioritizationHasFrequencyCappingRules } from "./appSettingsAppGroupIdMessagePrioritizationHasFrequencyCappingRules";
import { postMessagePrioritizationRules } from "./appSettingsAppGroupIdMessagePrioritizationRules";
import { getMessagePrioritizationRulesData } from "./appSettingsAppGroupIdMessagePrioritizationRulesData";
import { postMessagePrioritizationRulesValidation } from "./appSettingsAppGroupIdMessagePrioritizationRulesValidation";
import { postAppSettingsAppGroupIdQuietHoursRules } from "./appSettingsAppGroupIdQuietHoursRules";
import { getAppSettingsAppGroupIdQuietHoursRulesData } from "./appSettingsAppGroupIdQuietHoursRulesData";
import { postAppSettingsAuthenticationCredentialCreate } from "./appSettingsAuthenticationCredentialCreate";
import { postAppSettingsAuthenticationCredentialDelete } from "./appSettingsAuthenticationCredentialDelete";
import { postAppSettingsAuthenticationCredentialEdit } from "./appSettingsAuthenticationCredentialEdit";
import { getAuthenticationCredentials } from "./appSettingsAuthenticationCredentials";
import { getAuthenticationCredentialUsages } from "./appSettingsAuthenticationCredentialsIdUsages";
import { postAppSettingsComputeCustomAttributeUsage } from "./appSettingsComputeCustomAttributeUsage";
import { postAppSettingsCreateApiKey } from "./appSettingsCreateApiKey";
import {
  patchAppSettingsCustomAttributeSchema,
  postAppSettingsCustomAttributeSchema,
} from "./appSettingsCustomAttributeSchema";
import { getAppSettingsCustomAttributeUsage } from "./appSettingsCustomAttributeUsage";
import { getDataTableAppSettingsCustomAttributesData } from "./appSettingsCustomAttributesData";
import { getAppSettingsCustomAttributesTags } from "./appSettingsCustomAttributesTags";
import { getCustomAttributesValues } from "./appSettingsCustomAttributesValues";
import { postAppSettingsCustomDataExport } from "./appSettingsCustomDataExport";
import { postAppSettingsCustomEventPropertySchema } from "./appSettingsCustomEventPropertySchema";
import { getAppSettingsCustomEventUsage } from "./appSettingsCustomEventUsage";
import { getDataTableAppSettingsCustomEventsData } from "./appSettingsCustomEventsData";
import { getAppSettingsCustomEventsTags } from "./appSettingsCustomEventsTags";
import { getAppSettingsGetCustomEventProperties } from "./appSettingsGetCustomEventProperties";
import { getAppSettingsGetTerritoriesWithFilters } from "./appSettingsGetTerritoriesWithFilters";
import {
  getAppSettingsInternalUserGroupsAnonymousUsers,
  putAppSettingsInternalUserGroupsAnonymousUsers,
} from "./appSettingsInternalUserGroupsAnonymousUsers";
import { postAppSettingsInternalUserGroupsBulkAddUsersToGroupV2AppGroupId } from "./appSettingsInternalUserGroupsBulkAddUsersToGroupV2AppGroupId";
import { postAppSettingsInternalUserGroupsDeleteInternalUserGroups } from "./appSettingsInternalUserGroupsDeleteInternalUserGroups";
import { postAppSettingsInternalUserGroupsExtractUsersFromIds } from "./appSettingsInternalUserGroupsExtractUsersFromIds";
import { getAppSettingsInternalUserGroupsInternalUserGroupId } from "./appSettingsInternalUserGroupsInternalUserGroupId";
import { getDataTableAppSettingsInternalUserGroupsInternalUserGroupIdV2TestUsers } from "./appSettingsInternalUserGroupsInternalUserGroupIdV2TestUsers";
import { postAppSettingsInternalUserGroupsInternalUserGroupUpsert } from "./appSettingsInternalUserGroupsInternalUserGroupUpsert";
import { postAppSettingsInternalUserGroupsRemoveTestUsersFromInternalUserGroup } from "./appSettingsInternalUserGroupsRemoveTestUsersFromInternalUserGroup";
import { patchAppSettingsInternalUserGroupsTestUser } from "./appSettingsInternalUserGroupsTestUser";
import { getAppSettingsInternalUserGroupsTestUserAppData } from "./appSettingsInternalUserGroupsTestUserAppData";
import { getDataTableAppSettingsMessageActivityMessages } from "./appSettingsMessageActivityMessages";
import { getAppSettingsObjectsUsingCustomAttributes } from "./appSettingsObjectsUsingCustomAttributes";
import { getAppSettingsObjectsUsingCustomEvents } from "./appSettingsObjectsUsingCustomEvents";
import { getAppSettingsObjectsUsingProducts } from "./appSettingsObjectsUsingProducts";
import { getDataTableAppSettingsProductsData } from "./appSettingsProductsData";
import { getAppSettingsSegmentablePropertyUsage } from "./appSettingsSegmentablePropertyUsage";
import { deleteAppSettingsTag } from "./appSettingsTagDelete";
import { upsertAppSettingsTag } from "./appSettingsTagUpsert";
import { getDataTableAppSettingsTagsData } from "./appSettingsTagsData";
import { dataTableAppSettingsTestUserLogs } from "./appSettingsTestUserLogs";
import { getAppSettingsTestUserLogsSearchTerms } from "./appSettingsTestUserLogsSearchTerms";
import { getDataTableAppSettingsV2InternalUserGroupsInternalUserGroups } from "./appSettingsV2InternalUserGroupsInternalUserGroups";
import { getAppsAggregatePushCredentialInfo } from "./appsAggregatePushCredentialInfo";
import { getAppsAndFiltersPreview } from "./appsAndFiltersPreview";
import { getAppsApiDashboardQuery } from "./appsApiDashboardQuery";
import { getDataTableAppsApiLimitsAppGroupRateLimitDatatableAppGroupId } from "./appsApiLimitsAppGroupRateLimitDatatableAppGroupId";
import { getDataTableAppsApiLimitsCompanyRateLimitDatatable } from "./appsApiLimitsCompanyRateLimitDatatable";
import { getDataTableAppsApiLimitsCompanySdkRateLimitDatatable } from "./appsApiLimitsCompanySdkRateLimitDatatable";
import { getDataTableAppsApiRequestLogRequests } from "./appsApiRequestLogRequests";
import { getApiUsageAlertDatatable } from "./appsApiUsageAlertDatatable";
import { getAppsAppGroup } from "./appsAppGroup";
import { postAppsAppGroupIdAnalyticsReportSetting } from "./appsAppGroupIdAnalyticsReportSetting";
import { getBotTrackingSettings, postBotTrackingSettings } from "./appsAppGroupIdBotTrackingSettings";
import { getAppsAppGroupIdChartsAttributeNames } from "./appsAppGroupIdChartsAttributeNames";
import { getAppsAppGroupIdChartsBanner } from "./appsAppGroupIdChartsBanner";
import { getChartsContentCards } from "./appsAppGroupIdChartsContentCards";
import { getAppsAppGroupIdChartsDailyPurchasesByPurchaseNames } from "./appsAppGroupIdChartsDailyPurchasesByPurchaseNames";
import { getAppsAppGroupIdChartsDailyRevenueByPurchaseNames } from "./appsAppGroupIdChartsDailyRevenueByPurchaseNames";
import { getAppsAppGroupIdChartsEmail } from "./appsAppGroupIdChartsEmail";
import { getAppsAppGroupIdChartsFormulaData } from "./appsAppGroupIdChartsFormulaData";
import { getAppGroupHasRevenue } from "./appsAppGroupIdChartsHasRevenue";
import { getAppsAppGroupIdChartsKakao } from "./appsAppGroupIdChartsKakao";
import { useLineChartsApiQuery } from "./appsAppGroupIdChartsLine";
import { getAppsAppGroupIdChartsPush } from "./appsAppGroupIdChartsPush";
import { getAppGroupRevenueLifetimeStats } from "./appsAppGroupIdChartsRevenueLifetimeStats";
import { getAppsAppGroupIdChartsRevenuePreviousWindow } from "./appsAppGroupIdChartsRevenuePreviousWindow";
import { postAppsAppGroupIdChartsSessions } from "./appsAppGroupIdChartsSessions";
import { getAppGroupSessionLifetimeStats } from "./appsAppGroupIdChartsSessionsLifetimeStats";
import { postAppsAppGroupIdChartsSessionsPreviousWindow } from "./appsAppGroupIdChartsSessionsPreviousWindow";
import { getAppsAppGroupIdChartsSms } from "./appsAppGroupIdChartsSms";
import { getAppsAppGroupIdChartsTriggerIam } from "./appsAppGroupIdChartsTriggerIam";
import { postAppsAppGroupIdChartsUninstall } from "./appsAppGroupIdChartsUninstall";
import { getAppsAppGroupIdChartsUsers } from "./appsAppGroupIdChartsUsers";
import { getAppsAppGroupIdChartsWebhook } from "./appsAppGroupIdChartsWebhook";
import { getAppsAppGroupIdChartsWhatsapp } from "./appsAppGroupIdChartsWhatsapp";
import {
  deleteAppsAppGroupIdCustomAttributesSettings,
  postAppsAppGroupIdCustomAttributesSettings,
} from "./appsAppGroupIdCustomAttributesSettings";
import { postAppsAppGroupIdCustomAttributesSettingsCreate } from "./appsAppGroupIdCustomAttributesSettingsCreate";
import {
  deleteAppsAppGroupIdCustomEventsSettings,
  postAppsAppGroupIdCustomEventsSettings,
} from "./appsAppGroupIdCustomEventsSettings";
import { postAppsAppGroupIdCustomEventsSettingsCreate } from "./appsAppGroupIdCustomEventsSettingsCreate";
import {
  getDragAndDropEditorSettings,
  postDragAndDropEditorSettings,
} from "./appsAppGroupIdEmailDraganddropSettings";
import { postEmailSettingsApiEndpoint } from "./appsAppGroupIdEmailSettings";
import {
  getUserDataEncryptionSettings,
  getGenerateExternalId,
  postUserDataEncryptionSettings,
} from "./appsAppGroupIdEncryptionSettings";
import { postAppsAppGroupIdEventPropertiesSettings } from "./appsAppGroupIdEventPropertiesSettings";
import { getAppsAppGroupIdMessagingRules, postAppsAppGroupIdMessagingRules } from "./appsAppGroupIdMessagingRules";
import {
  deleteAppsAppGroupIdProductsSettings,
  postAppsAppGroupIdProductsSettings,
} from "./appsAppGroupIdProductsSettings";
import { postAppsAppGroupIdProductsSettingsCreate } from "./appsAppGroupIdProductsSettingsCreate";
import { postAppsAppGroupIdPushSettings } from "./appsAppGroupIdPushSettings";
import { getAppSettingsApiEndpoint, postAppsAppGroupIdSettings } from "./appsAppGroupIdSettings";
import { postStopImportInProgress } from "./appsAppGroupIdStopImportInProgress";
import { getTeamSummary } from "./appsAppGroupIdTeamsTeamIdSummary";
import { postTeamCreate } from "./appsAppGroupIdTerritoryCreate";
import { postTeamEdit } from "./appsAppGroupIdTerritoryEdit";
import { getAppsAppGroupIdUninstallTrackingApps } from "./appsAppGroupIdUninstallTrackingApps";
import { getUserImportsDatatable } from "./appsAppGroupIdUserImportsDatatable";
import { postwsAppsAppGroupIdUserImportsImportIdValidate } from "./appsAppGroupIdUserImportsImportIdValidate";
import { getAppGroups, postWorkspaces } from "./appsAppGroups";
import { deleteAppsAppGroupsAppGroupId, postAppsAppGroupsAppGroupId } from "./appsAppGroupsAppGroupId";
import { postAppsAppGroupsAppGroupIdRename } from "./appsAppGroupsAppGroupIdRename";
import { getAppsAppGroupsUsingCatalogs } from "./appsAppGroupsUsingCatalogs";
import { getAppsAppGroupsWithPermission } from "./appsAppGroupsWithPermission";
import { deleteAppsAppId } from "./appsAppId";
import { getAppsAppIdFirebaseCredential, postAppsAppIdFirebaseCredential } from "./appsAppIdFirebaseCredential";
import {
  deleteAppsAppIdPushCredential,
  getAppsAppIdPushCredential,
  postAppsAppIdPushCredential,
} from "./appsAppIdPushCredential";
import { postAppsAppIdPushCredentialTest } from "./appsAppIdPushCredentialTest";
import { getAppsAppIdSdkAuthenticationAnalytics } from "./appsAppIdSdkAuthenticationAnalytics";
import {
  getAppsAppIdSdkAuthenticationSettings,
  putAppsAppIdSdkAuthenticationSettings,
} from "./appsAppIdSdkAuthenticationSettings";
import { postAppsAppIdUploadPushCertificate } from "./appsAppIdUploadPushCertificate";
import { getAppsBusinessSources } from "./appsBusinessSources";
import { getAppsBusinessUsage } from "./appsBusinessUsage";
import { postAppsBusinessUsers } from "./appsBusinessUsers";
import { getAppsCatalogFields } from "./appsCatalogFields";
import { getDataTableAppsCatalogFilteredSetItemsDatatable } from "./appsCatalogFilteredSetItemsDatatable";
import { getAppsCatalogFilteredSets } from "./appsCatalogFilteredSets";
import { getDataTableAppsCatalogFilteredSetsListDatatable } from "./appsCatalogFilteredSetsListDatatable";
import { getAppsCatalogItems } from "./appsCatalogItems";
import { getDataTableAppsCatalogItemsDatatable } from "./appsCatalogItemsDatatable";
import { getDataTableAppsCatalogSubscriptionsListDatatable } from "./appsCatalogSubscriptionsListDatatable";
import { getAppsCatalogs, postAppsCatalogs } from "./appsCatalogs";
import { deleteAppsCatalogsCatalogId, getAppsCatalogsCatalogId } from "./appsCatalogsCatalogId";
import { postAppsCatalogsCatalogIdExport } from "./appsCatalogsCatalogIdExport";
import { postAppsCatalogsCatalogIdFilteredSets } from "./appsCatalogsCatalogIdFilteredSets";
import {
  getAppsCatalogsCatalogIdFilteredSetsFilteredSetName,
  patchAppsCatalogsCatalogIdFilteredSetsFilteredSetName,
} from "./appsCatalogsCatalogIdFilteredSetsFilteredSetName";
import { postAppsCatalogsCatalogIdItemsItemIdRefreshAgenticField } from "./appsCatalogsCatalogIdItemsItemIdRefreshAgenticField";
import { deleteAppsCatalogsCatalogIdSubscriptionsDeleteAll } from "./appsCatalogsCatalogIdSubscriptionsDeleteAll";
import { getDataTableAppsCatalogsDatatable } from "./appsCatalogsDatatable";
import { getAppsCatalogsUsage } from "./appsCatalogsUsage";
import { postAppsEngagementReportsCampaignsByTags } from "./appsEngagementReportsCampaignsByTags";
import { postAppsEngagementReportsCanvasesByTags } from "./appsEngagementReportsCanvasesByTags";
import {
  postAppsEngagementReportsEngagementReport,
  putAppsEngagementReportsEngagementReport,
} from "./appsEngagementReportsEngagementReport";
import { getAppsEngagementReportsEngagementReportData } from "./appsEngagementReportsEngagementReportData";
import { getDataTableAppsEngagementReportsEngagementReportsData } from "./appsEngagementReportsEngagementReportsData";
import { getAppsEngagementReportsTags } from "./appsEngagementReportsTags";
import { postAppsEngagementReportsUpdateArchivedState } from "./appsEngagementReportsUpdateArchivedState";
import { putAppsEngagementReportsUpdateTags } from "./appsEngagementReportsUpdateTags";
import { getAppsGetDefaultCustomPagesAppGroupId } from "./appsGetDefaultCustomPagesAppGroupId";
import {
  getMessageArchivingSettingsApiEndpoint,
  postMessageArchivingSettingsApiEndpoint,
} from "./appsMessageArchivingSettings";
import { postAppsMultiLanguageSettingsAddLocale } from "./appsMultiLanguageSettingsAddLocale";
import { deleteAppsMultiLanguageSettingsDeleteLocaleLocaleId } from "./appsMultiLanguageSettingsDeleteLocaleLocaleId";
import { postAppsMultiLanguageSettingsDownloadTranslationTemplate } from "./appsMultiLanguageSettingsDownloadTranslationTemplate";
import { getAppsMultiLanguageSettingsLocales } from "./appsMultiLanguageSettingsGetLocales";
import { deleteAppsMultiLanguageSettingsRemoveTranslations } from "./appsMultiLanguageSettingsRemoveTranslations";
import { putAppsMultiLanguageSettingsUpdateLocale } from "./appsMultiLanguageSettingsUpdateLocale";
import { postAppsMultiLanguageSettingsUploadTranslations } from "./appsMultiLanguageSettingsUploadTranslations";
import { getAppsMultiLanguageSettingsValidateTranslationUsage } from "./appsMultiLanguageSettingsValidateTranslationUsage";
import { postTeamsArchivedState } from "./appsTeamsUpdateArchivedState";
import { getTransformationLogsDatatable } from "./appsTransformationLogsDatatable";
import { getDataTableAppsTransformationTemplates } from "./appsTransformationTemplatesDatatable";
import { getTransformationsDatatable } from "./appsTransformationsDatatable";
import { postAppsUploadMessage } from "./appsUploadMessage";
import {
  getUserInfoAnyUsers,
  getUserInfoByIdentifier,
  getUserInfoCampaignsByIdentifier,
  getCustomObjectsLinkedToUser,
  getCustomObjectsNotLinkedToUser,
  getCustomObjectsPreviewCalculatedFilters,
  postCustomObjectsBatchLinkUser,
  getUserInfoSegmentsByIdentifier,
  getUserInfosByIdentifier,
  pushTokenStatus,
  deleteCustomObjectsUserRelationship,
  patchCustomObjectsUserRelationship,
  putUserInfoUpdateSubscriptionGroupStatus,
  putUserInfoUpdateSubscriptionStatus,
} from "./appsUserInfo";
import { postAppsUserInfoCancelUserDeletion } from "./appsUserInfoCancelUserDeletion";
import { postAppsUserInfoConfirmUserDeletion } from "./appsUserInfoConfirmUserDeletion";
import { deleteAppsUserInfoDeleteUsersFromSegment } from "./appsUserInfoDeleteUsersFromSegment";
import { getAppsUserInfoDeleteUsersRunning } from "./appsUserInfoDeleteUsersRunning";
import { getAppsUserInfoGetClickThroughTrackingConfig } from "./appsUserInfoGetClickThroughTrackingConfig";
import { getDataTableAppsUserInfoMergeDuplicateUsersRecordDatatable } from "./appsUserInfoMergeDuplicateUsersRecordDatatable";
import { getAppsUserInfoMergeDuplicateUsersRules } from "./appsUserInfoMergeDuplicateUsersRules";
import { getAppsUserInfoMergeDuplicateUsersRunning } from "./appsUserInfoMergeDuplicateUsersRunning";
import { postAppsUserInfoMergeUsers } from "./appsUserInfoMergeUsers";
import { getAppsUserInfoScheduledMergeDuplicateUsersRules } from "./appsUserInfoScheduledMergeDuplicateUsersRules";
import { patchAppsUserInfoUpdateClickThroughTrackingConfig } from "./appsUserInfoUpdateClickThroughTrackingConfig";
import { patchAppsUserInfoUpdateMergeDuplicateUsersRules } from "./appsUserInfoUpdateMergeDuplicateUsersRules";
import { patchAppsUserInfoUpdateScheduledMergeDuplicateUsersRules } from "./appsUserInfoUpdateScheduledMergeDuplicateUsersRules";
import { getDataTableAppsUserInfoUserDeletionRecordDatatable } from "./appsUserInfoUserDeletionRecordDatatable";
import { postAppsUserInfoUserIdentifierCancelSingleUserDeletion } from "./appsUserInfoUserIdentifierCancelSingleUserDeletion";
import { putAppsUserInfoUserIdentifierChangeEmail } from "./appsUserInfoUserIdentifierChangeEmail";
import { deleteAppsUserInfoUserIdentifierDeleteUser } from "./appsUserInfoUserIdentifierDeleteUser";
import { getDataTableAudienceSyncConsumption } from "./audienceSyncConsumption";
import { postBannersDismiss } from "./bannersDismiss";
import { deleteCampaignBrief, getCampaignBrief, putCampaignBrief } from "./campaignBrief";
import { getCampaignOccurrences } from "./campaignOccurrences";
import { deleteCampaignQaRun, getCampaignQaRun, putCampaignQaRun } from "./campaignQaRuns";
import { getCampaignsData, postCampaign, postCampaignCopy } from "./campaigns";
import { getCampaignAggregateStats } from "./campaignsAggregateStats";
import { postCanvasCopy } from "./canvas";
import { deleteCanvasBrief, getCanvasBrief, putCanvasBrief } from "./canvasBrief";
import { getCanvasChangelogs } from "./canvasChangelogs";
import { deleteCanvasQaRun, getCanvasQaRun, putCanvasQaRun } from "./canvasQaRuns";
import { getChangelogs } from "./changelogs";
import { getChannelDashboardData } from "./channelDashboardData";
import { getDataTableCjCredentials } from "./cjCredentials";
import {
  createComment,
  createCommentThread,
  deleteComment,
  deleteCommentThread,
  editComment,
  getCommentThreads,
  reopenCommentThread,
  resolveCommentThread,
} from "./comments";
import { putCommentsTargetGlobalNotificationSetting } from "./commentsTargetGlobalNotificationSetting";
import {
  getCommentsNotificationSetting,
  putCommentsNotificationSetting,
} from "./commentsTargetNotificationSetting";
import { getCompanyAiSettings } from "./companiesCompanyIdAiSettings";
import { putCompanyAllDataAiTrainingOptOut } from "./companiesCompanyIdAllDataAiTrainingOptOut";
import { putCompanyAnonymousAggregatedAiTrainingOptOut } from "./companiesCompanyIdAnonymousAggregatedAiTrainingOptOut";
import { getCompaniesCompanyIdAppGroupPermissionSetsAllPermissionSets } from "./companiesCompanyIdAppGroupPermissionSetsAllPermissionSets";
import { postCompaniesCompanyIdAppGroupPermissionSetsCreatePermissionSet } from "./companiesCompanyIdAppGroupPermissionSetsCreatePermissionSet";
import { deleteCompaniesCompanyIdAppGroupPermissionSetsDeletePermissionSetId } from "./companiesCompanyIdAppGroupPermissionSetsDeletePermissionSetId";
import { postCompaniesCompanyIdAppGroupPermissionSetsDuplicatePermissionSet } from "./companiesCompanyIdAppGroupPermissionSetsDuplicatePermissionSet";
import { getCompaniesCompanyIdAppGroupPermissionSetsPermissionSetId } from "./companiesCompanyIdAppGroupPermissionSetsPermissionSetId";
import { putCompaniesCompanyIdAppGroupPermissionSetsUpdatePermissionSet } from "./companiesCompanyIdAppGroupPermissionSetsUpdatePermissionSet";
import { getCompaniesCompanyIdAppGroups } from "./companiesCompanyIdAppGroups";
import { getCompanyRateLimits } from "./companiesCompanyIdCompanyRateLimits";
import { postCompaniesCompanyIdCustomDomains } from "./companiesCompanyIdCustomDomains";
import {
  deleteCompaniesCompanyIdCustomDomainsAppLinkingAssignment,
  putCompaniesCompanyIdCustomDomainsAppLinkingAssignments,
} from "./companiesCompanyIdCustomDomainsAppLinkingAssignments";
import {
  deleteCompaniesCompanyIdCustomDomainsDomainTypeDomainId,
  getCompaniesCompanyIdCustomDomainsDomainTypeDomainId,
} from "./companiesCompanyIdCustomDomainsDomainTypeDomainId";
import { postCompaniesCompanyIdCustomDomainsDomainTypeDomainIdMigration } from "./companiesCompanyIdCustomDomainsDomainTypeDomainIdMigration";
import { getCompaniesCompanyIdCustomDomainsDomainTypeDomainIdSubscriptionGroups } from "./companiesCompanyIdCustomDomainsDomainTypeDomainIdSubscriptionGroups";
import { postCompaniesCompanyIdCustomRolesCreateCustomRole } from "./companiesCompanyIdCustomRolesCreateCustomRole";
import { getCompaniesCompanyIdCustomRolesCustomRoleId } from "./companiesCompanyIdCustomRolesCustomRoleId";
import { getCompaniesCompanyIdCustomRolesCustomRoleManagementData } from "./companiesCompanyIdCustomRolesCustomRoleManagementData";
import { deleteCompaniesCompanyIdCustomRolesDeleteCustomRoleId } from "./companiesCompanyIdCustomRolesDeleteCustomRoleId";
import { postCompaniesCompanyIdCustomRolesDuplicateCustomRole } from "./companiesCompanyIdCustomRolesDuplicateCustomRole";
import { putCompaniesCompanyIdCustomRolesUpdateCustomRoleId } from "./companiesCompanyIdCustomRolesUpdateCustomRoleId";
import { postCompaniesCompanyIdDevelopers } from "./companiesCompanyIdDevelopers";
import { postDevelopersCsvExport } from "./companiesCompanyIdDevelopersCsvExport";
import { getCompaniesCompanyIdDevelopersCurrentPrefCenterUrl } from "./companiesCompanyIdDevelopersCurrentPrefCenterUrl";
import {
  deleteCompaniesCompanyIdDevelopersDeveloperId,
  getCompaniesCompanyIdDevelopersDeveloperId,
  putCompaniesCompanyIdDevelopersDeveloperId,
} from "./companiesCompanyIdDevelopersDeveloperId";
import { putCompaniesCompanyIdDevelopersDeveloperIdDeveloperClearTwoFactorAuth } from "./companiesCompanyIdDevelopersDeveloperIdDeveloperClearTwoFactorAuth";
import { postCompaniesCompanyIdDevelopersDeveloperIdDeveloperResendConfirmation } from "./companiesCompanyIdDevelopersDeveloperIdDeveloperResendConfirmation";
import { postDeveloperSuspend } from "./companiesCompanyIdDevelopersDeveloperIdSuspend";
import { postDeveloperUnsuspend } from "./companiesCompanyIdDevelopersDeveloperIdUnsuspend";
import { getCompaniesCompanyIdDevelopersPermissionStructures } from "./companiesCompanyIdDevelopersPermissionStructures";
import { getDevelopersTable } from "./companiesCompanyIdDevelopersTable";
import { getConfigurationData } from "./companiesCompanyIdEmailSelfServeConfigurationData";
import { postCompaniesCompanyIdEmailSelfServeIpAddresses } from "./companiesCompanyIdEmailSelfServeIpAddresses";
import { postCompaniesCompanyIdEmailSelfServeIpPool } from "./companiesCompanyIdEmailSelfServeIpPool";
import { postCompaniesCompanyIdEmailSelfServeIpPools } from "./companiesCompanyIdEmailSelfServeIpPools";
import { postProvisionSesAccount } from "./companiesCompanyIdEmailSelfServeProvision";
import { deleteSendingDomain, patchSendingDomain } from "./companiesCompanyIdEmailSelfServeSendingDomainDomainId";
import { postAssignExistingTrackingDomain } from "./companiesCompanyIdEmailSelfServeSendingDomainDomainIdAssignExistingTrackingDomain";
import { postPartnerTrackingDomain } from "./companiesCompanyIdEmailSelfServeSendingDomainDomainIdPartnerTrackingDomain";
import { postTrackingDomain } from "./companiesCompanyIdEmailSelfServeSendingDomainDomainIdTrackingDomain";
import { postSendingDomain } from "./companiesCompanyIdEmailSelfServeSendingDomains";
import { putCompanyFeatureStatuses } from "./companiesCompanyIdFeatureManagementSetFeatureStatus";
import { postFreeTrialDeveloper } from "./companiesCompanyIdFreeTrialDevelopers";
import {
  deleteFreeTrialDeveloper,
  getFreeTrialDeveloper,
  putFreeTrialDeveloper,
} from "./companiesCompanyIdFreeTrialDevelopersDeveloperId";
import { getFreeTrialDevelopersTable } from "./companiesCompanyIdFreeTrialDevelopersTable";
import { putCompanyGenerativeAiOptOut } from "./companiesCompanyIdGenerativeAiOptOut";
import { getDataTableCompaniesCompanyIdMobileAppLinkingAssignableTrackingDomains } from "./companiesCompanyIdMobileAppLinkingAssignableTrackingDomains";
import {
  getCompaniesCompanyIdMobileAppLinkingConfigs,
  postCompaniesCompanyIdMobileAppLinkingConfigs,
} from "./companiesCompanyIdMobileAppLinkingConfigs";
import {
  deleteCompaniesCompanyIdMobileAppLinkingConfigsId,
  getCompaniesCompanyIdMobileAppLinkingConfigsId,
  patchCompaniesCompanyIdMobileAppLinkingConfigsId,
} from "./companiesCompanyIdMobileAppLinkingConfigsId";
import { putCompaniesCompanyIdNotificationPreferencesBulkAdd } from "./companiesCompanyIdNotificationPreferencesBulkAdd";
import { putCompaniesCompanyIdNotificationPreferencesUpdate } from "./companiesCompanyIdNotificationPreferencesUpdate";
import { getCompaniesCompanyIdOauthMcpSettings } from "./companiesCompanyIdOauthMcpSettings";
import { getCompaniesCompanyIdOauthMcpSettingsMarketplaceClients } from "./companiesCompanyIdOauthMcpSettingsMarketplaceClients";
import { putCompaniesCompanyIdOauthMcpSettingsMarketplaceClientsKey } from "./companiesCompanyIdOauthMcpSettingsMarketplaceClientsKey";
import { putCompaniesCompanyIdOauthMcpSettingsMcpEnabled } from "./companiesCompanyIdOauthMcpSettingsMcpEnabled";
import { putCompaniesCompanyIdOauthMcpSettingsPartnerAppsEnabled } from "./companiesCompanyIdOauthMcpSettingsPartnerAppsEnabled";
import { getCompaniesCompanyIdOauthMcpSettingsPartnerPolicies } from "./companiesCompanyIdOauthMcpSettingsPartnerPolicies";
import { putCompaniesCompanyIdOauthMcpSettingsRedirectUris } from "./companiesCompanyIdOauthMcpSettingsRedirectUris";
import { getMcpTokenRevocation, postMcpTokenRevocation } from "./companiesCompanyIdOauthMcpSettingsRevocations";
import { getCompanySecurityEventConfig } from "./companiesCompanyIdSecuritySettingsSecurityEventConfig";
import { postCompanySecurityEventConfigTest } from "./companiesCompanyIdSecuritySettingsSecurityEventConfigTest";
import { getSenderVerificationEligibility } from "./companiesCompanyIdSenderVerificationEligibility";
import {
  getCompaniesCompanyIdSenderVerificationIpAddresses,
  postCompaniesCompanyIdSenderVerificationIpAddresses,
} from "./companiesCompanyIdSenderVerificationIpAddresses";
import {
  getCompaniesCompanyIdSenderVerificationSendingDomains,
  postCompaniesCompanyIdSenderVerificationSendingDomains,
} from "./companiesCompanyIdSenderVerificationSendingDomains";
import { putCompaniesCompanyIdSenderVerificationSendingDomainsVerify } from "./companiesCompanyIdSenderVerificationSendingDomainsVerify";
import { postCompaniesCompanyIdSenderVerificationSetupRdns } from "./companiesCompanyIdSenderVerificationSetupRdns";
import { postCompaniesCompanyIdSenderVerificationSubuser } from "./companiesCompanyIdSenderVerificationSubuser";
import {
  getCompaniesCompanyIdSenderVerificationTrackingDomains,
  postCompaniesCompanyIdSenderVerificationTrackingDomains,
} from "./companiesCompanyIdSenderVerificationTrackingDomains";
import { putCompaniesCompanyIdSenderVerificationTrackingDomainsVerify } from "./companiesCompanyIdSenderVerificationTrackingDomainsVerify";
import {
  getCompaniesCompanyIdVerifiedDomains,
  postCompaniesCompanyIdVerifiedDomains,
} from "./companiesCompanyIdVerifiedDomains";
import {
  deleteCompaniesCompanyIdVerifiedDomainsId,
  getCompaniesCompanyIdVerifiedDomainsId,
} from "./companiesCompanyIdVerifiedDomainsId";
import { getDataTableCompaniesWorkspaceRateLimitsDataTable } from "./companiesWorkspaceRateLimitsDataTable";
import { deleteCompaniesWorkspaceRateLimitsDelete } from "./companiesWorkspaceRateLimitsDelete";
import { postCompaniesWorkspaceRateLimitsUpsert } from "./companiesWorkspaceRateLimitsUpsert";
import { getCompaniesWorkspaceTimezones } from "./companiesWorkspaceTimezones";
import {
  getCompanyContactInformation,
  getCompanyLinkShorteningDomains,
  getCompanyNotificationPreferences,
  getCompanySecuritySettings,
  getCompanySettings,
  getCompanyTimezoneOptions,
  putCompanyContactInformation,
} from "./company";
import { getCompanySettingsDataPointUsage } from "./companySettingsDataPointUsage";
import { getDataTableCompanySettingsMostUsedEventsAndAttributesByAppsAndAppGroups } from "./companySettingsMostUsedEventsAndAttributesByAppsAndAppGroups";
import { postCompanySettingsMostUsedEventsAndAttributesByAppsAndAppGroupsExport } from "./companySettingsMostUsedEventsAndAttributesByAppsAndAppGroupsExport";
import { getCompanySettingsSubscriptionsAndUsage } from "./companySettingsSubscriptionsAndUsage";
import { postwsCortexAgentRunQuery } from "./cortexAgentRunQuery";
import { getCustomEventNames } from "./customEventNames";
import { postCustomObjectsEnableAccounts } from "./customObjectsEnableAccounts";
import { getDataTableCustomObjectsImportStagingRecords } from "./customObjectsImportStagingRecords";
import { getCustomObjectsOnboardingStatus } from "./customObjectsOnboardingStatus";
import { postCustomObjectsTypeName } from "./customObjectsTypeName";
import { getCustomObjectsTypeNameObjectId } from "./customObjectsTypeNameObjectId";
import { postAsyncRequestManagerCancelRequest } from "./dashboardAsyncRequestManagerCancelRequest";
import { getAsyncRequestManagerFindRequest } from "./dashboardAsyncRequestManagerFindRequest";
import { getAsyncRequestManagerRequests } from "./dashboardAsyncRequestManagerListRequests";
import { getDashboardConversionAttributionDashboardAppGroupIdCampaignCanvasMetadata } from "./dashboardConversionAttributionDashboardAppGroupIdCampaignCanvasMetadata";
import { getDatashares } from "./datashares";
import {
  getDataTableDecisioningStudioAgentsAppGroupId,
  postDecisioningStudioAgentsAppGroupId,
} from "./decisioningStudioAgentsAppGroupId";
import { getDecisioningStudioAgentsAppGroupIdDsaIdAgentPreferences } from "./decisioningStudioAgentsAppGroupIdDsaIdAgentPreferences";
import { getDecisioningStudioAgentsAppGroupIdDsaIdAudiences } from "./decisioningStudioAgentsAppGroupIdDsaIdAudiences";
import {
  getDecisioningStudioAgentsAppGroupIdDsaIdAudienceDistribution,
  putDecisioningStudioAgentsAppGroupIdDsaIdAudienceDistribution,
} from "./decisioningStudioAgentsAppGroupIdDsaIdAudiencesDistribution";
import { getDecisioningStudioAgentsAppGroupIdDsaIdAudiencesGetAgentIsPersonalizing } from "./decisioningStudioAgentsAppGroupIdDsaIdAudiencesGetAgentIsPersonalizing";
import {
  getDecisioningStudioAgentsAppGroupIdDsaIdSegments,
  putDecisioningStudioAgentsAppGroupIdDsaIdSegments,
} from "./decisioningStudioAgentsAppGroupIdDsaIdAudiencesSegments";
import { getDataTableDecisioningStudioAgentsAppGroupIdDsaIdBaseCreatives } from "./decisioningStudioAgentsAppGroupIdDsaIdBaseCreatives";
import { getDecisioningStudioAgentsAppGroupIdDsaIdBaseCreativesCampaignIdVariants } from "./decisioningStudioAgentsAppGroupIdDsaIdBaseCreativesCampaignIdVariants";
import { postDecisioningStudioAgentsAppGroupIdDsaIdCampaigns } from "./decisioningStudioAgentsAppGroupIdDsaIdCampaigns";
import { getDataTableDecisioningStudioAgentsAppGroupIdDsaIdConstraints } from "./decisioningStudioAgentsAppGroupIdDsaIdConstraints";
import {
  deleteDecisioningStudioAgentsAppGroupIdDsaIdConstraintsComponent,
  getDecisioningStudioAgentsAppGroupIdDsaIdConstraintsComponent,
  postDecisioningStudioAgentsAppGroupIdDsaIdConstraintsComponent,
  putDecisioningStudioAgentsAppGroupIdDsaIdConstraintsComponent,
} from "./decisioningStudioAgentsAppGroupIdDsaIdConstraintsComponent";
import { getDecisioningStudioAgentsAppGroupIdDsaIdConversionEvents } from "./decisioningStudioAgentsAppGroupIdDsaIdConversionEvents";
import { getDecisioningStudioAgentsAppGroupIdDsaIdCreativeComponents } from "./decisioningStudioAgentsAppGroupIdDsaIdCreativeComponents";
import { getDecisioningStudioAgentsAppGroupIdDsaIdCreativeComponentsComponentBaseCreatives } from "./decisioningStudioAgentsAppGroupIdDsaIdCreativeComponentsComponentBaseCreatives";
import { getDataTableDecisioningStudioAgentsAppGroupIdDsaIdCreativeComponentsComponentVariants } from "./decisioningStudioAgentsAppGroupIdDsaIdCreativeComponentsComponentVariants";
import { postDecisioningStudioAgentsAppGroupIdDsaIdCreativeComponentsComponentVariants } from "./decisioningStudioAgentsAppGroupIdDsaIdCreativeComponentsComponentVariants";
import {
  deleteDecisioningStudioAgentsAppGroupIdDsaIdCreativeComponentsComponentVariantsVariantId,
  putDecisioningStudioAgentsAppGroupIdDsaIdCreativeComponentsComponentVariantsVariantId,
} from "./decisioningStudioAgentsAppGroupIdDsaIdCreativeComponentsComponentVariantsVariantId";
import { getDecisioningStudioAgentsAppGroupIdDsaIdDetails } from "./decisioningStudioAgentsAppGroupIdDsaIdDetails";
import { putDecisioningStudioAgentsAppGroupIdDsaIdDetails } from "./decisioningStudioAgentsAppGroupIdDsaIdDetails";
import { getDecisioningStudioAgentsAppGroupIdDsaIdDimensions } from "./decisioningStudioAgentsAppGroupIdDsaIdDimensions";
import { getDecisioningStudioAgentsAppGroupIdDsaIdDimensionsDimension } from "./decisioningStudioAgentsAppGroupIdDsaIdDimensionsDimension";
import {
  getDataTableDecisioningStudioAgentsAppGroupIdDsaIdDimensionsDimensionActions,
  patchDecisioningStudioAgentsAppGroupIdDsaIdDimensionsDimensionActions,
  postDecisioningStudioAgentsAppGroupIdDsaIdDimensionsDimensionActions,
} from "./decisioningStudioAgentsAppGroupIdDsaIdDimensionsDimensionActions";
import {
  getDecisioningStudioAgentsAppGroupIdDsaIdDimensionsDimensionActionsActionId,
  patchDecisioningStudioAgentsAppGroupIdDsaIdDimensionsDimensionActionsActionId,
} from "./decisioningStudioAgentsAppGroupIdDsaIdDimensionsDimensionActionsActionId";
import { getDecisioningStudioLiftDecomposition } from "./decisioningStudioAgentsAppGroupIdDsaIdInsightsLiftDecomposition";
import { getPersonalizationExplainerAvailableDimensions } from "./decisioningStudioAgentsAppGroupIdDsaIdInsightsPersonalizationExplainerAvailableDimensions";
import { getDecisioningStudioAgentsAppGroupIdDsaIdInsightsPersonalizationExplainerDimensionActions } from "./decisioningStudioAgentsAppGroupIdDsaIdInsightsPersonalizationExplainerDimensionActions";
import { getDecisioningStudioAgentsAppGroupIdDsaIdInsightsPersonalizationExplainerDimensionUplift } from "./decisioningStudioAgentsAppGroupIdDsaIdInsightsPersonalizationExplainerDimensionUplift";
import { getDecisioningStudioAgentsAppGroupIdDsaIdFirstRecommendationRun } from "./decisioningStudioAgentsAppGroupIdDsaIdFirstRecommendationRun";
import { postDecisioningStudioAgentsAppGroupIdDsaIdLaunch } from "./decisioningStudioAgentsAppGroupIdDsaIdLaunch";
import { getDecisioningStudioAgentsAppGroupIdDsaIdLaunchValidation } from "./decisioningStudioAgentsAppGroupIdDsaIdLaunchValidation";
import { getDecisioningStudioAgentsAppGroupIdDsaIdPerformanceReportData } from "./decisioningStudioAgentsAppGroupIdDsaIdPerformanceReportData";
import { getDecisioningStudioAgentsAppGroupIdDsaIdPerformanceReportSettings } from "./decisioningStudioAgentsAppGroupIdDsaIdPerformanceReportSettings";
import { postDecisioningStudioAgentsAppGroupIdDsaIdResume } from "./decisioningStudioAgentsAppGroupIdDsaIdResume";
import {
  getDecisioningStudioAgentsAppGroupIdDsaIdSchedule,
  putDecisioningStudioAgentsAppGroupIdDsaIdSchedule,
} from "./decisioningStudioAgentsAppGroupIdDsaIdSchedule";
import { getDecisioningStudioAgentsAppGroupIdDsaIdSourceCanvases } from "./decisioningStudioAgentsAppGroupIdDsaIdSourceCanvases";
import { postDecisioningStudioAgentsAppGroupIdDsaIdStop } from "./decisioningStudioAgentsAppGroupIdDsaIdStop";
import { getDecisioningStudioAgentsAppGroupIdDsaIdTiming } from "./decisioningStudioAgentsAppGroupIdDsaIdTiming";
import {
  getDecisioningStudioAgentsAppGroupIdDsaIdTimingQuietHours,
  putDecisioningStudioAgentsAppGroupIdDsaIdTimingQuietHours,
} from "./decisioningStudioAgentsAppGroupIdDsaIdTimingQuietHours";
import { postDecisioningStudioAgentsAppGroupIdDsaIdWorkflows } from "./decisioningStudioAgentsAppGroupIdDsaIdWorkflows";
import {
  getDecisioningStudioAgentsAppGroupIdId,
  putDecisioningStudioAgentsAppGroupIdId,
} from "./decisioningStudioAgentsAppGroupIdId";
import { putDecisioningStudioAgentsBaseCreativeRename } from "./decisioningStudioAgentsBaseCreativeRename";
import {
  deleteDecisioningStudioAgentsBaseCreative,
  postDecisioningStudioAgentsBaseCreative,
  putDecisioningStudioAgentsBaseCreative,
} from "./decisioningStudioAgentsBaseCreatives";
import { getDataTableDecisioningStudioAgentsConsumption } from "./decisioningStudioAgentsConsumption";
import { getDeliverabilityEmailAppGroupIdData } from "./deliverabilityEmailAppGroupIdData";
import { getDeliverabilityEmailAppGroupIdFilters } from "./deliverabilityEmailAppGroupIdFilters";
import { getDeliverabilityPostmasterAppGroupIdComplianceStatus } from "./deliverabilityPostmasterAppGroupIdComplianceStatus";
import { getDataTableDeliverabilityPostmasterAppGroupIdDeliveryErrors } from "./deliverabilityPostmasterAppGroupIdDeliveryErrors";
import { getDataTableDeliverabilityPostmasterAppGroupIdDomainReputation } from "./deliverabilityPostmasterAppGroupIdDomainReputation";
import { getDeliverabilityPostmasterAppGroupIdDomains } from "./deliverabilityPostmasterAppGroupIdDomains";
import { getDataTableDeliverabilityPostmasterAppGroupIdIpReputation } from "./deliverabilityPostmasterAppGroupIdIpReputation";
import { getDeliverabilityPostmasterAppGroupIdIps } from "./deliverabilityPostmasterAppGroupIdIps";
import { getDeliverabilityPostmasterLatestEvent } from "./deliverabilityPostmasterAppGroupIdLatestEvent";
import { getDeliverabilitySndsAppGroupIdIps } from "./deliverabilitySndsAppGroupIdIps";
import { getDeliverabilitySndsLatestEvent } from "./deliverabilitySndsAppGroupIdLatestEvent";
import { getDataTableDeliverabilitySndsAppGroupIdSndsData } from "./deliverabilitySndsAppGroupIdSndsData";
import { deleteDeltashares, getDeltashares, postDeltashares, putDeltashares } from "./deltashares";
import {
  disableMultiFactorAuth,
  getDeveloper,
  getNotificationSubscriptions,
  getSparseDevelopers,
  putDeveloper,
} from "./developer";
import { getDustConfig } from "./dustConfig";
import { getDataTableEmailConsumption } from "./emailConsumption";
import { getEmailIpWarmingCampaignStats } from "./emailIpWarmingAppGroupIdCampaignStats";
import { postEmailIpWarmingDelete } from "./emailIpWarmingAppGroupIdDelete";
import { postEmailIpWarmingAppGroupIdEngagementDataBeginUpload } from "./emailIpWarmingAppGroupIdEngagementDataBeginUpload";
import { postEmailIpWarmingAppGroupIdEngagementDataChunk } from "./emailIpWarmingAppGroupIdEngagementDataChunk";
import { postEmailIpWarmingAppGroupIdEngagementDataRegister } from "./emailIpWarmingAppGroupIdEngagementDataRegister";
import { getEmailIpWarmingAppGroupIdIpCount } from "./emailIpWarmingAppGroupIdIpCount";
import { postEmailIpWarmingLaunch } from "./emailIpWarmingAppGroupIdLaunch";
import { getEmailIpWarmingAppGroupIdPlan } from "./emailIpWarmingAppGroupIdPlan";
import { getEmailIpWarmingAppGroupIdPlanNameAvailable } from "./emailIpWarmingAppGroupIdPlanNameAvailable";
import { getDataTableEmailIpWarmingAppGroupIdPlans } from "./emailIpWarmingAppGroupIdPlans";
import { getEmailIpWarmingAppGroupIdRequiredEmailTemplates } from "./emailIpWarmingAppGroupIdRequiredEmailTemplates";
import { getEmailIpWarmingAppGroupIdSchedule } from "./emailIpWarmingAppGroupIdSchedule";
import { postEmailIpWarmingAppGroupIdScheduleSettings } from "./emailIpWarmingAppGroupIdScheduleSettings";
import { getEmailIpWarmingAppGroupIdShowIpWarmingWidget } from "./emailIpWarmingAppGroupIdShowIpWarmingWidget";
import { postEmailIpWarmingStop } from "./emailIpWarmingAppGroupIdStop";
import { getSubscriptionGroups } from "./emailSubscriptionGroups";
import { getEngagementAbTestingScheduleData } from "./engagementAbTestingScheduleData";
import { getAllCards } from "./engagementAllCards";
import {
  getAndroidNotificationChannels,
  updateAndroidNotificationChannels,
} from "./engagementAndroidNotificationChannels";
import {
  createSegmentCohort,
  getSegmentCohort,
  getSegmentCohorts,
  patchSegmentCohort,
} from "./engagementApiSegmentCohorts";
import { getEngagementApiSegmentCohortsBillingHistory } from "./engagementApiSegmentCohortsBillingHistory";
import { getSegmentCohortEngagements } from "./engagementApiSegmentCohortsIdEngagements";
import { segmentCohortsPreviewSql, segmentCohortsPreviewSqlResults } from "./engagementApiSegmentCohortsPreviewSql";
import { getEngagementApiSegmentCohortsTags } from "./engagementApiSegmentCohortsTags";
import { getEngagementApiSuppressionLists } from "./engagementApiSuppressionLists";
import { getEngagementApiSuppressionListsId } from "./engagementApiSuppressionListsId";
import { getEngagementApiSuppressionListsSettings } from "./engagementApiSuppressionListsSettings";
import {
  getDataTableEngagementAppGroupIdBannerTemplates,
  postEngagementAppGroupIdBannerTemplates,
} from "./engagementAppGroupIdBannerTemplates";
import { postEngagementAppGroupIdBannerTemplatesDuplicate } from "./engagementAppGroupIdBannerTemplatesDuplicate";
import {
  getEngagementAppGroupIdBannerTemplatesId,
  putEngagementAppGroupIdBannerTemplatesId,
} from "./engagementAppGroupIdBannerTemplatesId";
import { postEngagementAppGroupIdBannerTemplatesUpdateArchivedState } from "./engagementAppGroupIdBannerTemplatesUpdateArchivedState";
import { getEngagementAppGroupIdCampaignCampaignIdMessageMessageVariationIdLatestTestResults } from "./engagementAppGroupIdCampaignCampaignIdMessageMessageVariationIdLatestTestResults";
import { getEngagementAppGroupIdCampaignCountryPerformanceCampaignId } from "./engagementAppGroupIdCampaignCountryPerformanceCampaignId";
import { getEngagementAppGroupIdCanvasContentOptimizerSteps } from "./engagementAppGroupIdCanvasContentOptimizerSteps";
import { getEngagementAppGroupIdCanvasCountryPerformanceWorkflowId } from "./engagementAppGroupIdCanvasCountryPerformanceWorkflowId";
import { getEngagementAppGroupIdCanvasStepBatchedStatsStepType } from "./engagementAppGroupIdCanvasStepBatchedStatsStepType";
import { getEngagementAppGroupIdCanvasWorkflowIdContentOptimizationLaunchLimit } from "./engagementAppGroupIdCanvasWorkflowIdContentOptimizationLaunchLimit";
import { getContentOptimizationPerformanceContext } from "./engagementAppGroupIdCanvasWorkflowIdContentOptimizationStepIdPerformanceContext";
import { postEngagementCanvasStepPreviewPath } from "./engagementAppGroupIdCanvasWorkflowIdStepStepIdPreviewPath";
import { discardCanvasVersion, putCanvasVersion } from "./engagementAppGroupIdCanvasWorkflowIdVersionsVersionId";
import { getCloudStorageCapability } from "./engagementAppGroupIdCloudStorageCapability";
import { postCompiledIamCustomCss } from "./engagementAppGroupIdCompiledIamCustomCss";
import { getEngagementAppGroupIdContentBlocksIdPreviewThumbnail } from "./engagementAppGroupIdContentBlocksIdPreviewThumbnail";
import { postCreateAccessibilityTest } from "./engagementAppGroupIdCreateAccessibilityTest";
import { postEngagementCreateEmailTest } from "./engagementAppGroupIdCreateEmailTest";
import { postEngagementCreateSpamTest } from "./engagementAppGroupIdCreateSpamTest";
import { postEngagementAppGroupIdCropImageAsset } from "./engagementAppGroupIdCropImageAsset";
import {
  getEngagementAppGroupIdDestinationCanvasNotificationDismissedWorkflowId,
  postEngagementAppGroupIdDestinationCanvasNotificationDismissedWorkflowId,
} from "./engagementAppGroupIdDestinationCanvasNotificationDismissedWorkflowId";
import { getEmailSettingsApiEndpoint } from "./engagementAppGroupIdEmailSettings";
import { getEngagementAppGroupIdEmailTemplatesIdPreviewThumbnail } from "./engagementAppGroupIdEmailTemplatesIdPreviewThumbnail";
import { getEngagementAppGroupIdFeatureFlagLimits } from "./engagementAppGroupIdFeatureFlagLimits";
import { getEngagementAppGroupIdFeatureFlagsInfo } from "./engagementAppGroupIdFeatureFlagsInfo";
import { getEngagementAppGroupIdFeatureFlagsRolloutIdDependencies } from "./engagementAppGroupIdFeatureFlagsRolloutIdDependencies";
import { getEngagementAppGroupIdFeatureFlagsRolloutIdExperimentUsage } from "./engagementAppGroupIdFeatureFlagsRolloutIdExperimentUsage";
import { getEngagementAppGroupIdFeatureFlagsTags } from "./engagementAppGroupIdFeatureFlagsTags";
import { postEngagementAppGroupIdFeatureFlagsUpdateTags } from "./engagementAppGroupIdFeatureFlagsUpdateTags";
import { getEngagementAppGroupIdFeatureLimitations } from "./engagementAppGroupIdFeatureLimitations";
import { getFromEmailDomains } from "./engagementAppGroupIdFromEmailDomains";
import { getVideoPresignedUrl } from "./engagementAppGroupIdGenerateVideoPresignedUrl";
import { getAccessibilityResults } from "./engagementAppGroupIdGetAccessibilityResultsId";
import { getEngagementAppGroupIdGetAssetMetadata } from "./engagementAppGroupIdGetAssetMetadata";
import { getEngagementGetEmailClientMetadata } from "./engagementAppGroupIdGetEmailClientMetadataId";
import { getEngagementGetEmailResults } from "./engagementAppGroupIdGetEmailResultsId";
import { getEngagementGetSpamClientDescriptions } from "./engagementAppGroupIdGetSpamClientDescriptions";
import { getEngagementGetSpamResultsId } from "./engagementAppGroupIdGetSpamResultsId";
import { getEngagementAppGroupIdHasFeatureFlags } from "./engagementAppGroupIdHasFeatureFlags";
import { getDataTableInfobipKakaoSenderKeys } from "./engagementAppGroupIdInfobipKakaoSenderKeysData";
import { getEngagementAppGroupIdKakaoSenderKeys } from "./engagementAppGroupIdKakaoSenderKeys";
import { postEngagementAppGroupIdLibraryDelete } from "./engagementAppGroupIdLibraryDelete";
import { putEngagementAppGroupIdLibraryEdit } from "./engagementAppGroupIdLibraryEdit";
import { putEngagementAppGroupIdLibraryReplaceFile } from "./engagementAppGroupIdLibraryReplaceFile";
import { postEngagementAppGroupIdLibraryUpdateTags } from "./engagementAppGroupIdLibraryUpdateTags";
import { getEngagementAppGroupIdLinkAliasesGetTriggerableLinks } from "./engagementAppGroupIdLinkAliasesGetTriggerableLinks";
import { getEngagementListEmailSettings } from "./engagementAppGroupIdListEmailSettings";
import { getMediaLibraryAssetData } from "./engagementAppGroupIdMediaLibraryAssetDataAssetId";
import { getDataTableEngagementAppGroupIdPresetBannerTemplates } from "./engagementAppGroupIdPresetBannerTemplates";
import { getEngagementAppGroupIdPresetBannerTemplatesId } from "./engagementAppGroupIdPresetBannerTemplatesId";
import { getEngagementAppGroupIdPushSettings } from "./engagementAppGroupIdPushSettings";
import { getAppGroupRandomUserId } from "./engagementAppGroupIdRandomUserId";
import { postEngagementAppGroupIdShareablePreviewLink } from "./engagementAppGroupIdShareablePreviewCreateLink";
import { getEngagementAppGroupIdShareablePreviewLinks } from "./engagementAppGroupIdShareablePreviewGetLinks";
import { getEngagementAppGroupIdSmsInboundMessageKeywordCategories } from "./engagementAppGroupIdSmsInboundMessageKeywordCategories";
import { postBlankCanvasTemplate } from "./engagementAppGroupIdStructuralTemplateBlankCanvasTemplate";
import { postEngagementAppGroupIdStructuralTemplateCanvasTemplate } from "./engagementAppGroupIdStructuralTemplateCanvasTemplate";
import { postEngagementAppGroupIdStructuralTemplateCanvasTemplateCanvasCanvasId } from "./engagementAppGroupIdStructuralTemplateCanvasTemplateCanvasCanvasId";
import { postEngagementAppGroupIdStructuralTemplateCanvasTemplateClone } from "./engagementAppGroupIdStructuralTemplateCanvasTemplateClone";
import { getEngagementAppGroupIdStructuralTemplateCanvasTemplateClonedStepsData } from "./engagementAppGroupIdStructuralTemplateCanvasTemplateClonedStepsData";
import { putEngagementAppGroupIdStructuralTemplateCanvasTemplateRename } from "./engagementAppGroupIdStructuralTemplateCanvasTemplateRename";
import { getEngagementAppGroupIdStructuralTemplateCanvasTemplateTags } from "./engagementAppGroupIdStructuralTemplateCanvasTemplateTags";
import { getEngagementAppGroupIdStructuralTemplateCanvasTemplateTerritories } from "./engagementAppGroupIdStructuralTemplateCanvasTemplateTerritories";
import { postEngagementAppGroupIdStructuralTemplateCanvasTemplateUpdateArchivedState } from "./engagementAppGroupIdStructuralTemplateCanvasTemplateUpdateArchivedState";
import { postEngagementAppGroupIdStructuralTemplateCanvasTemplateUpdateTags } from "./engagementAppGroupIdStructuralTemplateCanvasTemplateUpdateTags";
import { postEngagementAppGroupIdStructuralTemplateCanvasTemplateUpsert } from "./engagementAppGroupIdStructuralTemplateCanvasTemplateUpsert";
import { getDataTableCanvasTemplates } from "./engagementAppGroupIdStructuralTemplateCanvasTemplatesData";
import {
  getDataTableEngagementAppGroupIdSuppressionRules,
  postEngagementAppGroupIdSuppressionRules,
} from "./engagementAppGroupIdSuppressionRules";
import {
  getEngagementAppGroupIdSuppressionRulesId,
  putEngagementAppGroupIdSuppressionRulesId,
} from "./engagementAppGroupIdSuppressionRulesId";
import { postEngagementAppGroupIdSurveyExportResponses } from "./engagementAppGroupIdSurveyExportResponses";
import { getDataTableEngagementAppGroupIdSurveyQuestionResponses } from "./engagementAppGroupIdSurveyQuestionResponses";
import { getEngagementAppGroupIdSurveyStats } from "./engagementAppGroupIdSurveyStats";
import { getDataTableEngagementAppGroupIdSurveys } from "./engagementAppGroupIdSurveys";
import { getEngagementAppGroupIdSurveysSurveyStatsSummary } from "./engagementAppGroupIdSurveysSurveyStatsSummary";
import {
  getEngagementAppGroupIdTemplatedPreview,
  postEngagementAppGroupIdTemplatedPreview,
} from "./engagementAppGroupIdTemplatedPreview";
import { postEngagementTestSend } from "./engagementAppGroupIdTestSend";
import { getEngagementAppGroupIdTestSendFreeTrialAllowedDomains } from "./engagementAppGroupIdTestSendFreeTrialAllowedDomains";
import { postEngagementAppGroupIdTransactionalWebPushTest } from "./engagementAppGroupIdTransactionalWebPushTest";
import {
  postWhatsAppMessageTemplate,
  postSaveWhatsAppMessageTemplateAsDraft,
  getWhatsAppMessageTemplateById,
  getEngagementAppGroupIdWhatsAppMessageTemplates,
  deleteWhatsAppMessageTemplateDraft,
} from "./engagementAppGroupIdWhatsAppMessageTemplates";
import { getEngagementAppGroupIdWhatsAppMessageTemplatesExternalAccountId } from "./engagementAppGroupIdWhatsAppMessageTemplatesExternalAccountId";
import {
  getWabaCreativeOptimizationSettings,
  postWabaCreativeOptimizationSettings,
} from "./engagementAppGroupIdWhatsAppWabaCreativeOptimizationSettings";
import { getEngagementAppGroupIdWhatsappMmLiteApiStatus } from "./engagementAppGroupIdWhatsappMmLiteApiStatus";
import { getWhatsAppMmLiteStatusForMessagingService } from "./engagementAppGroupIdWhatsappMmLiteApiStatusMessagingServiceId";
import { getDataTableEngagementAppIdFeatureFlagsEligibilityUserIdDeviceId } from "./engagementAppIdFeatureFlagsEligibilityUserIdDeviceId";
import { patchEngagementApprovalsContextIdApproveAll } from "./engagementApprovalsContextIdApproveAll";
import { getEngagementApprovalsStep, patchEngagementApprovalsStep } from "./engagementApprovalsContextIdStep";
import { postwsEngagementAsyncCampaignPreviewAppGroupId } from "./engagementAsyncCampaignPreviewAppGroupId";
import { getEngagementAsyncSegmentInsightsActualStats } from "./engagementAsyncSegmentInsightsActualStats";
import { getEngagementAsyncSegmentInsightsStatsAppGroupId } from "./engagementAsyncSegmentInsightsStatsAppGroupId";
import { engagementAsyncSegmentsAndFiltersPreviewAppGroupId } from "./engagementAsyncSegmentsAndFiltersPreviewAppGroupId";
import { getEngagementAudienceSyncPlatformAdAccounts } from "./engagementAudienceSyncPlatformAdAccounts";
import { getEngagementAudienceSyncPlatformAdAccountsAdAccountId } from "./engagementAudienceSyncPlatformAdAccountsAdAccountId";
import { postEngagementAudienceSyncPlatformAdAccountsAdAccountIdAudiences } from "./engagementAudienceSyncPlatformAdAccountsAdAccountIdAudiences";
import { postEngagementBrazeReportDashboard } from "./engagementBrazeReportDashboard";
import { postEngagementBrazeReportDashboardRunEventDashboardRunEventIdCancel } from "./engagementBrazeReportDashboardRunEventDashboardRunEventIdCancel";
import { getReportDashboardRunEvent } from "./engagementBrazeReportDashboardRunEventDashboardTypeDashboardId";
import { getEngagementBrazeReportDashboardType } from "./engagementBrazeReportDashboardType";
import { deleteEngagementCampaignActiveDraftCampaignId } from "./engagementCampaignActiveDraftCampaignId";
import { getEngagementCampaignBannerClickDailyStatsCampaignId } from "./engagementCampaignBannerClickDailyStatsCampaignId";
import { getEngagementCampaignDataCampaignId } from "./engagementCampaignDataCampaignId";
import { getCampaignEmailClickDailyStats } from "./engagementCampaignEmailClickDailyStats";
import { getEngagementCampaignIamClickDailyStatsCampaignId } from "./engagementCampaignIamClickDailyStatsCampaignId";
import { putEngagementCampaignScheduleSummary } from "./engagementCampaignScheduleSummary";
import { getEngagementCampaignStats } from "./engagementCampaignStatsCampaignId";
import { patchEngagementCampaignsAppGroupIdCampaignIdAutoStopExemption } from "./engagementCampaignsAppGroupIdCampaignIdAutoStopExemption";
import { getCampaignsWithExceptions } from "./engagementCampaignsAppGroupIdCampaignsWithExceptions";
import { postEngagementCampaignsAppGroupIdUpdateArchivedState } from "./engagementCampaignsAppGroupIdUpdateArchivedState";
import { postEngagementCampaignsAppGroupIdUpdateEnabledState } from "./engagementCampaignsAppGroupIdUpdateEnabledState";
import { deleteEngagementCampaignsCampaignAlertPreferencesDeleteCampaignId } from "./engagementCampaignsCampaignAlertPreferencesDeleteCampaignId";
import { putEngagementCampaignsCampaignAlertPreferencesUpdate } from "./engagementCampaignsCampaignAlertPreferencesUpdate";
import { postEngagementCampaignsCampaignIdExport } from "./engagementCampaignsCampaignIdExport";
import { getEngagementCampaignLimits } from "./engagementCampaignsCampaignLimitsAppGroupId";
import { getEngagementCampaignsCampaignTerritories } from "./engagementCampaignsCampaignTerritories";
import { getEngagementCampaignsCampaignsWithCarouselSlides } from "./engagementCampaignsCampaignsWithCarouselSlides";
import { getEngagementCampaignsCampaignsWithPushButtons } from "./engagementCampaignsCampaignsWithPushButtons";
import { getEngagementCampaignsCampaignsWithRepliedToSms } from "./engagementCampaignsCampaignsWithRepliedToSms";
import { getEngagementCampaignsCarouselSlidesForCampaign } from "./engagementCampaignsCarouselSlidesForCampaign";
import { postEngagementCampaignsClone } from "./engagementCampaignsClone";
import { getEngagementCampaignsConversionCorrelationDataCampaignId } from "./engagementCampaignsConversionCorrelationDataCampaignId";
import { postEngagementCampaignsCreateDefault } from "./engagementCampaignsCreateDefault";
import { postEngagementCampaignsDataFilters } from "./engagementCampaignsDataFilters";
import { getEngagementCampaignsDataGetSavedFilters } from "./engagementCampaignsDataGetSavedFilters";
import { getDataTableEngagementCampaignsDataV2 } from "./engagementCampaignsDataV2";
import { postEngagementCampaignsDraftActiveCampaign } from "./engagementCampaignsDraftActiveCampaign";
import { getEligibleCampaigns } from "./engagementCampaignsEligible";
import { getEngagementCampaignsExperimentDataCampaignId } from "./engagementCampaignsExperimentDataCampaignId";
import { getCampaignsGlobalFrequencyCaps } from "./engagementCampaignsGlobalFrequencyCapsAppGroupId";
import { getEngagementCampaignsGlobalRateLimitsAppGroupId } from "./engagementCampaignsGlobalRateLimitsAppGroupId";
import { getEngagementCampaignsPushButtonsForCampaign } from "./engagementCampaignsPushButtonsForCampaign";
import { postEngagementCampaignsRestoreCampaignRetargetingData } from "./engagementCampaignsRestoreCampaignRetargetingData";
import { putEngagementCampaignsSetGlobalFrequencyCaps } from "./engagementCampaignsSetGlobalFrequencyCaps";
import { putEngagementCampaignsSetGlobalRateLimits } from "./engagementCampaignsSetGlobalRateLimits";
import { getEngagementCampaignsTags } from "./engagementCampaignsTags";
import { getEngagementCampaignsTagsWithIds } from "./engagementCampaignsTagsWithIds";
import { postEngagementCampaignsUpdateTags } from "./engagementCampaignsUpdateTags";
import { postEngagementCancelConversionReport } from "./engagementCancelConversionReport";
import { deleteEngagementCanvasActiveDraftWorkflowId } from "./engagementCanvasActiveDraftWorkflowId";
import { getEngagementCanvasCarouselSlides } from "./engagementCanvasCarouselSlides";
import { getEngagementCanvasComparisonReportsCanvasesAppGroupId } from "./engagementCanvasComparisonReportsCanvasesAppGroupId";
import { postEngagementCanvasContextUpdateStepPreview } from "./engagementCanvasContextUpdateStepPreview";
import { getEligibleCanvas } from "./engagementCanvasEligible";
import { postCanvasFromCanvasTemplate } from "./engagementCanvasFromCanvasTemplate";
import { postEngagementCanvasItemsBlockingStepsOrVariationsDeletion } from "./engagementCanvasItemsBlockingStepsOrVariationsDeletion";
import { postEngagementCanvasLlmStepPreview } from "./engagementCanvasLlmStepPreview";
import { getEngagementCanvasPushButtons } from "./engagementCanvasPushButtons";
import { postEngagementCanvasRestoreCanvasRetargetingData } from "./engagementCanvasRestoreCanvasRetargetingData";
import { getEngagementCanvasSendToDestinationRelatedCanvases } from "./engagementCanvasSendToDestinationRelatedCanvases";
import { getEngagementCanvasStatsWorkflowId } from "./engagementCanvasStatsWorkflowId";
import { getEngagementCanvasTags } from "./engagementCanvasTags";
import { getCanvasTemplatePreview } from "./engagementCanvasTemplatePreview";
import { postEngagementCanvasExport } from "./engagementCanvasWorkflowIdExport";
import { getDataTableEngagementCanvasesData } from "./engagementCanvasesData";
import { getEngagementCanvasesForClickedShortenedSmsLink } from "./engagementCanvasesForClickedShortenedSmsLink";
import { getEngagementCanvasesWithRepliedToSms } from "./engagementCanvasesWithRepliedToSms";
import { getEngagementContentBlockInclusionsId } from "./engagementContentBlockInclusions";
import { getEngagementContentBlockLocales } from "./engagementContentBlockLocales";
import { getDataTableEngagementContentBlocks } from "./engagementContentBlocks";
import { getEngagementContentBlocksContent } from "./engagementContentBlocksContent";
import { postEngagementContentBlocksDuplicate } from "./engagementContentBlocksDuplicate";
import { getEngagementContentBlocksId, postEngagementContentBlocksId } from "./engagementContentBlocksId";
import { getEngagementContentBlocksNames } from "./engagementContentBlocksNames";
import { getEngagementContentBlocksSelect } from "./engagementContentBlocksSelect";
import { getEngagementContentBlocksTags } from "./engagementContentBlocksTags";
import { getEngagementContentBlocksTerritories } from "./engagementContentBlocksTerritories";
import { postEngagementContentBlocksUpdateArchivedState } from "./engagementContentBlocksUpdateArchivedState";
import { postEngagementContentBlocksUpdateTags } from "./engagementContentBlocksUpdateTags";
import { postEngagementConversionFilterPreview } from "./engagementConversionFilterPreview";
import { postEngagementConversionReport, putEngagementConversionReport } from "./engagementConversionReport";
import { postEngagementCreateLocationSet } from "./engagementCreateLocationSet";
import { getDragAndDropContentBlocks } from "./engagementDragAndDropContentBlocks";
import { putEngagementEditLocationsApps } from "./engagementEditLocationsApps";
import { getEngagementEmailMessageDndEditorAccessToken } from "./engagementEmailMessageDndEditorAccessToken";
import { postEngagementEmailMessageDndEditorSimpleToFullJson } from "./engagementEmailMessageDndEditorSimpleToFullJson";
import { getDataTableEngagementEmailTemplates, getEmailTemplateSources } from "./engagementEmailTemplates";
import { postEngagementEmailTemplatesDuplicate } from "./engagementEmailTemplatesDuplicate";
import { getEngagementEmailTemplatesId, postEngagementEmailTemplatesId } from "./engagementEmailTemplatesId";
import { getEngagementEmailTemplatesTags } from "./engagementEmailTemplatesTags";
import { getEngagementEmailTemplatesTerritories } from "./engagementEmailTemplatesTerritories";
import { postEngagementEmailTemplatesUpdateArchivedState } from "./engagementEmailTemplatesUpdateArchivedState";
import { postEngagementEmailTemplatesUpdateTags } from "./engagementEmailTemplatesUpdateTags";
import { postExportLogsCancel } from "./engagementExportLogsCancel";
import { getExportLogsResult } from "./engagementExportLogsLogIdAppGroupId";
import { getDataTableExportLogs } from "./engagementExportLogsResult";
import { postEngagementFeatureFlagRolloutUpsert } from "./engagementFeatureFlagRolloutUpsert";
import { getFeatureFlagRolloutsData } from "./engagementFeatureFlagRolloutsData";
import { getEngagementFeatureFlagRolloutsDataFeatureFlagBsonIdAppGroupId } from "./engagementFeatureFlagRolloutsDataFeatureFlagBsonIdAppGroupId";
import { getEngagementFilterGroups } from "./engagementFilterGroups";
import { getEngagementFilterType } from "./engagementFilterType";
import { getEngagementGeofencesData } from "./engagementGeofencesData";
import { getEngagementGetCanvasesForFilter } from "./engagementGetCanvasesForFilter";
import { getEngagementGetChangelogs } from "./engagementGetChangelogs";
import { getEngagementGetProductRecommenderProperties } from "./engagementGetProductRecommenderProperties";
import { getEngagementInAppMessageCampaignsAndWorkflowsData } from "./engagementInAppMessageCampaignsAndWorkflowsData";
import { getDataTableEngagementInAppMessageColorProfiles } from "./engagementInAppMessageColorProfiles";
import { getEngagementInAppMessageColorProfilesDefault } from "./engagementInAppMessageColorProfilesDefault";
import { postEngagementInAppMessageColorProfilesDuplicate } from "./engagementInAppMessageColorProfilesDuplicate";
import {
  getEngagementInAppMessageColorProfilesId,
  postEngagementInAppMessageColorProfilesId,
} from "./engagementInAppMessageColorProfilesId";
import { getEngagementInAppMessageColorProfilesTags } from "./engagementInAppMessageColorProfilesTags";
import { getEngagementInAppMessageColorProfilesTerritories } from "./engagementInAppMessageColorProfilesTerritories";
import { postEngagementInAppMessageColorProfilesUpdateArchivedState } from "./engagementInAppMessageColorProfilesUpdateArchivedState";
import { postEngagementInAppMessageColorProfilesUpdateTags } from "./engagementInAppMessageColorProfilesUpdateTags";
import { postEngagementIntelligentDeliveryPreview } from "./engagementIntelligentDeliveryPreviewAppGroupId";
import { getEngagementInvalidAttributeNames } from "./engagementInvalidAttributeNames";
import { getIosNotificationGroups, updateIosNotificationGroups } from "./engagementIosNotificationGroups";
import { getEngagementJumpstartContentBlocks } from "./engagementJumpstartContentBlocks";
import { getEngagementJumpstartEmailTemplates } from "./engagementJumpstartEmailTemplatesId";
import { getEngagementLandingPageData } from "./engagementLandingPageData";
import { getEngagementLandingPageStats } from "./engagementLandingPageStatsLandingPageBsonId";
import { putEngagementLandingPageTemplateId } from "./engagementLandingPageTemplateId";
import { getDataTableEngagementLandingPageTemplatesData } from "./engagementLandingPageTemplatesData";
import { getEngagementLandingPageTemplatesDataId } from "./engagementLandingPageTemplatesDataId";
import { postEngagementLandingPageTemplatesDuplicate } from "./engagementLandingPageTemplatesDuplicate";
import { postEngagementLandingPageTemplatesUpdateArchivedState } from "./engagementLandingPageTemplatesUpdateArchivedState";
import { postEngagementLandingPagesAppGroupIdCreateLandingPageApp } from "./engagementLandingPagesAppGroupIdCreateLandingPageApp";
import { getLandingPagesCustomDomainLimits } from "./engagementLandingPagesAppGroupIdCustomDomainLimits";
import {
  deleteLandingPagesCustomSubdomain,
  getLandingPagesCustomSubdomain,
  postLandingPagesCustomSubdomain,
} from "./engagementLandingPagesAppGroupIdCustomSubdomain";
import { postLandingPagesCustomSubdomainReactivate } from "./engagementLandingPagesAppGroupIdCustomSubdomainReactivate";
import { postEngagementLandingPagesAppGroupIdDuplicate } from "./engagementLandingPagesAppGroupIdDuplicate";
import {
  deleteLandingPagePostLaunchDraft,
  postLandingPageSavePostLaunchDraft,
} from "./engagementLandingPagesAppGroupIdLandingPageBsonIdPostLaunchDraft";
import {
  postEngagementLandingPagesAppGroupIdLandingPageId,
  putEngagementLandingPagesAppGroupIdLandingPageId,
} from "./engagementLandingPagesAppGroupIdLandingPageId";
import { postEngagementLandingPagesAppGroupIdLandingPageIdCopyTargetAppGroupId } from "./engagementLandingPagesAppGroupIdLandingPageIdCopyTargetAppGroupId";
import { getEngagementLandingPagesAppGroupIdLandingPageIdPreview } from "./engagementLandingPagesAppGroupIdLandingPageIdPreview";
import { getEngagementLandingPagesAppGroupIdLimits } from "./engagementLandingPagesAppGroupIdLimits";
import { getEngagementLandingPagesAppGroupIdSelect } from "./engagementLandingPagesAppGroupIdSelect";
import { getEngagementLandingPagesAppGroupIdSizeLimits } from "./engagementLandingPagesAppGroupIdSizeLimits";
import { getDataTableEngagementLandingPagesAppGroupIdSurveyLandingPagesWithQuestion } from "./engagementLandingPagesAppGroupIdSurveyLandingPagesWithQuestion";
import { postEngagementLandingPagesAppGroupIdUpdateArchivedState } from "./engagementLandingPagesAppGroupIdUpdateArchivedState";
import { getDataTableEngagementLandingPagesData } from "./engagementLandingPagesData";
import { getLandingPageNamesForSelect } from "./engagementLandingPagesSelect";
import { getLinkAliasCampaignEmailClickDailyStats } from "./engagementLinkAliasCampaignEmailClickDailyStats";
import { postLinkAliasMarkup } from "./engagementLinkAliases";
import { getTrackedLinks } from "./engagementLinkAliasesTrackedLinks";
import { postLinkAliasLinks } from "./engagementLinkAliasesUpdateLinks";
import { getEngagementLinkAliasesUpsertLid } from "./engagementLinkAliasesUpsertLid";
import { getEngagementLinkTemplatesId, postEngagementLinkTemplatesId } from "./engagementLinkTemplatesId";
import { getEngagementLinkTemplates } from "./engagementLinkTemplatesSelect";
import { getEngagementLinkTemplatesTags } from "./engagementLinkTemplatesTags";
import { getEngagementLinkTemplatesTerritories } from "./engagementLinkTemplatesTerritories";
import { postEngagementLinkTemplatesUpdateTags } from "./engagementLinkTemplatesUpdateTags";
import { getListCampaignsForReportBuilder } from "./engagementListCampaignsForReportBuilder";
import { getEngagementLocationSetData } from "./engagementLocationSetData";
import { getLocationSetTriggers } from "./engagementLocationSetTriggers";
import { getDataTableEngagementLocationSetsData } from "./engagementLocationSetsData";
import { postEngagementLocationSetsUpdateArchivedState } from "./engagementLocationSetsUpdateArchivedState";
import { getEngagementLocationsApps } from "./engagementLocationsApps";
import { getEngagementLocationsTags } from "./engagementLocationsTags";
import { getMessagingServices } from "./engagementMessagingServices";
import { getDataTableEngagementPlacementCampaignBasesDataV2 } from "./engagementPlacementCampaignBasesDataV2";
import { getEngagementPrediction } from "./engagementPrediction";
import { getEngagementPredictionAppGroupData } from "./engagementPredictionAppGroupData";
import { postEngagementPredictionClone } from "./engagementPredictionClone";
import { getEngagementPredictionFiltersPreviewAppGroupId } from "./engagementPredictionFiltersPreviewAppGroupId";
import { getEngagementPredictionStatsPredictionId } from "./engagementPredictionStatsPredictionId";
import { postEngagementPredictions } from "./engagementPredictions";
import { getDataTableEngagementPredictionsData } from "./engagementPredictionsData";
import { getEngagementPredictionsGetCustomEventNames } from "./engagementPredictionsGetCustomEventNames";
import { getEngagementPresetDraganddropTemplates } from "./engagementPresetDraganddropTemplates";
import { getDataTableEngagementPresetEmailTemplates } from "./engagementPresetEmailTemplates";
import { getEngagementPresetEmailTemplatesId } from "./engagementPresetEmailTemplatesId";
import { getDataTableEngagementPresetIamTemplates } from "./engagementPresetIamTemplates";
import { getDataTableEngagementPresetLandingPageTemplatesData } from "./engagementPresetLandingPageTemplatesData";
import { getEngagementPresetLandingPageTemplatesDataId } from "./engagementPresetLandingPageTemplatesDataId";
import { getDataTableEngagementPresetWebhookTemplates } from "./engagementPresetWebhookTemplates";
import { getEngagementPresetWebhookTemplatesId } from "./engagementPresetWebhookTemplatesId";
import { postEngagementProductRecommendations } from "./engagementProductRecommendations";
import { getEngagementProductRecommendationsRecommenderId } from "./engagementProductRecommendationsRecommenderId";
import { getEngagementProductRecommenderNames } from "./engagementProductRecommenderNames";
import { postEngagementQueryBuilderAppGroupIdReportIdSchedule } from "./engagementQueryBuilderAppGroupIdReportIdSchedule";
import { getEngagementQueryBuilderCredits } from "./engagementQueryBuilderCredits";
import { getEngagementQueryBuilderReport } from "./engagementQueryBuilderReport";
import { archiveQueryBuilderReport } from "./engagementQueryBuilderReportArchive";
import { deleteQueryBuilderReport } from "./engagementQueryBuilderReportDelete";
import { postEngagementQueryBuilderReportIdAppGroupIdExport } from "./engagementQueryBuilderReportIdAppGroupIdExport";
import { getEngagementQueryBuilderReports } from "./engagementQueryBuilderReports";
import { getSqlQueries } from "./engagementQueryBuilderSqlQueries";
import { getEngagementSqlQueriesQueryId } from "./engagementQueryBuilderSqlQueriesQueryId";
import { getEngagementRecommendationsMetadata } from "./engagementRecommendationsMetadata";
import { getEngagementRecommenderAnalytics } from "./engagementRecommenderAnalytics";
import { getEngagementRemoteFilterShells } from "./engagementRemoteFilterShells";
import { getEngagementRemoteSegmentSearch } from "./engagementRemoteSegmentSearch";
import { postEngagementRemoveAllContentCards } from "./engagementRemoveAllContentCards";
import { postEngagementReorderInAppMessages } from "./engagementReorderInAppMessages";
import { postEngagementReportBuilder2Clone } from "./engagementReportBuilder2AppGroupIdClone";
import { postEngagementReportBuilder2AppGroupIdNewReport } from "./engagementReportBuilder2AppGroupIdNewReport";
import {
  getEngagementReportBuilder2AppGroupIdReportId,
  putEngagementReportBuilder2AppGroupIdReportId,
} from "./engagementReportBuilder2AppGroupIdReportId";
import { postwsEngagementReportBuilder2Run } from "./engagementReportBuilder2AppGroupIdReportIdRun";
import { getEngagementReportBuilder2AppGroupIdSegmentAnalyticsTrackingWindows } from "./engagementReportBuilder2AppGroupIdSegmentAnalyticsTrackingWindows";
import { getEngagementReportBuilder2AppGroupIdSegmentIdentities } from "./engagementReportBuilder2AppGroupIdSegmentIdentities";
import { postReportBuilder2Archive } from "./engagementReportBuilder2AppGroupIdUpdateArchivedState";
import { putReportBuilder2BulkUpdateTags } from "./engagementReportBuilder2AppGroupIdUpdateTags";
import { getEngagementReportBuilder2Developers } from "./engagementReportBuilder2Developers";
import { postEngagementReportBuilder2ReportIdAppGroupIdRun } from "./engagementReportBuilder2ReportIdAppGroupIdRun";
import { postReportBuilder2CancelReport } from "./engagementReportBuilder2ReportIdCancelQueryBuilderReport";
import { getDataTableEngagementReportBuilder2Reports } from "./engagementReportBuilder2Reports";
import { getEngagementReportBuilder2Tags } from "./engagementReportBuilder2Tags";
import { postEngagementReportDashboard } from "./engagementReportDashboard";
import {
  deleteEngagementReportDashboardDashboardId,
  getEngagementReportDashboardDashboardId,
  putEngagementReportDashboardDashboardId,
} from "./engagementReportDashboardDashboardId";
import { postEngagementReportDashboardDashboardIdCreateTileFromReportBuilderReport } from "./engagementReportDashboardDashboardIdCreateTileFromReportBuilderReport";
import { getEngagementReportDashboardLatest } from "./engagementReportDashboardLatest";
import { postReportDashboardRunDashboard } from "./engagementReportDashboardRunDashboardDashboardTypeDashboardId";
import { postEngagementReportDashboardsAppGroupIdUpdateArchivedState } from "./engagementReportDashboardsAppGroupIdUpdateArchivedState";
import { postEngagementReportTile } from "./engagementReportTile";
import { deleteEngagementReportTileTileId, putEngagementReportTileTileId } from "./engagementReportTileTileId";
import { getSdkAuthChangelogs } from "./engagementSdkAuthChangelogs";
import { getEngagementSegmentData } from "./engagementSegmentData";
import { postEngagementSegmentInsightsActualStatistics } from "./engagementSegmentInsightsActualStatistics";
import { getEngagementSegmentPreview } from "./engagementSegmentPreviewAppGroupId";
import { getEngagementSegments, postEngagementSegments } from "./engagementSegments";
import {
  getEngagementSegmentsAndFiltersSentenceArray,
  postEngagementSegmentsAndFiltersSentenceArray,
} from "./engagementSegmentsAndFiltersSentenceArrayAppGroupId";
import { getEngagementSegmentsCampaignSentenceAppGroupId } from "./engagementSegmentsCampaignSentenceAppGroupId";
import { getEngagementSegmentsCampaignsForLinkSegmentation } from "./engagementSegmentsCampaignsForLinkSegmentation";
import { getEngagementSegmentsCanExportAllAttributes } from "./engagementSegmentsCanExportAllAttributes";
import { postEngagementSegmentsClone } from "./engagementSegmentsClone";
import { getEngagementSegmentsCount } from "./engagementSegmentsCount";
import { postEngagementSegmentsExport } from "./engagementSegmentsExport";
import { getSegmentEngagements } from "./engagementSegmentsIdEngagements";
import { postEngagementSegmentsMarkAsArchived } from "./engagementSegmentsMarkAsArchived";
import { postEngagementSegmentsMarkAsUnarchived } from "./engagementSegmentsMarkAsUnarchived";
import { putEngagementSegmentsSegmentId } from "./engagementSegmentsSegmentId";
import { getEngagementSegmentsSegmentIdDownloadSelector } from "./engagementSegmentsSegmentIdDownloadSelector";
import { postEngagementSegmentsFacebookExport } from "./engagementSegmentsSegmentIdFacebookExport";
import { engagementSegmentsMigrateFilters } from "./engagementSegmentsSegmentIdMigrateFilters";
import { getEngagementSegmentsSegmentTerritories } from "./engagementSegmentsSegmentTerritories";
import { postEngagementSegmentsStar, postEngagementSegmentsUnstar } from "./engagementSegmentsStar";
import { getEngagementSegmentsTags } from "./engagementSegmentsTags";
import { engagementSegmentsUpdateTags } from "./engagementSegmentsUpdateTags";
import { getEngagementSegmentsWorkflowsForLinkSegmentation } from "./engagementSegmentsWorkflowsForLinkSegmentation";
import { getDataTableEngagementSendOutcomesAbortLogData } from "./engagementSendOutcomesAbortLogData";
import { getEngagementSparseSegmentsData } from "./engagementSparseSegmentsData";
import { getEngagementSurveyQuestionChart } from "./engagementSurveyQuestionChart";
import { getEngagementTagsWithRepliedToSms } from "./engagementTagsWithRepliedToSms";
import { deleteCanvasFromCanvasTemplate } from "./engagementUndoCanvasFromCanvasTemplate";
import { postEngagementUpdateFeatureFlagRolloutArchivedState } from "./engagementUpdateFeatureFlagRolloutArchivedState";
import { postEngagementUpdateLocationSetLocationSetId } from "./engagementUpdateLocationSetLocationSetId";
import { postEngagementUploadAsset } from "./engagementUploadAsset";
import { getEngagementUserMatcher, postEngagementUserMatcher } from "./engagementUserMatcher";
import { getDataTableEngagementV2LinkTemplates } from "./engagementV2LinkTemplates";
import { postEngagementWebhookTemplatesDuplicate } from "./engagementWebhookTemplatesDuplicate";
import { postEngagementWebhookTemplatesId } from "./engagementWebhookTemplatesId";
import { getEngagementWebhookTemplatesTags } from "./engagementWebhookTemplatesTags";
import { getEngagementWebhookTemplatesTerritories } from "./engagementWebhookTemplatesTerritories";
import { postEngagementWebhookTemplatesUpdateArchivedState } from "./engagementWebhookTemplatesUpdateArchivedState";
import { postEngagementWebhookTemplatesUpdateTags } from "./engagementWebhookTemplatesUpdateTags";
import { getFreeTrialPilotDeepLinkQrCode } from "./freeTrialPilotDeepLinkQrCode";
import { getFreeTrialQrCode } from "./freeTrialQrCode";
import { postGlobalFunnelRun } from "./funnelReportsAppGroupIdCreate";
import { getFunnelReportDetails } from "./funnelReportsReportIdAppGroupIdDetails";
import { getGlobalFunnelRun } from "./funnelReportsRunIdAppGroupIdStatus";
import { postGenerativeAiAgent } from "./generativeAiAgent";
import { postGenerativeAiAgentClone } from "./generativeAiAgentClone";
import { getGenerativeAiAgentId } from "./generativeAiAgentId";
import { postGenerativeAiAgentIdCopyTargetAppGroupId } from "./generativeAiAgentIdCopyTargetAppGroupId";
import { getGenerativeAiAgentIdExecutionStats } from "./generativeAiAgentIdExecutionStats";
import { getDataTableGenerativeAiAgentIdLogRuns } from "./generativeAiAgentIdLogRuns";
import { getDataTableGenerativeAiAgentIdLogs } from "./generativeAiAgentIdLogs";
import { getGenerativeAiAgentIdLogsBatchDetails } from "./generativeAiAgentIdLogsBatchDetails";
import { getGenerativeAiAgentIdLogsCallingLocations } from "./generativeAiAgentIdLogsCallingLocations";
import { getGenerativeAiAgentIdLogsDetail } from "./generativeAiAgentIdLogsDetail";
import { getGenerativeAiAgentIdVersionDiff } from "./generativeAiAgentIdVersionDiff";
import { getDataTableGenerativeAiAgentIdVersions } from "./generativeAiAgentIdVersions";
import { putGenerativeAiAgentUpdateArchivedState } from "./generativeAiAgentUpdateArchivedState";
import { getDataTableGenerativeAiAgents } from "./generativeAiAgents";
import { getGenerativeAiAgentsCampaignQa } from "./generativeAiAgentsCampaignQa";
import { getGenerativeAiAgentsCanvasQa } from "./generativeAiAgentsCanvasQa";
import { getGenerativeAiAgentsCatalogs } from "./generativeAiAgentsCatalogs";
import { getGenerativeAiAgentsModels } from "./generativeAiAgentsModels";
import { getGenerativeAiAgentsStandardsSettings } from "./generativeAiAgentsStandardsSettings";
import { getGenerativeAiAgentsTags } from "./generativeAiAgentsTags";
import { getGenerativeAiAgentsTerritories } from "./generativeAiAgentsTerritories";
import { getGenerativeAiAgentsTools } from "./generativeAiAgentsTools";
import { getGenerativeAiAgentsUniqueName } from "./generativeAiAgentsUniqueName";
import { postwsGenerativeAiAppGroupIdAgentPreview } from "./generativeAiAppGroupIdAgentPreview";
import { postwsGenerativeAiAppGroupIdBrandGuidelinesEvaluation } from "./generativeAiAppGroupIdBrandGuidelinesEvaluation";
import { postwsGenerativeAiAppGroupIdBrandGuidelinesSynthesis } from "./generativeAiAppGroupIdBrandGuidelinesSynthesis";
import { postwsGenerativeAiAppGroupIdBrandGuidelinesTestGeneration } from "./generativeAiAppGroupIdBrandGuidelinesTestGeneration";
import { postwsGenerativeAiAppGroupIdCampaignQa } from "./generativeAiAppGroupIdCampaignQa";
import { postGenerativeAiAppGroupIdCampaignQaCancel } from "./generativeAiAppGroupIdCampaignQaCancel";
import { postwsGenerativeAiAppGroupIdCanvasQa } from "./generativeAiAppGroupIdCanvasQa";
import { postGenerativeAiAppGroupIdCanvasQaCancel } from "./generativeAiAppGroupIdCanvasQaCancel";
import { postwsGenerativeAiAppGroupIdGptAssistant } from "./generativeAiAppGroupIdGptAssistant";
import { postwsGenerativeAiAppGroupIdStandardsRulesetSynthesis } from "./generativeAiAppGroupIdStandardsRulesetSynthesis";
import { postwsGenerativeAiAppGroupIdVariantGenerationAssistant } from "./generativeAiAppGroupIdVariantGenerationAssistant";
import { getGenerativeAiBrandGuideline } from "./generativeAiBrandGuideline";
import {
  deleteGenerativeAiBrandGuidelineDocument,
  postGenerativeAiBrandGuidelineDocument,
} from "./generativeAiBrandGuidelineDocument";
import { putGenerativeAiBrandGuidelineUpdateArchivedState } from "./generativeAiBrandGuidelineUpdateArchivedState";
import { postGenerativeAiBrandGuidelines } from "./generativeAiBrandGuidelines";
import { listBrandGuidelines } from "./generativeAiListBrandGuidelines";
import { getGenerativeAiStandardsRulesetSynthesisUsage } from "./generativeAiStandardsRulesetSynthesisUsage";
import { getGenerativeAiStandardsRunHistory } from "./generativeAiStandardsRunHistory";
import { getGenerativeAiStandardsRunUsage } from "./generativeAiStandardsRunUsage";
import { getGlobalControlSettings } from "./globalControlSettings";
import { postInboxVisionAppGroupIdCreateEmailTest } from "./inboxVisionAppGroupIdCreateEmailTest";
import { getInboxVisionAppGroupIdGetInboxVisionData } from "./inboxVisionAppGroupIdGetInboxVisionData";
import { postInboxVisionAppGroupIdSetDefaultPreviewIds } from "./inboxVisionAppGroupIdSetDefaultPreviewIds";
import {
  createCdiImportSync,
  deleteCdiImportSync,
  postCdiKeyRegenerate,
  postCdiTestConnection,
  postImportKeysDelete,
  putImportKeysUpdate,
  updateCdiImportSync,
  updateCdiImportSyncStatus,
} from "./integrationsCdiImport";
import { getIntegrationsCurrentsIntegrationDataId } from "./integrationsCurrentsIntegrationDataId";
import { getIntegrationsCurrentsIntegrationsConfig } from "./integrationsCurrentsIntegrationsConfig";
import { getIntegrationsDirectCdiAwsAccountId } from "./integrationsDirectCdiAwsAccountId";
import { postIntegrationsDirectCdiCatalogSchemaDiff } from "./integrationsDirectCdiCatalogSchemaDiff";
import { getIntegrationsDirectCdiGcpWifPrincipalAppGroupId } from "./integrationsDirectCdiGcpWifPrincipalAppGroupId";
import { getIntegrationsDirectCdiImportKeysAppGroupId } from "./integrationsDirectCdiImportKeysAppGroupId";
import { postIntegrationsDirectCdiImportKeysGenerate } from "./integrationsDirectCdiImportKeysGenerate";
import { postIntegrationsDirectCdiImportKeysKeyIdTest } from "./integrationsDirectCdiImportKeysKeyIdTest";
import { postIntegrationsDirectCdiImportSyncsConnection } from "./integrationsDirectCdiImportSyncsConnection";
import { getCdiInferCatalogFields } from "./integrationsDirectCdiImportSyncsImportSyncIdInferCatalogFields";
import { postIntegrationCdiSyncNow } from "./integrationsDirectCdiImportSyncsImportSyncIdSyncNow";
import { postIntegrationsDirectCdiImportSyncsTestConnection } from "./integrationsDirectCdiImportSyncsTestConnection";
import { postIntegrationsDirectCdiInitializeMap } from "./integrationsDirectCdiInitializeMap";
import { getCdiJobSyncStatusSummary } from "./integrationsDirectCdiJobSyncStatusSummary";
import { getCdiJobs } from "./integrationsDirectCdiJobs";
import { getCdiJobById } from "./integrationsDirectCdiJobsJobId";
import { getCdiJobErrors } from "./integrationsDirectCdiJobsJobIdErrors";
import { postIntegrationsDirectCdiJobsJobIdErrorsRequestExport } from "./integrationsDirectCdiJobsJobIdErrorsRequestExport";
import { getCdiJobsSinkLogs } from "./integrationsDirectCdiJobsJobIdSinkLogs";
import { postIntegrationsDirectCdiJobsJobIdSinkLogsRequestExport } from "./integrationsDirectCdiJobsJobIdSinkLogsRequestExport";
import { getCdiSegmentsConfig } from "./integrationsDirectCdiSegmentsConfig";
import { getIntegrationsDirectCdiSnowflakeWifPrincipalAppGroupId } from "./integrationsDirectCdiSnowflakeWifPrincipalAppGroupId";
import { getIntegrationsDirectCdiSources, postIntegrationsDirectCdiSources } from "./integrationsDirectCdiSources";
import {
  deleteCdiSourcesConfig,
  patchIntegrationsDirectCdiSourcesSourceId,
} from "./integrationsDirectCdiSourcesSourceId";
import { getIntegrationsDirectCdiSourcesSourceIdDistinctColumnValues } from "./integrationsDirectCdiSourcesSourceIdDistinctColumnValues";
import { postIntegrationsDirectCdiSourcesSourceIdPreviewAndValidate } from "./integrationsDirectCdiSourcesSourceIdPreviewAndValidate";
import { postIntegrationsDirectCdiSourcesSourceIdRefreshSchemas } from "./integrationsDirectCdiSourcesSourceIdRefreshSchemas";
import { postIntegrationsDirectCdiSourcesSourceIdTestConnection } from "./integrationsDirectCdiSourcesSourceIdTestConnection";
import { postIntegrationsDirectCdiSourcesTestConnection } from "./integrationsDirectCdiSourcesTestConnection";
import { getIntegrationsDirectCdiValidationOverrides } from "./integrationsDirectCdiValidationOverrides";
import { getIntegrationsGetTechnologyPartnerData } from "./integrationsGetTechnologyPartnerData";
import { getIntegrationsGetTechnologyPartnersData } from "./integrationsGetTechnologyPartnersData";
import { getDataTableIntegrationsGetWhatsAppData } from "./integrationsGetWhatsAppData";
import { postIntegrationsScimScimDestroy } from "./integrationsScimScimDestroy";
import { postIntegrationsScimScimEditSettings } from "./integrationsScimScimEditSettings";
import { getIntegrationsScimScimInfo } from "./integrationsScimScimInfo";
import { postIntegrationsScimScimInstall } from "./integrationsScimScimInstall";
import { postIntegrationsScimScimResetToken } from "./integrationsScimScimResetToken";
import { getIntegrationsVoucherGroupIdAppGroupId } from "./integrationsVoucherGroupIdAppGroupId";
import { getDataTableIntegrationsVoucherGroups } from "./integrationsVoucherGroups";
import { postIntegrationsVoucherGroupsIdAppGroupIdUnusedVoucherCodesExport } from "./integrationsVoucherGroupsIdAppGroupIdUnusedVoucherCodesExport";
import { postIntegrationsVoucherGroupsTags } from "./integrationsVoucherGroupsTags";
import { postKnowledgeSourceDefinition } from "./knowledgeSourceDefinition";
import {
  deleteKnowledgeSourceDefinitionId,
  getKnowledgeSourceDefinitionId,
  postKnowledgeSourceDefinitionIdRefresh,
  postKnowledgeSourceDefinitionIdSearch,
  patchKnowledgeSourceDefinitionId,
} from "./knowledgeSourceDefinitionId";
import { getDataTableKnowledgeSourceDefinitions } from "./knowledgeSourceDefinitions";
import {
  deleteLegacyCatalogAccountFields,
  getLegacyCatalogAccountFields,
  postLegacyCatalogAccountFields,
} from "./legacyCatalogAccountFields";
import {
  deleteLegacyCatalogAccounts,
  postLegacyCatalogAccounts,
  putLegacyCatalogAccounts,
} from "./legacyCatalogAccounts";
import { getDataTableLegacyCatalogAccountsDatatable } from "./legacyCatalogAccountsDatatable";
import { getLineSubscriptionGroups } from "./lineSubscriptionGroups";
import {
  getFileList,
  getMediaLibrarySources,
  getMediaLibraryTags,
  getMediaLibraryTeams,
  postImageData,
  uploadFiles,
} from "./mediaLibrary";
import {
  getMessagingDiagnosticsCampaignsForFilter,
  getMessagingDiagnosticsCanvasesForFilter,
  getMessagingDiagnosticsCanvasStepsForFilter,
} from "./messagingDiagnosticsFilters";
import {
  getMilestoneChecklist,
  getMilestoneChecklistSettings,
  patchMilestoneChecklist,
  postMilestoneChecklist,
} from "./milestoneChecklist";
import { getOAuthApplicationData } from "./oauthApplicationsClientId";
import { postOAuthAuthorize } from "./oauthAuthorize";
import { getOAuthValidateAuthorizationRequest } from "./oauthValidateAuthorizationRequest";
import { getOAuthValidateDeveloperPermissions } from "./oauthValidateDeveloperPermissions";
import { getOAuthValidateScopes } from "./oauthValidateScopes";
import { getOfferfitAppGroupIdGetPrimaryKpi } from "./offerfitAppGroupIdGetPrimaryKpi";
import { getDataTableOfferfitAppGroupIdUseCases } from "./offerfitAppGroupIdUseCases";
import { getOfferfitAppGroupIdUseCasesUseCaseId } from "./offerfitAppGroupIdUseCasesUseCaseId";
import { getOfferfitAppGroupIdUseCasesUseCaseIdCampaignData } from "./offerfitAppGroupIdUseCasesUseCaseIdCampaignData";
import { getOfferfitAppGroupIdUseCasesUseCaseIdToken } from "./offerfitAppGroupIdUseCasesUseCaseIdToken";
import { getOfferfitAppGroupIdUseCasesUseCaseIdUnpromotedCustomerChanges } from "./offerfitAppGroupIdUseCasesUseCaseIdUnpromotedCustomerChanges";
import { getOpenAiRateLimitStats } from "./openAi";
import {
  deleteProductAlert,
  getProductAlert,
  getProductAlerts,
  patchProductAlert,
  postProductAlert,
  putProductAlert,
} from "./productAlerts";
import { getProductAlertOverrides, putProductAlertOverridesAlertIdCanvasId } from "./productAlertOverrides";
import { getPurchaseNames } from "./purchaseNames";
import { getRecentInteractions } from "./recentInteractions";
import { getRecentlyVisited } from "./recentlyVisited";
import { postRecentlyVisitedVisit } from "./recentlyVisitedVisit";
import { remoteLookupFindFetchers, remoteLookupSearchFetchers } from "./remoteLookup";
import { postReportingAppGroupIdMetricsQuery } from "./reportingAppGroupIdMetricsQuery";
import { getResourcesProductboardAuth } from "./resourcesProductboardAuth";
import { getDataTableSdkDebuggerAppGroupIdAll } from "./sdkDebuggerAppGroupIdAll";
import { putSdkDebuggerDocument } from "./sdkDebuggerDocument";
import { getSdkDebuggerRecordingId } from "./sdkDebuggerRecordingId";
import { getSdkDebuggerRecordingIdLogs } from "./sdkDebuggerRecordingIdLogs";
import { putSdkDebuggerRecordingIdStop } from "./sdkDebuggerRecordingIdStop";
import { getGlobalSearch } from "./search";
import { getMessagingServices as getSmsMessagingServices } from "./smsConfiguration";
import { getDataTableSmsMmsConsumption } from "./smsMmsConsumption";
import { postStartCsvImport } from "./startCsvImport";
import { getSubscriptionGroupAnalytics } from "./subscriptionGroupAnalytics";
import { postSupportCasesAppGroupId } from "./supportCasesAppGroupId";
import { getTeamData } from "./teamData";
import { getTeamMembersData } from "./teamMembersData";
import { getTeamsPermissions } from "./teams";
import { getTeamsData } from "./teamsData";
import type { VerifyDashboardApiEndpointDefinitions } from "./types";
import { getUserEventHistory, requestUserEventHistory } from "./userEventHistory";
import { getUserRecentEventHistory } from "./userRecentEventHistory";
import { getUsersPreferenceCenter, postUsersPreferenceCenter } from "./usersPreferenceCenter";
import { getUsersPreferenceCenterSelect } from "./usersPreferenceCenterSelect";
import { getUsersPreferenceCenters } from "./usersPreferenceCenters";
import { getUsersSmsSubscriptionGroupsForFilter } from "./usersSmsSubscriptionGroupsForFilter";
import { postwsUsersSubscriptionGroupCurrentDayStatsSubscriptionGroupId } from "./usersSubscriptionGroupCurrentDayStatsSubscriptionGroupId";
import { getUsersSubscriptionGroupData } from "./usersSubscriptionGroupData";
import { getUsersSubscriptionGroupDoubleOptInEnabled } from "./usersSubscriptionGroupDoubleOptInEnabled";
import { getUsersSubscriptionGroupStats } from "./usersSubscriptionGroupStats";
import { getSubscriptionGroupsData } from "./usersSubscriptionGroupsData";
import { postUsersSubscriptionGroupsId } from "./usersSubscriptionGroupsId";
import { postUsersSubscriptionGroupsUpdateArchivedStateId } from "./usersSubscriptionGroupsUpdateArchivedStateId";
import { getUsersSubscriptionGroupsUsageId } from "./usersSubscriptionGroupsUsageId";
import { getWebhookMessageTemplates } from "./webhookMessageTemplates";
import { getDataTableWhatsAppConsumption } from "./whatsAppConsumption";
import { getWhatsAppSubscriptionGroups } from "./whatsAppSubscriptionGroups";
import { getWhatsAppFlowDetails, getWhatsAppFlowList } from "./whatsappFlows";
import { getWhatsAppMessageTemplates } from "./whatsappMessageTemplates";
import { getWhatsAppMessagingServices } from "./whatsappMessagingServices";
import { getWhatsAppMetaScopes } from "./whatsappMetaScopes";
import { getWhatsAppProductData } from "./whatsappProductData";
/**
 * Define dashboard API endpoints here.
 *
 * Each endpoint should be defined using the absolute path of the API as the top-level key.
 * Inside, the structure is:
 *
 * ```
 * "/path/to/api": {
 *   PUT?: (...argsForEndpoint) => Promise<EndpointResult>
 *   GET?: (...argsForEndpoint) => Promise<EndpointResult>
 *   POST?: (...argsForEndpoint) => Promise<EndpointResult>
 *   PATCH?: (...argsForEndpoint) => Promise<EndpointResult>
 *   DELETE?: (...argsForEndpoint) => Promise<EndpointResult>
 * }
 * ```
 *
 * By convention, APIs that accept parameters should enclose them in in {curly brackets}.
 * For example, if the API varies based on app ID, then `{appId}` should be used in the API path.
 *
 * This shape is validated by the `DashboardApiEndpointDefinitions` type defined in `types.ts`
 *
 * To consume these endpoints, use the `useDashboardApi` hook provided in "@services/useDashboardApi"
 *
 * # Declaring endpoint fetcher functions
 *
 * For GET fetcher functions, use the `reactQueryFetcherAdapter` function
 *
 * ```
 * import fetch from "@lib/fetch";
 * import { cacheKey } from "./constants";
 * import { ChangelogResponse } from "./types";
 * import { reactQueryFetcherAdapter } from "../reactQueryFetcherAdapters";
 *
 * export const getChangelogs = reactQuer yFetcherAdapter(
 *   cacheKey,
 *   async (
 *     signal,
 *     { configurationId, type }: { configurationId: string; type: string }
 *   ): Promise<ChangelogResponse> => {
 *     const data = {
 *       type,
 *       id: configurationId,
 *     };
 *     return await fetch("/engagement/get_changelogs", "GET", data, { signal });
 *   }
 * );
 * ```
 *
 * @example
 * // consuming the endpoint
 * import { useDashboardApiQuery } from "@services/useDashboardApi";
 *
 * export const useSimpleExample = () => {
 *   return useDashboardApiQuery("/engagement/get_changelogs");
 * }
 *
 * @example
 * // consuming a mutation fetcher function
 * import { useDashboardApiMutation } from "@services/useDashboardApi";
 *
 * export const useSimpleExample = () => {
 *   return useDashboardApiMutation("/engagement/get_changelogs");
 * }
 *
 * @example
 * // for endpoints that accept parameters
 * import { useDashboardApiQuery } from "@services/useDashboardApi";
 *
 * export const useAcceptsParameters = (appId: string) => {
 *   return useDashboardApiQuery("/engagement/get_changelogs", {
 *     params: [appId]
 *   });
 * });
 *
 * @example
 * // passing options to react-query
 * import { useDashboardApiQuery } from "@services/useDashboardApi";
 *
 * export const useAcceptsParameters = (appId: string) => {
 *   return useDashboardApiQuery("/engagement/get_changelogs", {
 *     params: [appId],
 *     options: {
 *       select: ({ changelog_items: changelogItems }) => normalizeResponse(changelogItems),
 *     },
 *   });
 * });
 *
 * @example
 * // declaring an API endpoint
 * "/apps/{appId}/sdk_authentication_settings": {
 *   cacheKey: sdkAuthCacheKey,
 *   endpoints: {
 *     GET: getSdkAuthSettings,
 *     PUT: putSdkAuthSettings,
 *   },
 * },
 */
export const dashboardApiEndpoints = makeDashboardApiEndpoints({
  "/:app_group_id/braze_docs/fallback_search": { POST: postAppGroupIdBrazeDocsFallbackSearch },
  "/:app_group_id/braze_docs/lookup": { POST: postAppGroupIdBrazeDocsLookup },
  "/:app_group_id/braze_docs/search": { POST: postAppGroupIdBrazeDocsSearch },
  "/:app_group_id/braze_mcp/call_tool": { POST: postAppGroupIdBrazeMcpCallTool },
  "/:app_group_id/braze_mcp/tools": { GET: getAppGroupIdBrazeMcpTools },
  "/:app_group_id/campaign/:campaign_id/copy/:target_app_group_id": { POST: postCampaignCopy },
  "/:app_group_id/campaign/:campaign_id/message/:message_variation_id": { GET: getCampaignMessageVariation },
  "/:app_group_id/campaign_brief/:campaign_id": {
    DELETE: deleteCampaignBrief,
    GET: getCampaignBrief,
    PUT: putCampaignBrief,
  },
  "/:app_group_id/campaign_qa_runs/:campaign_id": {
    DELETE: deleteCampaignQaRun,
    GET: getCampaignQaRun,
    PUT: putCampaignQaRun,
  },
  "/:app_group_id/canvas/:workflow_id/copy/:target_app_group_id": { POST: postCanvasCopy },
  "/:app_group_id/canvas/:workflow_id/step": { POST: postCanvasStep },
  "/:app_group_id/canvas/:workflow_id/step/:step_id": { GET: getCanvasStep, PATCH: patchCanvasStep },
  "/:app_group_id/canvas/:workflow_id/step/:step_id/message": { POST: postMessage },
  "/:app_group_id/canvas/:workflow_id/step/:step_id/message/:message_variation_id": {
    DELETE: deleteMessage,
    GET: getMessage,
    PUT: putMessage,
  },
  "/:app_group_id/canvas/:workflow_id/step/:step_id/messages": { GET: getMessages },
  "/:app_group_id/canvas/:workflow_id/step/:step_id/name": { PATCH: patchCanvasStepName },
  "/:app_group_id/canvas/:workflow_id/step/:step_id/position": { PATCH: patchCanvasStepPosition },
  "/:app_group_id/canvas/:workflow_id/steps/position": { PATCH: patchCanvasStepsPosition },
  "/:app_group_id/canvas_brief/:canvas_id": {
    DELETE: deleteCanvasBrief,
    GET: getCanvasBrief,
    PUT: putCanvasBrief,
  },
  "/:app_group_id/canvas_qa_runs/:canvas_id": {
    DELETE: deleteCanvasQaRun,
    GET: getCanvasQaRun,
    PUT: putCanvasQaRun,
  },
  "/:app_group_id/compare_previews_ai": { POSTWS: postwsAppGroupIdComparePreviewsAi },
  "/:app_group_id/conversational/conversations/:history_type": { GET: getDataTableConversationHistory },
  "/:app_group_id/conversational/conversations/:history_type/:session_id": { GET: getConversationHistoryDetail },
  "/:app_group_id/conversational/inbound_message_triggers": { GET: getConversationalInboundMessageTriggers },
  "/:app_group_id/conversational/preview_message_history": { GET: getConversationalPreviewMessageHistory },
  "/:app_group_id/conversational/preview_settings": { POST: postConversationalPreviewSettings },
  "/:app_group_id/conversational/preview_settings/workflows": { GET: getConversationalPreviewSettingsWorkflows },
  "/:app_group_id/conversational/preview_workflow": { POST: postConversationalPreviewWorkflow },
  "/:app_group_id/conversational/reply_routing": { GET: getConversationalReplyRouting },
  "/:app_group_id/conversational/settings": { GET: getConversationalSettings, PUT: putConversationalSettings },
  "/:app_group_id/conversational/simulation/cases": { GET: getSimulationCases, POST: postSimulationCase },
  "/:app_group_id/conversational/simulation/cases/:id": {
    DELETE: deleteSimulationCase,
    GET: getSimulationCase,
    PUT: putSimulationCase,
  },
  "/:app_group_id/conversational/simulation/runs": { GET: getSimulationRuns, POST: postSimulationRun },
  "/:app_group_id/conversational/simulation/runs/:id": { GET: getSimulationRun },
  "/:app_group_id/conversational/simulation/webhooks": { GET: getSimulationWebhooks },
  "/:app_group_id/conversational/tags": { GET: getConversationalTags },
  "/:app_group_id/conversational/territories": { GET: getConversationalTerritories },
  "/:app_group_id/conversational/test_webhook": { POST: postConversationalTestWebhook },
  "/:app_group_id/conversational/tool_definition": { POST: postConversationalToolDefinition },
  "/:app_group_id/conversational/tool_definition/:id": {
    DELETE: deleteConversationalToolDefinitionId,
    GET: getConversationalToolDefinitionId,
    PUT: putConversationalToolDefinitionId,
  },
  "/:app_group_id/conversational/tool_definitions": { GET: getDataTableConversationalToolDefinitions },
  "/:app_group_id/conversational/workflow": { POST: postConversationalWorkflow },
  "/:app_group_id/conversational/workflow/:id": {
    DELETE: deleteConversationalWorkflow,
    GET: getConversationalWorkflow,
    PUT: putConversationalWorkflow,
  },
  "/:app_group_id/conversational/workflows": { GET: getDataTableConversationalWorkflows },
  "/:app_group_id/figma/file_nodes": { POST: postAppGroupIdFigmaFileNodes },
  "/:app_group_id/figma/images": { POST: postAppGroupIdFigmaImages },
  "/:app_group_id/figma/oauth/disconnect": { DELETE: deleteAppGroupIdFigmaOauthDisconnect },
  "/:app_group_id/figma/oauth/status": { GET: getAppGroupIdFigmaOauthStatus },
  "/:app_group_id/generate_image": { POSTWS: postwsAppGroupIdGenerateImage },
  "/:app_group_id/generative_ai/agent/preview": { POSTWS: postwsGenerativeAiAppGroupIdAgentPreview },
  "/:app_group_id/generative_ai/agents/campaign_qa": { GET: getGenerativeAiAgentsCampaignQa },
  "/:app_group_id/generative_ai/agents/canvas_qa": { GET: getGenerativeAiAgentsCanvasQa },
  "/:app_group_id/generative_ai/brand_guidelines_evaluation": {
    POSTWS: postwsGenerativeAiAppGroupIdBrandGuidelinesEvaluation,
  },
  "/:app_group_id/generative_ai/brand_guidelines_synthesis": {
    POSTWS: postwsGenerativeAiAppGroupIdBrandGuidelinesSynthesis,
  },
  "/:app_group_id/generative_ai/brand_guidelines_test_generation": {
    POSTWS: postwsGenerativeAiAppGroupIdBrandGuidelinesTestGeneration,
  },
  "/:app_group_id/generative_ai/campaign_qa": { POSTWS: postwsGenerativeAiAppGroupIdCampaignQa },
  "/:app_group_id/generative_ai/campaign_qa/cancel": { POST: postGenerativeAiAppGroupIdCampaignQaCancel },
  "/:app_group_id/generative_ai/canvas_qa": { POSTWS: postwsGenerativeAiAppGroupIdCanvasQa },
  "/:app_group_id/generative_ai/canvas_qa/cancel": { POST: postGenerativeAiAppGroupIdCanvasQaCancel },
  "/:app_group_id/generative_ai/gpt_assistant": { POSTWS: postwsGenerativeAiAppGroupIdGptAssistant },
  "/:app_group_id/generative_ai/standards_ruleset_synthesis": {
    POSTWS: postwsGenerativeAiAppGroupIdStandardsRulesetSynthesis,
  },
  "/:app_group_id/generative_ai/standards_ruleset_synthesis_usage": {
    GET: getGenerativeAiStandardsRulesetSynthesisUsage,
  },
  "/:app_group_id/generative_ai/standards_run_history": { GET: getGenerativeAiStandardsRunHistory },
  "/:app_group_id/generative_ai/standards_run_usage": { GET: getGenerativeAiStandardsRunUsage },
  "/:app_group_id/generative_ai/variant_generation_assistant": {
    POSTWS: postwsGenerativeAiAppGroupIdVariantGenerationAssistant,
  },
  "/:app_group_id/knowledge_source/definition": {
    POST: postKnowledgeSourceDefinition,
  },
  "/:app_group_id/knowledge_source/definition/:id": {
    DELETE: deleteKnowledgeSourceDefinitionId,
    GET: getKnowledgeSourceDefinitionId,
    PATCH: patchKnowledgeSourceDefinitionId,
  },
  "/:app_group_id/knowledge_source/definition/:id/refresh": {
    POST: postKnowledgeSourceDefinitionIdRefresh,
  },
  "/:app_group_id/knowledge_source/definition/:id/search": {
    POST: postKnowledgeSourceDefinitionIdSearch,
  },
  "/:app_group_id/knowledge_source/definitions": {
    GET: getDataTableKnowledgeSourceDefinitions,
  },
  "/:app_group_id/liquid_validation/check_syntax": { POST: postAppGroupIdLiquidValidationCheckSyntax },
  "/:app_group_id/liquid_validation/features": { GET: getAppGroupIdLiquidValidationFeatures },
  "/:app_group_id/messaging_diagnostics/campaigns_for_filter": {
    GET: getMessagingDiagnosticsCampaignsForFilter,
  },
  "/:app_group_id/messaging_diagnostics/canvas_steps_for_filter": {
    GET: getMessagingDiagnosticsCanvasStepsForFilter,
  },
  "/:app_group_id/messaging_diagnostics/canvases_for_filter": {
    GET: getMessagingDiagnosticsCanvasesForFilter,
  },
  "/:app_group_id/messaging_diagnostics/send_outcomes_abort_log": {
    GET: getDataTableEngagementSendOutcomesAbortLogData,
  },
  "/:app_group_id/operator_mcp_connections": {
    GET: getAppGroupIdOperatorMcpConnections,
    POST: postAppGroupIdOperatorMcpConnections,
  },
  "/:app_group_id/operator_mcp_connections/:connection_id": {
    DELETE: deleteAppGroupIdOperatorMcpConnectionsConnectionId,
  },
  "/:app_group_id/operator_mcp_connections/:connection_id/call_tool": {
    POST: postAppGroupIdOperatorMcpConnectionsConnectionIdCallTool,
  },
  "/:app_group_id/operator_mcp_connections/:connection_id/tokens": {
    DELETE: deleteAppGroupIdOperatorMcpConnectionsConnectionIdTokens,
  },
  "/:app_group_id/operator_mcp_connections/tools": { GET: getAppGroupIdOperatorMcpConnectionsTools },
  "/:app_group_id/playwright/scan_a11y": { GET: getAppGroupIdPlaywrightScanA11y },
  "/account_settings/notification_subscriptions": {
    GET: getNotificationSubscriptions,
  },
  "/admin/get_impersonation_logs": { GET: getAdminGetImpersonationLogs },
  "/admin/impersonate": { POST: postAdminImpersonate },
  "/admin/impersonation": { GET: getAdminImpersonation },
  "/admin/impersonation_capabilities": { GET: getAdminImpersonationCapabilities },
  "/admin/request_impersonation": { POST: postAdminRequestImpersonation },
  "/ai_agent/async_dynamic_prompts/:app_group_id": { POSTWS: postwsAiAgentAsyncDynamicPromptsAppGroupId },
  "/ai_agent/gemini_interactions/:app_group_id": { POST: postAiAgentGeminiInteractionsAppGroupId },
  "/ai_agent/openai_responses/:app_group_id": { POST: postAiAgentOpenaiResponsesAppGroupId },
  "/alloys/:partner/attribution/:app_group_id": {
    DELETE: deleteAlloysPartnerAttributionAppGroupId,
    GET: getAlloysPartnerAttributionAppGroupId,
    POST: postAlloysPartnerAttributionAppGroupId,
  },
  "/alloys/:partner/cohort_import/:app_group_id": {
    GET: getAlloysPartnerCohortImportAppGroupId,
    POST: postAlloysPartnerCohortImportAppGroupId,
  },
  "/alloys/:provider/agentic/:app_group_id": {
    DELETE: deleteAlloysProviderAgenticAppGroupId,
    GET: getAlloysProviderAgenticAppGroupId,
    POST: postAlloysProviderAgenticAppGroupId,
  },
  "/alloys/adjust/custom_events/:app_group_id": {
    GET: getAlloysAdjustCustomEventsAppGroupId,
    POST: postAlloysAdjustCustomEventsAppGroupId,
  },
  "/alloys/adjust/custom_events/:app_group_id/disconnect": {
    DELETE: deleteAlloysAdjustCustomEventsAppGroupIdDisconnect,
  },
  "/alloys/amazon-bedrock/agentic/:app_group_id/external_id": {
    DELETE: deleteAlloysAmazonBedrockAgenticExternalId,
    GET: getAlloysAmazonBedrockAgenticExternalId,
    POST: postAlloysAmazonBedrockAgenticExternalId,
  },
  "/alloys/gemini/agentic/:app_group_id/oauth/connect": {
    POST: postAlloysGeminiAgenticAppGroupIdOauthConnect,
  },
  "/alloys/gemini/agentic/:app_group_id/oauth/disconnect": {
    DELETE: deleteAlloysGeminiAgenticAppGroupIdOauthDisconnect,
  },
  "/alloys/gemini/agentic/:app_group_id/oauth/projects": {
    GET: getAlloysGeminiAgenticAppGroupIdOauthProjects,
  },
  "/alloys/gemini/agentic/:app_group_id/oauth/select_project": {
    POST: postAlloysGeminiAgenticAppGroupIdOauthSelectProject,
  },
  "/alloys/gemini/agentic/:app_group_id/oauth/verify_project": {
    GET: getAlloysGeminiAgenticAppGroupIdOauthVerifyProject,
  },
  "/alloys/integrations/:integration_id/bridge": { GET: getAlloysIntegrationsIntegrationIdBridge },
  "/alloys/partners/:alloys_id": { GET: getAlloysPartnersAlloysId },
  "/alloys/partners/datadog/:app_group_id": {
    DELETE: deleteAlloysPartnersDatadogAppGroupId,
    GET: getAlloysPartnersDatadogAppGroupId,
    POST: postAlloysPartnersDatadogAppGroupId,
  },
  "/alloys/partners/google-postmaster/:app_group_id": {
    DELETE: deleteAlloysPartnersGooglePostmasterAppGroupId,
    GET: getAlloysPartnersGooglePostmasterAppGroupId,
  },
  "/alloys/partners/google-postmaster/:app_group_id/connect": {
    POST: postAlloysPartnersGooglePostmasterAppGroupIdConnect,
  },
  "/alloys/partners/shopify/:app_group_id/bridges": { GET: getAlloysPartnersShopifyAppGroupIdBridges },
  "/alloys/partners/shopify/:app_group_id/bridges/:bridge_id": {
    DELETE: deleteAlloysPartnersShopifyAppGroupIdBridgesBridgeId,
    GET: getAlloysPartnersShopifyAppGroupIdBridgesBridgeId,
    PATCH: patchAlloysPartnersShopifyAppGroupIdBridgesBridgeId,
  },
  "/alloys/partners/shopify/:app_group_id/bridges/:bridge_id/app_embed": {
    GET: getAlloysPartnersShopifyAppGroupIdBridgesBridgeIdAppEmbed,
  },
  "/alloys/partners/shopify/:app_group_id/bridges/:bridge_id/backfill_estimates": {
    GET: getAlloysPartnersShopifyAppGroupIdBridgesBridgeIdBackfillEstimates,
  },
  "/alloys/partners/shopify/:app_group_id/bridges/:bridge_id/catalog/item_error_count": {
    GET: getAlloysPartnersShopifyAppGroupIdBridgesBridgeIdCatalogItemErrorCount,
  },
  "/alloys/partners/shopify/:integration_id/fetch_collections": {
    GET: getAlloysPartnersShopifyFetchCollections,
  },
  "/alloys/partners/shopify/:integration_id/fetch_customer_metafields": {
    GET: getAlloysPartnersShopifyIntegrationIdFetchCustomerMetafields,
  },
  "/alloys/partners/shopify/:integration_id/fetch_markets": {
    GET: getAlloysPartnersShopifyFetchMarkets,
  },
  "/alloys/partners/shopify/:integration_id/fetch_product_metafields": {
    GET: getAlloysPartnersShopifyIntegrationIdFetchProductMetafields,
  },
  "/alloys/partners/shopify/:integration_id/fetch_product_tags": {
    GET: getAlloysPartnersShopifyFetchProductTags,
  },
  "/alloys/partners/shopify/:integration_id/fetch_segments": {
    GET: getAlloysPartnersShopifyFetchSegments,
  },
  "/alloys/partners/shopify/breaking_changes_export": { POST: postAlloysPartnersAlloysIdBreakingChangesExport },
  "/alloys/shopify/:app_group_id/bridges/:bridge_id/catalog_item_errors_export": {
    POST: postAlloysShopifyAppGroupIdBridgesBridgeIdCatalogItemErrorsExport,
  },
  "/alloys/shopify/:app_group_id/bridges/:bridge_id/catalog_resync": {
    POST: postAlloysShopifyAppGroupIdBridgesBridgeIdCatalogResync,
  },
  "/alloys/zendesk-sunshine/:app_group_id": {
    GET: getAlloysZendeskSunshineAppGroupId,
    POST: postAlloysZendeskSunshineAppGroupId,
  },
  "/analytics_dashboard/:app_group_id/agent_console_credit_consumption_detail_data": {
    GET: getDataTableAgentConsoleConsumption,
  },
  "/analytics_dashboard/:app_group_id/audience_sync_credit_consumption_detail_data": {
    GET: getDataTableAudienceSyncConsumption,
  },
  "/analytics_dashboard/:app_group_id/banners_credit_consumption_detail_data": {
    GET: getDataTableBannersConsumption,
  },
  "/analytics_dashboard/:app_group_id/campaign_canvas_credit_consumption_detail_data": {
    GET: getDataTableCampaignCanvasConsumption,
  },
  "/analytics_dashboard/:app_group_id/content_cards_credit_consumption_detail_data": {
    GET: getDataTableContentCardsConsumption,
  },
  "/analytics_dashboard/:app_group_id/credit_consumption_data": {
    GET: getAnalyticsDashboardAppGroupIdCreditConsumptionData,
  },
  "/analytics_dashboard/:app_group_id/credit_consumption_time_period_data": {
    GET: getAnalyticsDashboardAppGroupIdCreditConsumptionTimePeriodData,
  },
  "/analytics_dashboard/:app_group_id/credit_ratios_detail_data": {
    GET: getDataTableCreditRatios,
  },
  "/analytics_dashboard/:app_group_id/decisioning_studio_agents_credit_consumption_detail_data": {
    GET: getDataTableDecisioningStudioAgentsConsumption,
  },
  "/analytics_dashboard/:app_group_id/email_credit_consumption_detail_data": {
    GET: getDataTableEmailConsumption,
  },
  "/analytics_dashboard/:app_group_id/email_engagement_by_device_class_data": {
    GET: getAnalyticsDashboardAppGroupIdEmailEngagementByDeviceClassData,
  },
  "/analytics_dashboard/:app_group_id/email_engagement_by_providers_data": {
    GET: getAnalyticsDashboardAppGroupIdEmailEngagementByProvidersData,
    POST: postAnalyticsDashboardAppGroupIdEmailEngagementByProvidersData,
  },
  "/analytics_dashboard/:app_group_id/email_engagement_by_time_data": {
    GET: getAnalyticsDashboardAppGroupIdEmailEngagementByTimeData,
  },
  "/analytics_dashboard/:app_group_id/get_campaigns_for_filter": {
    GET: getAnalyticsDashboardAppGroupIdGetCampaignsForFilter,
  },
  "/analytics_dashboard/:app_group_id/get_canvases_for_filter": {
    GET: getAnalyticsDashboardAppGroupIdGetCanvasesForFilter,
  },
  "/analytics_dashboard/:app_group_id/kakao_credit_consumption_detail_data": {
    GET: getDataTableKakaoConsumption,
  },
  "/analytics_dashboard/:app_group_id/line_credit_consumption_detail_data": {
    GET: getDataTableLineConsumption,
  },
  "/analytics_dashboard/:app_group_id/message_archiving_credit_consumption_detail_data": {
    GET: getDataTableMessageArchivingConsumption,
  },
  "/analytics_dashboard/:app_group_id/sms_credit_consumption_detail_data": { GET: getDataTableSmsMmsConsumption },
  "/analytics_dashboard/:app_group_id/webhooks_credit_consumption_detail_data": {
    GET: getDataTableWebhooksConsumption,
  },
  "/analytics_dashboard/:app_group_id/whats_app_credit_consumption_detail_data": {
    GET: getDataTableWhatsAppConsumption,
  },
  "/api/calculated_attributes/:app_group_id": {
    GET: getApiCalculatedAttributesAppGroupId,
    POST: postApiCalculatedAttributesAppGroupId,
  },
  "/api/calculated_attributes/:app_group_id/deactivate": {
    POST: postApiCalculatedAttributesAppGroupIdDeactivate,
  },
  "/api/calculated_attributes/:app_group_id/reactivate": {
    POST: postApiCalculatedAttributesAppGroupIdReactivate,
  },
  "/api/calculated_attributes/:app_group_id/tags": {
    GET: getApiCalculatedAttributesAppGroupIdTags,
  },
  "/api/calculated_attributes/:id/:app_group_id": {
    GET: getApiCalculatedAttributesIdAppGroupId,
    PUT: putApiCalculatedAttributesIdAppGroupId,
  },
  "/api/calculated_attributes/:id/:app_group_id/engagements": {
    GET: getApiCalculatedAttributesIdAppGroupIdEngagements,
  },
  "/api/calculated_attributes/:id/:app_group_id/refresh": {
    POST: postApiCalculatedAttributesIdAppGroupIdRefresh,
  },
  "/api/calculated_attributes/:id/:app_group_id/user_lookup": {
    GET: getApiCalculatedAttributesIdAppGroupIdUserLookup,
  },
  "/api/calculated_filters/:app_group_id": {
    GET: getApiCalculatedFiltersAppGroupId,
    POST: postApiCalculatedFiltersAppGroupId,
  },
  "/api/calculated_filters/:app_group_id/archive": {
    PATCH: patchApiCalculatedFiltersAppGroupIdArchive,
  },
  "/api/calculated_filters/:app_group_id/unarchive": {
    PATCH: patchApiCalculatedFiltersAppGroupIdUnarchive,
  },
  "/api/calculated_filters/:id/:app_group_id": {
    GET: getApiCalculatedFiltersIdAppGroupId,
    PUT: putApiCalculatedFiltersIdAppGroupId,
  },
  "/api/calculated_filters/:id/:app_group_id/engagements": { GET: getApiCalculatedFiltersIdAppGroupIdEngagements },
  "/api/calculated_filters/:id/:app_group_id/refresh": {
    POST: postApiCalculatedFiltersIdAppGroupIdRefresh,
  },
  "/api/ecommerce/event_properties": {
    GET: getApiEcommerceEventProperties,
  },
  "/api/ecommerce/recommended_events": {
    GET: getApiEcommerceRecommendedEvents,
  },
  "/api_usage_alert/:alert_id": { DELETE: deleteApiUsageAlert },
  "/api_usage_alert/datatable": { GET: getApiUsageAlertDatatable },
  "/api_usage_alert/upsert": { POST: postApiUsageAlertUpsert },
  "/app/braze_dashboard_config": { GET: getAppBrazeDashboardConfig },
  "/app_groups/:app_group_id/banner_priority": {
    GET: getAppGroupsAppGroupIdBannerPriority,
    POST: postAppGroupsAppGroupIdBannerPriority,
  },
  "/app_groups/:app_group_id/placements": {
    GET: getDataTableAppGroupsAppGroupIdPlacements,
    POST: postAppGroupsAppGroupIdPlacements,
  },
  "/app_groups/:app_group_id/placements/:id": {
    GET: getAppGroupsAppGroupIdPlacementsId,
    PATCH: patchAppGroupsAppGroupIdPlacementsId,
  },
  "/app_groups/:app_group_id/placements/:id/preview": {
    GET: getAppGroupsAppGroupIdPlacementsIdPreview,
  },
  "/app_groups/:app_group_id/placements/update_archived_state": {
    POST: postAppGroupsAppGroupIdPlacementsUpdateArchivedState,
  },
  "/app_settings/:app_group_id/api_keys/:api_key_id/metadata": {
    GET: getAppSettingsAppGroupIdApiKeysApiKeyIdMetadata,
  },
  "/app_settings/:app_group_id/message_prioritization/categories_data": {
    GET: getMessagePrioritizationCategoriesData,
  },
  "/app_settings/:app_group_id/message_prioritization/category": { POST: postMessagePrioritizationCategory },
  "/app_settings/:app_group_id/message_prioritization/category/:category_id": {
    DELETE: deleteMessagePrioritizationCategory,
  },
  "/app_settings/:app_group_id/message_prioritization/category/:category_id/dependencies": {
    GET: getMessagePrioritizationCategoryDependencies,
  },
  "/app_settings/:app_group_id/message_prioritization/frequency_capping_coverage": {
    GET: getMessagePrioritizationFrequencyCappingCoverage,
  },
  "/app_settings/:app_group_id/message_prioritization/has_frequency_capping_rules": {
    GET: getMessagePrioritizationHasFrequencyCappingRules,
  },
  "/app_settings/:app_group_id/message_prioritization/rules": { POST: postMessagePrioritizationRules },
  "/app_settings/:app_group_id/message_prioritization/rules/validation": {
    POST: postMessagePrioritizationRulesValidation,
  },
  "/app_settings/:app_group_id/message_prioritization/rules_data": { GET: getMessagePrioritizationRulesData },
  "/app_settings/:app_group_id/quiet_hours/rules": {
    GET: getAppSettingsAppGroupIdQuietHoursRulesData,
    POST: postAppSettingsAppGroupIdQuietHoursRules,
  },
  "/app_settings/all_tags": { GET: getAppSettingsAllTags },
  "/app_settings/allowed_territories_for_developer_for_company": {
    GET: getTeamsPermissions,
  },
  "/app_settings/api_key_details/:api_key": { GET: getApiKeyDetails },
  "/app_settings/api_settings_info_datatable(/:app_group_id)": {
    GET: getDataTableAppSettingsApiSettingsInfoDatatableAppGroupId,
  },
  "/app_settings/app_identifiers(/:app_group_id)": { GET: getDataTableAppSettingsAppIdentifiers },
  "/app_settings/authentication_credential/create": { POST: postAppSettingsAuthenticationCredentialCreate },
  "/app_settings/authentication_credential/delete": { POST: postAppSettingsAuthenticationCredentialDelete },
  "/app_settings/authentication_credential/edit": { POST: postAppSettingsAuthenticationCredentialEdit },
  "/app_settings/authentication_credentials": { GET: getAuthenticationCredentials },
  "/app_settings/authentication_credentials/:id/usages": { GET: getAuthenticationCredentialUsages },
  "/app_settings/compute_custom_attribute_usage": { POST: postAppSettingsComputeCustomAttributeUsage },
  "/app_settings/create_api_key": { POST: postAppSettingsCreateApiKey },
  "/app_settings/custom_attribute_schema": {
    PATCH: patchAppSettingsCustomAttributeSchema,
    POST: postAppSettingsCustomAttributeSchema,
  },
  "/app_settings/custom_attribute_usage": { GET: getAppSettingsCustomAttributeUsage },
  "/app_settings/custom_attributes_data": { GET: getDataTableAppSettingsCustomAttributesData },
  "/app_settings/custom_attributes_tags": { GET: getAppSettingsCustomAttributesTags },
  "/app_settings/custom_attributes_values": { GET: getCustomAttributesValues },
  "/app_settings/custom_data_export": { POST: postAppSettingsCustomDataExport },
  "/app_settings/custom_event_property_schema": { POST: postAppSettingsCustomEventPropertySchema },
  "/app_settings/custom_event_usage": { GET: getAppSettingsCustomEventUsage },
  "/app_settings/custom_events_data": { GET: getDataTableAppSettingsCustomEventsData },
  "/app_settings/custom_events_tags": { GET: getAppSettingsCustomEventsTags },
  "/app_settings/delete_api_key/:api_key": { PUT: putAppSettingsDeleteApiKey },
  "/app_settings/get_custom_event_properties": { GET: getAppSettingsGetCustomEventProperties },
  "/app_settings/get_territories_with_filters": { GET: getAppSettingsGetTerritoriesWithFilters },
  "/app_settings/message_activity_messages": { GET: getDataTableAppSettingsMessageActivityMessages },
  "/app_settings/objects_using_custom_attributes": { GET: getAppSettingsObjectsUsingCustomAttributes },
  "/app_settings/objects_using_custom_events": { GET: getAppSettingsObjectsUsingCustomEvents },
  "/app_settings/objects_using_products": { GET: getAppSettingsObjectsUsingProducts },
  "/app_settings/products_data": { GET: getDataTableAppSettingsProductsData },
  "/app_settings/segmentable_property_usage": { GET: getAppSettingsSegmentablePropertyUsage },
  "/app_settings/tag_delete": { POST: deleteAppSettingsTag },
  "/app_settings/tag_upsert": { POST: upsertAppSettingsTag },
  "/app_settings/tags_data": { GET: getDataTableAppSettingsTagsData },
  "/app_settings/territories_data": { GET: getTeamsData },
  "/app_settings/territories_data/:id": { GET: getTeamData },
  "/app_settings/territories_data/:id/members": { GET: getTeamMembersData },
  "/app_settings/test_user_logs": { GET: dataTableAppSettingsTestUserLogs },
  "/app_settings/test_user_logs/search_terms": { GET: getAppSettingsTestUserLogsSearchTerms },
  "/apps/:app_group_id/analytics_report_setting": { POST: postAppsAppGroupIdAnalyticsReportSetting },
  "/apps/:app_group_id/bot_tracking_settings": { GET: getBotTrackingSettings, POST: postBotTrackingSettings },
  "/apps/:app_group_id/cancel_import": { POST: postCancelCsvImport },
  "/apps/:app_group_id/catalogs/:catalog_id/items/:item_id/refresh_agentic_field": {
    POST: postAppsCatalogsCatalogIdItemsItemIdRefreshAgenticField,
  },
  "/apps/:app_group_id/charts/attribute_names": { GET: getAppsAppGroupIdChartsAttributeNames },
  "/apps/:app_group_id/charts/banner": { GET: getAppsAppGroupIdChartsBanner },
  "/apps/:app_group_id/charts/content_cards": { GET: getChartsContentCards },
  "/apps/:app_group_id/charts/custom_event_names": { GET: getCustomEventNames },
  "/apps/:app_group_id/charts/daily_purchases_by_purchase_names": {
    GET: getAppsAppGroupIdChartsDailyPurchasesByPurchaseNames,
  },
  "/apps/:app_group_id/charts/daily_revenue_by_purchase_names": {
    GET: getAppsAppGroupIdChartsDailyRevenueByPurchaseNames,
  },
  "/apps/:app_group_id/charts/email": { GET: getAppsAppGroupIdChartsEmail },
  "/apps/:app_group_id/charts/formula_data": { GET: getAppsAppGroupIdChartsFormulaData },
  "/apps/:app_group_id/charts/has_revenue": { GET: getAppGroupHasRevenue },
  "/apps/:app_group_id/charts/kakao": { GET: getAppsAppGroupIdChartsKakao },
  "/apps/:app_group_id/charts/line": { GET: useLineChartsApiQuery },
  "/apps/:app_group_id/charts/purchase_names": { GET: getPurchaseNames },
  "/apps/:app_group_id/charts/push": { GET: getAppsAppGroupIdChartsPush },
  "/apps/:app_group_id/charts/revenue/lifetime_stats": { GET: getAppGroupRevenueLifetimeStats },
  "/apps/:app_group_id/charts/revenue_previous_window": { GET: getAppsAppGroupIdChartsRevenuePreviousWindow },
  "/apps/:app_group_id/charts/sessions": { POST: postAppsAppGroupIdChartsSessions },
  "/apps/:app_group_id/charts/sessions/lifetime_stats": { GET: getAppGroupSessionLifetimeStats },
  "/apps/:app_group_id/charts/sessions_previous_window": { POST: postAppsAppGroupIdChartsSessionsPreviousWindow },
  "/apps/:app_group_id/charts/sms": { GET: getAppsAppGroupIdChartsSms },
  "/apps/:app_group_id/charts/trigger_iam": { GET: getAppsAppGroupIdChartsTriggerIam },
  "/apps/:app_group_id/charts/uninstall": { POST: postAppsAppGroupIdChartsUninstall },
  "/apps/:app_group_id/charts/users": { GET: getAppsAppGroupIdChartsUsers },
  "/apps/:app_group_id/charts/webhook": { GET: getAppsAppGroupIdChartsWebhook },
  "/apps/:app_group_id/charts/whatsapp": { GET: getAppsAppGroupIdChartsWhatsapp },
  "/apps/:app_group_id/custom_attributes_settings": {
    DELETE: deleteAppsAppGroupIdCustomAttributesSettings,
    POST: postAppsAppGroupIdCustomAttributesSettings,
  },
  "/apps/:app_group_id/custom_attributes_settings_create": {
    POST: postAppsAppGroupIdCustomAttributesSettingsCreate,
  },
  "/apps/:app_group_id/custom_events_settings": {
    DELETE: deleteAppsAppGroupIdCustomEventsSettings,
    POST: postAppsAppGroupIdCustomEventsSettings,
  },
  "/apps/:app_group_id/custom_events_settings_create": { POST: postAppsAppGroupIdCustomEventsSettingsCreate },
  "/apps/:app_group_id/email/draganddrop_settings": {
    GET: getDragAndDropEditorSettings,
    POST: postDragAndDropEditorSettings,
  },
  "/apps/:app_group_id/email_settings": { POST: postEmailSettingsApiEndpoint },
  "/apps/:app_group_id/encryption_settings": {
    GET: getUserDataEncryptionSettings,
    POST: postUserDataEncryptionSettings,
  },
  "/apps/:app_group_id/encryption_settings/generate_external_id": {
    GET: getGenerateExternalId,
  },
  "/apps/:app_group_id/event_properties_settings": { POST: postAppsAppGroupIdEventPropertiesSettings },
  "/apps/:app_group_id/initialize_csv_import": { POST: postInitializeCsvImport },
  "/apps/:app_group_id/message_archiving_settings": {
    GET: getMessageArchivingSettingsApiEndpoint,
    POST: postMessageArchivingSettingsApiEndpoint,
  },
  "/apps/:app_group_id/messaging_rules": {
    GET: getAppsAppGroupIdMessagingRules,
    POST: postAppsAppGroupIdMessagingRules,
  },
  "/apps/:app_group_id/products_settings": {
    DELETE: deleteAppsAppGroupIdProductsSettings,
    POST: postAppsAppGroupIdProductsSettings,
  },
  "/apps/:app_group_id/products_settings_create": { POST: postAppsAppGroupIdProductsSettingsCreate },
  "/apps/:app_group_id/push_settings": { POST: postAppsAppGroupIdPushSettings },
  "/apps/:app_group_id/quick_add_user_profile": { POST: postQuickAddUserProfile },
  "/apps/:app_group_id/settings": {
    GET: getAppSettingsApiEndpoint,
    PUT: postAppsAppGroupIdSettings,
  },
  "/apps/:app_group_id/start_import": { POST: postStartCsvImport },
  "/apps/:app_group_id/stop_import_in_progress": { POST: postStopImportInProgress },
  "/apps/:app_group_id/teams/:team_id/summary": { GET: getTeamSummary },
  "/apps/:app_group_id/territories_update_archived_state": {
    POST: postTeamsArchivedState,
  },
  "/apps/:app_group_id/territory_create": { POST: postTeamCreate },
  "/apps/:app_group_id/territory_edit": { POST: postTeamEdit },
  "/apps/:app_group_id/uninstall_tracking_apps": { GET: getAppsAppGroupIdUninstallTrackingApps },
  "/apps/:app_group_id/user_imports/:import_id": { GET: getAppsAppGroupIdUserImportsImportId },
  "/apps/:app_group_id/user_imports/:import_id/cancel_validation": {
    POST: postCancelUserImportValidation,
  },
  "/apps/:app_group_id/user_imports/:import_id/data_maps/:data_map_id/update_map": {
    POST: postAppsAppGroupIdUserImportsImportIdDataMapsDataMapIdUpdateMap,
  },
  "/apps/:app_group_id/user_imports/:import_id/event_catalog_slice": {
    POST: postAppsAppGroupIdUserImportsImportIdEventCatalogSlice,
  },
  "/apps/:app_group_id/user_imports/:import_id/initialize_map": {
    POST: postAppsAppGroupIdUserImportsImportIdInitializeMap,
  },
  "/apps/:app_group_id/user_imports/:import_id/scan_event_names": {
    GET: getAppsAppGroupIdUserImportsImportIdScanEventNames,
  },
  "/apps/:app_group_id/user_imports/:import_id/search_event_catalog": {
    GET: getAppsAppGroupIdUserImportsImportIdSearchEventCatalog,
  },
  "/apps/:app_group_id/user_imports/:import_id/transform_column_mapping": {
    POST: postAppsAppGroupIdUserImportsImportIdTransformColumnMapping,
  },
  "/apps/:app_group_id/user_imports/:import_id/validate": {
    POSTWS: postwsAppsAppGroupIdUserImportsImportIdValidate,
  },
  "/apps/:app_group_id/user_imports_datatable": { GET: getUserImportsDatatable },
  "/apps/:app_id": { DELETE: deleteAppsAppId },
  "/apps/:app_id/fsa_credential": {
    GET: getAppsAppIdFirebaseCredential,
    POST: postAppsAppIdFirebaseCredential,
  },
  "/apps/:app_id/push_credential": {
    DELETE: deleteAppsAppIdPushCredential,
    GET: getAppsAppIdPushCredential,
    POST: postAppsAppIdPushCredential,
  },
  "/apps/:app_id/push_credential_test": { POST: postAppsAppIdPushCredentialTest },
  "/apps/:app_id/sdk_authentication_analytics": { GET: getAppsAppIdSdkAuthenticationAnalytics },
  "/apps/:app_id/sdk_authentication_settings": {
    GET: getAppsAppIdSdkAuthenticationSettings,
    PUT: putAppsAppIdSdkAuthenticationSettings,
  },
  "/apps/:app_id/upload_push_certificate": { POST: postAppsAppIdUploadPushCertificate },
  "/apps/aggregate_push_credential_info": { GET: getAppsAggregatePushCredentialInfo },
  "/apps/api_dashboard/query": { GET: getAppsApiDashboardQuery },
  "/apps/api_limits/app_group_rate_limit_datatable/(/:app_group_id)": {
    GET: getDataTableAppsApiLimitsAppGroupRateLimitDatatableAppGroupId,
  },
  "/apps/api_limits/company_rate_limit_datatable": { GET: getDataTableAppsApiLimitsCompanyRateLimitDatatable },
  "/apps/api_limits/company_sdk_rate_limit_datatable": {
    GET: getDataTableAppsApiLimitsCompanySdkRateLimitDatatable,
  },
  "/apps/api_request_log/requests": { GET: getDataTableAppsApiRequestLogRequests },
  "/apps/app_group": { GET: getAppsAppGroup },
  "/apps/app_groups": { GET: getAppGroups, POST: postWorkspaces },
  "/apps/app_groups/:app_group_id": { DELETE: deleteAppsAppGroupsAppGroupId, POST: postAppsAppGroupsAppGroupId },
  "/apps/app_groups/:app_group_id/rename": { POST: postAppsAppGroupsAppGroupIdRename },
  "/apps/app_groups_using_catalogs": { GET: getAppsAppGroupsUsingCatalogs },
  "/apps/app_groups_with_permission/:permission": { GET: getAppsAppGroupsWithPermission },
  "/apps/approval_settings": {
    POST: postAppsApprovalSettings,
  },
  "/apps/business/account_fields": {
    DELETE: deleteLegacyCatalogAccountFields,
    GET: getLegacyCatalogAccountFields,
    POST: postLegacyCatalogAccountFields,
  },
  "/apps/business/accounts": {
    DELETE: deleteLegacyCatalogAccounts,
    POST: postLegacyCatalogAccounts,
    PUT: putLegacyCatalogAccounts,
  },
  "/apps/business/accounts_datatable": { GET: getDataTableLegacyCatalogAccountsDatatable },
  "/apps/business/business_sources": { GET: getAppsBusinessSources },
  "/apps/business/usage": { GET: getAppsBusinessUsage },
  "/apps/business/users": { POST: postAppsBusinessUsers },
  "/apps/catalog_fields": { GET: getAppsCatalogFields },
  "/apps/catalog_filtered_set_items_datatable": { GET: getDataTableAppsCatalogFilteredSetItemsDatatable },
  "/apps/catalog_filtered_sets": { GET: getAppsCatalogFilteredSets },
  "/apps/catalog_filtered_sets_list_datatable": { GET: getDataTableAppsCatalogFilteredSetsListDatatable },
  "/apps/catalog_items": { GET: getAppsCatalogItems },
  "/apps/catalog_items_datatable": { GET: getDataTableAppsCatalogItemsDatatable },
  "/apps/catalog_subscriptions_list_datatable": {
    GET: getDataTableAppsCatalogSubscriptionsListDatatable,
  },
  "/apps/catalogs": {
    GET: getAppsCatalogs,
    POST: postAppsCatalogs,
  },
  "/apps/catalogs/:catalog_id": { DELETE: deleteAppsCatalogsCatalogId, GET: getAppsCatalogsCatalogId },
  "/apps/catalogs/:catalog_id/export": { POST: postAppsCatalogsCatalogIdExport },
  "/apps/catalogs/:catalog_id/fields": { POST: postAppsCatalogFields },
  "/apps/catalogs/:catalog_id/filtered_sets": { POST: postAppsCatalogsCatalogIdFilteredSets },
  "/apps/catalogs/:catalog_id/filtered_sets/:filtered_set_name": {
    GET: getAppsCatalogsCatalogIdFilteredSetsFilteredSetName,
    PATCH: patchAppsCatalogsCatalogIdFilteredSetsFilteredSetName,
  },
  "/apps/catalogs/:catalog_id/subscriptions_delete_all": {
    DELETE: deleteAppsCatalogsCatalogIdSubscriptionsDeleteAll,
  },
  "/apps/catalogs_datatable": { GET: getDataTableAppsCatalogsDatatable },
  "/apps/catalogs_usage": { GET: getAppsCatalogsUsage },
  "/apps/engagement_reports/campaigns_by_tags": { POST: postAppsEngagementReportsCampaignsByTags },
  "/apps/engagement_reports/canvases_by_tags": { POST: postAppsEngagementReportsCanvasesByTags },
  "/apps/engagement_reports/engagement_report": {
    POST: postAppsEngagementReportsEngagementReport,
    PUT: putAppsEngagementReportsEngagementReport,
  },
  "/apps/engagement_reports/engagement_report_data(/:app_group_id)": {
    GET: getAppsEngagementReportsEngagementReportData,
  },
  "/apps/engagement_reports/engagement_reports_data": {
    GET: getDataTableAppsEngagementReportsEngagementReportsData,
  },
  "/apps/engagement_reports/tags": { GET: getAppsEngagementReportsTags },
  "/apps/engagement_reports/update_archived_state": { POST: postAppsEngagementReportsUpdateArchivedState },
  "/apps/engagement_reports/update_tags": { PUT: putAppsEngagementReportsUpdateTags },
  "/apps/get_default_custom_pages/:app_group_id": { GET: getAppsGetDefaultCustomPagesAppGroupId },
  "/apps/multi_language_settings/add_locale": { POST: postAppsMultiLanguageSettingsAddLocale },
  "/apps/multi_language_settings/delete_locale/:locale_id": {
    DELETE: deleteAppsMultiLanguageSettingsDeleteLocaleLocaleId,
  },
  "/apps/multi_language_settings/download_translation_template": {
    POST: postAppsMultiLanguageSettingsDownloadTranslationTemplate,
  },
  "/apps/multi_language_settings/get_locales": { GET: getAppsMultiLanguageSettingsLocales },
  "/apps/multi_language_settings/remove_translations": {
    DELETE: deleteAppsMultiLanguageSettingsRemoveTranslations,
  },
  "/apps/multi_language_settings/update_locale/:locale_id": { PUT: putAppsMultiLanguageSettingsUpdateLocale },
  "/apps/multi_language_settings/upload_translations": { POST: postAppsMultiLanguageSettingsUploadTranslations },
  "/apps/multi_language_settings/validate_translation_usage": {
    GET: getAppsMultiLanguageSettingsValidateTranslationUsage,
  },
  "/apps/transformation_logs_datatable": { GET: getTransformationLogsDatatable },
  "/apps/transformation_templates_datatable": { GET: getDataTableAppsTransformationTemplates },
  "/apps/transformations": { GET: getTransformation, POST: createTransformation },
  "/apps/transformations/:transformation_id": { GET: getTransformationDetail, PATCH: updateTransformation },
  "/apps/transformations/:transformation_id/rename": { PATCH: renameTransformation },
  "/apps/transformations/:transformation_id/submit": { POST: submitTransformation },
  "/apps/transformations/:transformation_id/validate": { POST: validateTransformation },
  "/apps/transformations_datatable": { GET: getTransformationsDatatable },
  "/apps/transformations_package_detail": { GET: getTransformationPackageDetail },
  "/apps/upload_csv_chunk": { POST: postUploadCsvChunk },
  "/apps/upload_file": {
    PUT: uploadFiles,
  },
  "/apps/upload_message": { POST: postAppsUploadMessage },
  "/apps/user_event_history/:user_identifier": {
    GET: getUserEventHistory,
    POSTWS: requestUserEventHistory,
  },
  "/apps/user_info/:user_identifier": {
    GET: getUserInfoByIdentifier,
  },
  "/apps/user_info/:user_identifier/cancel_single_user_deletion": {
    POST: postAppsUserInfoUserIdentifierCancelSingleUserDeletion,
  },
  "/apps/user_info/:user_identifier/change_email": { PUT: putAppsUserInfoUserIdentifierChangeEmail },
  "/apps/user_info/:user_identifier/delete_user": { DELETE: deleteAppsUserInfoUserIdentifierDeleteUser },
  "/apps/user_info/:user_identifier/push_token_status": {
    GET: pushTokenStatus,
  },
  "/apps/user_info/:user_identifier/update_subscription_group_status": {
    PUT: putUserInfoUpdateSubscriptionGroupStatus,
  },
  "/apps/user_info/:user_identifier/update_subscription_status": {
    PUT: putUserInfoUpdateSubscriptionStatus,
  },
  "/apps/user_info/cancel_user_deletion": { POST: postAppsUserInfoCancelUserDeletion },
  "/apps/user_info/confirm_user_deletion": { POST: postAppsUserInfoConfirmUserDeletion },
  "/apps/user_info/delete_users_from_segment": { DELETE: deleteAppsUserInfoDeleteUsersFromSegment },
  "/apps/user_info/delete_users_running": { GET: getAppsUserInfoDeleteUsersRunning },
  "/apps/user_info/get_click_through_tracking_config": { GET: getAppsUserInfoGetClickThroughTrackingConfig },
  "/apps/user_info/merge_duplicate_users_record_datatable": {
    GET: getDataTableAppsUserInfoMergeDuplicateUsersRecordDatatable,
  },
  "/apps/user_info/merge_duplicate_users_rules": { GET: getAppsUserInfoMergeDuplicateUsersRules },
  "/apps/user_info/merge_duplicate_users_running": { GET: getAppsUserInfoMergeDuplicateUsersRunning },
  "/apps/user_info/merge_users": { POST: postAppsUserInfoMergeUsers },
  "/apps/user_info/scheduled_merge_duplicate_users_rules": {
    GET: getAppsUserInfoScheduledMergeDuplicateUsersRules,
  },
  "/apps/user_info/update_click_through_tracking_config": {
    PATCH: patchAppsUserInfoUpdateClickThroughTrackingConfig,
  },
  "/apps/user_info/update_merge_duplicate_users_rules": { PATCH: patchAppsUserInfoUpdateMergeDuplicateUsersRules },
  "/apps/user_info/update_scheduled_merge_duplicate_users_rules": {
    PATCH: patchAppsUserInfoUpdateScheduledMergeDuplicateUsersRules,
  },
  "/apps/user_info/user_deletion_record_datatable": { GET: getDataTableAppsUserInfoUserDeletionRecordDatatable },
  "/apps/user_info_any_users": {
    GET: getUserInfoAnyUsers,
  },
  "/apps/user_info_campaigns/:user_identifier": {
    GET: getUserInfoCampaignsByIdentifier,
  },
  "/apps/user_info_segments/:user_identifier": {
    GET: getUserInfoSegmentsByIdentifier,
  },
  "/apps/user_infos/:user_identifier": { GET: getUserInfosByIdentifier },
  "/apps/user_recent_event_history/:user_identifier": {
    GET: getUserRecentEventHistory,
  },
  "/banners/dismiss": { POST: postBannersDismiss },
  "/channel_dashboard/:app_group_id/:channel_type": { GET: getChannelDashboardData },
  "/comments/:target/global_notification_setting": { PUT: putCommentsTargetGlobalNotificationSetting },
  "/comments/:target/notification_setting": {
    GET: getCommentsNotificationSetting,
    PUT: putCommentsNotificationSetting,
  },
  "/comments/:target/threads": { GET: getCommentThreads, POST: createCommentThread },
  "/comments/:target/threads/:thread_id": { DELETE: deleteCommentThread },
  "/comments/:target/threads/:thread_id/comments": { POST: createComment },
  "/comments/:target/threads/:thread_id/comments/:comment_id": { DELETE: deleteComment, PATCH: editComment },
  "/comments/:target/threads/:thread_id/reopen": { PUT: reopenCommentThread },
  "/comments/:target/threads/:thread_id/resolve": { PUT: resolveCommentThread },
  "/companies/:company_id/ai_settings": { GET: getCompanyAiSettings },
  "/companies/:company_id/all_data_ai_training_kill_switch": {
    PUT: putCompanyAllDataAiTrainingOptOut,
  },
  "/companies/:company_id/anonymous_aggregated_ai_training_kill_switch": {
    PUT: putCompanyAnonymousAggregatedAiTrainingOptOut,
  },
  "/companies/:company_id/app_group_permission_sets/all_permission_sets": {
    GET: getCompaniesCompanyIdAppGroupPermissionSetsAllPermissionSets,
  },
  "/companies/:company_id/app_group_permission_sets/create_permission_set": {
    POST: postCompaniesCompanyIdAppGroupPermissionSetsCreatePermissionSet,
  },
  "/companies/:company_id/app_group_permission_sets/delete_permission_set/:id": {
    DELETE: deleteCompaniesCompanyIdAppGroupPermissionSetsDeletePermissionSetId,
  },
  "/companies/:company_id/app_group_permission_sets/duplicate_permission_set": {
    POST: postCompaniesCompanyIdAppGroupPermissionSetsDuplicatePermissionSet,
  },
  "/companies/:company_id/app_group_permission_sets/permission_set/:id": {
    GET: getCompaniesCompanyIdAppGroupPermissionSetsPermissionSetId,
  },
  "/companies/:company_id/app_group_permission_sets/update_permission_set": {
    PUT: putCompaniesCompanyIdAppGroupPermissionSetsUpdatePermissionSet,
  },
  "/companies/:company_id/app_groups": { GET: getCompaniesCompanyIdAppGroups },
  "/companies/:company_id/audience_sync_allotments": {
    GET: getAudienceSyncAllotments,
  },
  "/companies/:company_id/company_rate_limits": { GET: getCompanyRateLimits },
  "/companies/:company_id/contact_information": {
    GET: getCompanyContactInformation,
    PUT: putCompanyContactInformation,
  },
  "/companies/:company_id/custom_domains": {
    GET: getCompaniesCompanyIdCustomDomains,
    POST: postCompaniesCompanyIdCustomDomains,
  },
  "/companies/:company_id/custom_domains/:domain_type/:domain_id": {
    DELETE: deleteCompaniesCompanyIdCustomDomainsDomainTypeDomainId,
    GET: getCompaniesCompanyIdCustomDomainsDomainTypeDomainId,
  },
  "/companies/:company_id/custom_domains/:domain_type/:domain_id/migration": {
    POST: postCompaniesCompanyIdCustomDomainsDomainTypeDomainIdMigration,
  },
  "/companies/:company_id/custom_domains/:domain_type/:domain_id/subscription_groups": {
    GET: getCompaniesCompanyIdCustomDomainsDomainTypeDomainIdSubscriptionGroups,
  },
  "/companies/:company_id/custom_domains/:domain_type/:domain_parent_id/:domain_id/app_linking_assignment": {
    DELETE: deleteCompaniesCompanyIdCustomDomainsAppLinkingAssignment,
  },
  "/companies/:company_id/custom_domains/:domain_type/app_linking_assignments": {
    PUT: putCompaniesCompanyIdCustomDomainsAppLinkingAssignments,
  },
  "/companies/:company_id/custom_domains/limits": {
    GET: getCompaniesCompanyIdCustomDomainsLimits,
  },
  "/companies/:company_id/custom_roles/create_custom_role": {
    POST: postCompaniesCompanyIdCustomRolesCreateCustomRole,
  },
  "/companies/:company_id/custom_roles/custom_role/:id": { GET: getCompaniesCompanyIdCustomRolesCustomRoleId },
  "/companies/:company_id/custom_roles/custom_role_management_data": {
    GET: getCompaniesCompanyIdCustomRolesCustomRoleManagementData,
  },
  "/companies/:company_id/custom_roles/delete_custom_role/:id": {
    DELETE: deleteCompaniesCompanyIdCustomRolesDeleteCustomRoleId,
  },
  "/companies/:company_id/custom_roles/duplicate_custom_role": {
    POST: postCompaniesCompanyIdCustomRolesDuplicateCustomRole,
  },
  "/companies/:company_id/custom_roles/update_custom_role/:id": {
    PUT: putCompaniesCompanyIdCustomRolesUpdateCustomRoleId,
  },
  "/companies/:company_id/developers": { GET: getDevelopers, POST: postCompaniesCompanyIdDevelopers },
  "/companies/:company_id/developers/:developer_id": {
    DELETE: deleteCompaniesCompanyIdDevelopersDeveloperId,
    GET: getCompaniesCompanyIdDevelopersDeveloperId,
    PUT: putCompaniesCompanyIdDevelopersDeveloperId,
  },
  "/companies/:company_id/developers/:developer_id/developer_clear_two_factor_auth": {
    PUT: putCompaniesCompanyIdDevelopersDeveloperIdDeveloperClearTwoFactorAuth,
  },
  "/companies/:company_id/developers/:developer_id/developer_resend_confirmation": {
    POST: postCompaniesCompanyIdDevelopersDeveloperIdDeveloperResendConfirmation,
  },
  "/companies/:company_id/developers/:developer_id/suspend": { POST: postDeveloperSuspend },
  "/companies/:company_id/developers/:developer_id/unsuspend": { POST: postDeveloperUnsuspend },
  "/companies/:company_id/developers/csv_export": { POST: postDevelopersCsvExport },
  "/companies/:company_id/developers/current": {
    GET: getDeveloper,
  },
  "/companies/:company_id/developers/current/pref_center_url": {
    GET: getCompaniesCompanyIdDevelopersCurrentPrefCenterUrl,
  },
  "/companies/:company_id/developers/permission_structures": {
    GET: getCompaniesCompanyIdDevelopersPermissionStructures,
  },
  "/companies/:company_id/developers/table": { GET: getDevelopersTable },
  "/companies/:company_id/developers_common": { GET: getSparseDevelopers },
  "/companies/:company_id/email_self_serve/:app_group_id/configuration_data": {
    GET: getConfigurationData,
  },
  "/companies/:company_id/email_self_serve/:app_group_id/ip_addresses": {
    POST: postCompaniesCompanyIdEmailSelfServeIpAddresses,
  },
  "/companies/:company_id/email_self_serve/:app_group_id/ip_pool": {
    POST: postCompaniesCompanyIdEmailSelfServeIpPool,
  },
  "/companies/:company_id/email_self_serve/:app_group_id/ip_pools": {
    POST: postCompaniesCompanyIdEmailSelfServeIpPools,
  },
  "/companies/:company_id/email_self_serve/:app_group_id/provision": { POST: postProvisionSesAccount },
  "/companies/:company_id/email_self_serve/:app_group_id/sending_domain/:domain_id": {
    DELETE: deleteSendingDomain,
    PATCH: patchSendingDomain,
  },
  "/companies/:company_id/email_self_serve/:app_group_id/sending_domain/:domain_id/assign_existing_tracking_domain":
    { POST: postAssignExistingTrackingDomain },
  "/companies/:company_id/email_self_serve/:app_group_id/sending_domain/:domain_id/partner_tracking_domain": {
    POST: postPartnerTrackingDomain,
  },
  "/companies/:company_id/email_self_serve/:app_group_id/sending_domain/:domain_id/tracking_domain": {
    POST: postTrackingDomain,
  },
  "/companies/:company_id/email_self_serve/:app_group_id/sending_domains": { POST: postSendingDomain },
  "/companies/:company_id/feature_management/set_feature_statuses": { PUT: putCompanyFeatureStatuses },
  "/companies/:company_id/free_trial/developers": { POST: postFreeTrialDeveloper },
  "/companies/:company_id/free_trial/developers/:developer_id": {
    DELETE: deleteFreeTrialDeveloper,
    GET: getFreeTrialDeveloper,
    PUT: putFreeTrialDeveloper,
  },
  "/companies/:company_id/free_trial/developers_table": { GET: getFreeTrialDevelopersTable },
  "/companies/:company_id/generative_ai_kill_switch": { PUT: putCompanyGenerativeAiOptOut },
  "/companies/:company_id/link_shortening_domains": {
    GET: getCompanyLinkShorteningDomains,
  },
  "/companies/:company_id/mobile_app_linking_assignable_tracking_domains": {
    GET: getDataTableCompaniesCompanyIdMobileAppLinkingAssignableTrackingDomains,
  },
  "/companies/:company_id/mobile_app_linking_configs": {
    GET: getCompaniesCompanyIdMobileAppLinkingConfigs,
    POST: postCompaniesCompanyIdMobileAppLinkingConfigs,
  },
  "/companies/:company_id/mobile_app_linking_configs/:id": {
    DELETE: deleteCompaniesCompanyIdMobileAppLinkingConfigsId,
    GET: getCompaniesCompanyIdMobileAppLinkingConfigsId,
    PATCH: patchCompaniesCompanyIdMobileAppLinkingConfigsId,
  },
  "/companies/:company_id/notification_preferences/bulk_add": {
    PUT: putCompaniesCompanyIdNotificationPreferencesBulkAdd,
  },
  "/companies/:company_id/notification_preferences/list": {
    GET: getCompanyNotificationPreferences,
  },
  "/companies/:company_id/notification_preferences/update": {
    PUT: putCompaniesCompanyIdNotificationPreferencesUpdate,
  },
  "/companies/:company_id/oauth_mcp_settings": {
    GET: getCompaniesCompanyIdOauthMcpSettings,
  },
  "/companies/:company_id/oauth_mcp_settings/marketplace_clients": {
    GET: getCompaniesCompanyIdOauthMcpSettingsMarketplaceClients,
  },
  "/companies/:company_id/oauth_mcp_settings/marketplace_clients/:key": {
    PUT: putCompaniesCompanyIdOauthMcpSettingsMarketplaceClientsKey,
  },
  "/companies/:company_id/oauth_mcp_settings/mcp_enabled": {
    PUT: putCompaniesCompanyIdOauthMcpSettingsMcpEnabled,
  },
  "/companies/:company_id/oauth_mcp_settings/partner_apps_enabled": {
    PUT: putCompaniesCompanyIdOauthMcpSettingsPartnerAppsEnabled,
  },
  "/companies/:company_id/oauth_mcp_settings/partner_policies": {
    GET: getCompaniesCompanyIdOauthMcpSettingsPartnerPolicies,
  },
  "/companies/:company_id/oauth_mcp_settings/redirect_uris": {
    PUT: putCompaniesCompanyIdOauthMcpSettingsRedirectUris,
  },
  "/companies/:company_id/oauth_mcp_settings/revocations/:operation_id": { GET: getMcpTokenRevocation },
  "/companies/:company_id/oauth_mcp_settings/revoke_tokens": { POST: postMcpTokenRevocation },
  "/companies/:company_id/security_settings": {
    GET: getCompanySecuritySettings,
  },
  "/companies/:company_id/security_settings/security_event_config": { GET: getCompanySecurityEventConfig },
  "/companies/:company_id/security_settings/security_event_config_test": {
    POST: postCompanySecurityEventConfigTest,
  },
  "/companies/:company_id/sender_verification/eligibility": { GET: getSenderVerificationEligibility },
  "/companies/:company_id/sender_verification/ip_addresses": {
    GET: getCompaniesCompanyIdSenderVerificationIpAddresses,
    POST: postCompaniesCompanyIdSenderVerificationIpAddresses,
  },
  "/companies/:company_id/sender_verification/sending_domains": {
    GET: getCompaniesCompanyIdSenderVerificationSendingDomains,
    POST: postCompaniesCompanyIdSenderVerificationSendingDomains,
  },
  "/companies/:company_id/sender_verification/sending_domains/verify": {
    PUT: putCompaniesCompanyIdSenderVerificationSendingDomainsVerify,
  },
  "/companies/:company_id/sender_verification/setup_rdns": {
    POST: postCompaniesCompanyIdSenderVerificationSetupRdns,
  },
  "/companies/:company_id/sender_verification/subuser": { POST: postCompaniesCompanyIdSenderVerificationSubuser },
  "/companies/:company_id/sender_verification/tracking_domains": {
    GET: getCompaniesCompanyIdSenderVerificationTrackingDomains,
    POST: postCompaniesCompanyIdSenderVerificationTrackingDomains,
  },
  "/companies/:company_id/sender_verification/tracking_domains/verify": {
    PUT: putCompaniesCompanyIdSenderVerificationTrackingDomainsVerify,
  },
  "/companies/:company_id/settings": {
    GET: getCompanySettings,
  },
  "/companies/:company_id/time_zone_options": { GET: getCompanyTimezoneOptions },
  "/companies/:company_id/verified_domains": {
    GET: getCompaniesCompanyIdVerifiedDomains,
    POST: postCompaniesCompanyIdVerifiedDomains,
  },
  "/companies/:company_id/verified_domains/:id": {
    DELETE: deleteCompaniesCompanyIdVerifiedDomainsId,
    GET: getCompaniesCompanyIdVerifiedDomainsId,
  },
  "/companies/workspace_rate_limits/:app_group_id": { DELETE: deleteCompaniesWorkspaceRateLimitsDelete },
  "/companies/workspace_rate_limits/upsert": { POST: postCompaniesWorkspaceRateLimitsUpsert },
  "/companies/workspace_rate_limits_data_table": {
    GET: getDataTableCompaniesWorkspaceRateLimitsDataTable,
  },
  "/companies/workspaces_time_zones": { GET: getCompaniesWorkspaceTimezones },
  "/company_settings/data_point_usage": { GET: getCompanySettingsDataPointUsage },
  "/company_settings/most_used_events_and_attributes_by_apps_and_app_groups": {
    GET: getDataTableCompanySettingsMostUsedEventsAndAttributesByAppsAndAppGroups,
  },
  "/company_settings/most_used_events_and_attributes_by_apps_and_app_groups_export": {
    POST: postCompanySettingsMostUsedEventsAndAttributesByAppsAndAppGroupsExport,
  },
  "/company_settings/subscriptions_and_usage": { GET: getCompanySettingsSubscriptionsAndUsage },
  "/cortex_agent/run_query": { POSTWS: postwsCortexAgentRunQuery },
  "/dashboard/async_request_manager/cancel_request": { POST: postAsyncRequestManagerCancelRequest },
  "/dashboard/async_request_manager/find_request": { GET: getAsyncRequestManagerFindRequest },
  "/dashboard/async_request_manager/list_requests": { GET: getAsyncRequestManagerRequests },
  "/dashboard/conversion_attribution_dashboard/:app_group_id/campaign_canvas_metadata": {
    GET: getDashboardConversionAttributionDashboardAppGroupIdCampaignCanvasMetadata,
  },
  "/data_objects/:type_name": {
    GET: getDataTableCustomObjectsTypeName,
    POST: postCustomObjectsTypeName,
  },
  "/data_objects/:type_name/:object_id": {
    DELETE: deleteCustomObjectsTypeNameObjectId,
    GET: getCustomObjectsTypeNameObjectId,
    PATCH: patchCustomObjectsTypeNameObjectId,
  },
  "/data_objects/:type_name/:object_id/object_relationships": {
    DELETE: deleteCustomObjectsTypeNameObjectIdObjectRelationships,
    GET: getDataTableCustomObjectsTypeNameObjectIdObjectRelationships,
    POST: postCustomObjectsTypeNameObjectIdObjectRelationships,
  },
  "/data_objects/:type_name/:object_id/unlinked_objects": {
    GET: getCustomObjectsTypeNameObjectIdUnlinkedObjects,
  },
  "/data_objects/:type_name/:object_id/unlinked_users": {
    GET: getCustomObjectsTypeNameObjectIdUnlinkedUsers,
  },
  "/data_objects/:type_name/:object_id/users": {
    GET: getDataTableCustomObjectsTypeNameObjectIdUsers,
    POST: postCustomObjectsTypeNameObjectIdUsers,
  },
  "/data_objects/:type_name/:object_id/users/:user_id": {
    DELETE: deleteCustomObjectsUserRelationship,
    PATCH: patchCustomObjectsUserRelationship,
  },
  "/data_objects/:type_name/linked_to_user/:user_identifier": {
    GET: getCustomObjectsLinkedToUser,
  },
  "/data_objects/:type_name/not_linked_to_user/:user_identifier": {
    GET: getCustomObjectsNotLinkedToUser,
  },
  "/data_objects/:type_name/schema/fields": {
    GET: getDataTableCustomObjectsTypeNameSchemaFields,
    POST: postCustomObjectsTypeNameSchemaFields,
  },
  "/data_objects/:type_name/schema/fields/:field_name": {
    DELETE: deleteCustomObjectsTypeNameSchemaFieldsFieldName,
    PATCH: patchCustomObjectsTypeNameSchemaFieldsFieldName,
  },
  "/data_objects/:type_name/users/:user_id/batch_link": {
    POST: postCustomObjectsBatchLinkUser,
  },
  "/data_objects/data_object_type_attributes": { GET: getCustomObjectsCustomObjectTypeAttributes },
  "/data_objects/data_object_type_relationships": { GET: getCustomObjectsCustomObjectTypeRelationships },
  "/data_objects/data_object_type_schema": { GET: getCustomObjectsCustomObjectTypeSchema },
  "/data_objects/data_object_types": { GET: getCustomObjectsCustomObjectTypes },
  "/data_objects/data_objects_usage": {
    GET: getCustomObjectsUsage,
  },
  "/data_objects/enable_accounts": { POST: postCustomObjectsEnableAccounts },
  "/data_objects/import_staging_records": { GET: getDataTableCustomObjectsImportStagingRecords },
  "/data_objects/object_relationship_type_schema": { GET: getCustomObjectsObjectRelationshipTypeSchema },
  "/data_objects/object_relationship_types/:rel_type_id/fields": {
    POST: postCustomObjectsObjectRelationshipTypeFields,
  },
  "/data_objects/onboarding_status": { GET: getCustomObjectsOnboardingStatus },
  "/data_objects/preview_calculated_filters/:user_identifier": { GET: getCustomObjectsPreviewCalculatedFilters },
  "/data_objects/user_data_object_type_relationships": {
    GET: getCustomObjectsUserCustomObjectTypeRelationships,
  },
  "/data_objects/user_linked_data_object_types": { GET: getCustomObjectsUserLinkedCustomObjectTypes },
  "/data_objects/user_relationship_type_attributes": {
    GET: getCustomObjectsUserRelationshipTypeAttributes,
  },
  "/data_objects/user_relationship_type_schema": { GET: getCustomObjectsUserRelationshipTypeSchema },
  "/data_objects/user_relationship_types/:rel_type_id/fields": {
    POST: postCustomObjectsUserRelationshipTypeFields,
  },
  "/databricks_deltashares/:app_group_id": {
    DELETE: deleteDeltashares,
    GET: getDeltashares,
    POST: postDeltashares,
    PUT: putDeltashares,
  },
  "/datashares": { GET: getDatashares },
  "/decisioning_studio_agents/:app_group_id": {
    GET: getDataTableDecisioningStudioAgentsAppGroupId,
    POST: postDecisioningStudioAgentsAppGroupId,
  },
  "/decisioning_studio_agents/:app_group_id/:dsa_id/agent_preferences": {
    GET: getDecisioningStudioAgentsAppGroupIdDsaIdAgentPreferences,
  },
  "/decisioning_studio_agents/:app_group_id/:dsa_id/audiences": {
    GET: getDecisioningStudioAgentsAppGroupIdDsaIdAudiences,
  },
  "/decisioning_studio_agents/:app_group_id/:dsa_id/audiences/distribution": {
    GET: getDecisioningStudioAgentsAppGroupIdDsaIdAudienceDistribution,
    PUT: putDecisioningStudioAgentsAppGroupIdDsaIdAudienceDistribution,
  },
  "/decisioning_studio_agents/:app_group_id/:dsa_id/audiences/get_agent_is_personalizing": {
    GET: getDecisioningStudioAgentsAppGroupIdDsaIdAudiencesGetAgentIsPersonalizing,
  },
  "/decisioning_studio_agents/:app_group_id/:dsa_id/audiences/segments": {
    GET: getDecisioningStudioAgentsAppGroupIdDsaIdSegments,
    PUT: putDecisioningStudioAgentsAppGroupIdDsaIdSegments,
  },
  "/decisioning_studio_agents/:app_group_id/:dsa_id/base_creatives": {
    GET: getDataTableDecisioningStudioAgentsAppGroupIdDsaIdBaseCreatives,
    POST: postDecisioningStudioAgentsBaseCreative,
  },
  "/decisioning_studio_agents/:app_group_id/:dsa_id/base_creatives/:campaign_id": {
    DELETE: deleteDecisioningStudioAgentsBaseCreative,
    PUT: putDecisioningStudioAgentsBaseCreative,
  },
  "/decisioning_studio_agents/:app_group_id/:dsa_id/base_creatives/:campaign_id/rename": {
    PUT: putDecisioningStudioAgentsBaseCreativeRename,
  },
  "/decisioning_studio_agents/:app_group_id/:dsa_id/base_creatives/:campaign_id/variants": {
    GET: getDecisioningStudioAgentsAppGroupIdDsaIdBaseCreativesCampaignIdVariants,
  },
  "/decisioning_studio_agents/:app_group_id/:dsa_id/campaigns/": {
    POST: postDecisioningStudioAgentsAppGroupIdDsaIdCampaigns,
  },
  "/decisioning_studio_agents/:app_group_id/:dsa_id/constraints": {
    GET: getDataTableDecisioningStudioAgentsAppGroupIdDsaIdConstraints,
  },
  "/decisioning_studio_agents/:app_group_id/:dsa_id/constraints/:component": {
    DELETE: deleteDecisioningStudioAgentsAppGroupIdDsaIdConstraintsComponent,
    GET: getDecisioningStudioAgentsAppGroupIdDsaIdConstraintsComponent,
    POST: postDecisioningStudioAgentsAppGroupIdDsaIdConstraintsComponent,
    PUT: putDecisioningStudioAgentsAppGroupIdDsaIdConstraintsComponent,
  },
  "/decisioning_studio_agents/:app_group_id/:dsa_id/conversion_events": {
    GET: getDecisioningStudioAgentsAppGroupIdDsaIdConversionEvents,
  },
  "/decisioning_studio_agents/:app_group_id/:dsa_id/creative_components": {
    GET: getDecisioningStudioAgentsAppGroupIdDsaIdCreativeComponents,
  },
  "/decisioning_studio_agents/:app_group_id/:dsa_id/creative_components/:component/base_creatives": {
    GET: getDecisioningStudioAgentsAppGroupIdDsaIdCreativeComponentsComponentBaseCreatives,
  },
  "/decisioning_studio_agents/:app_group_id/:dsa_id/creative_components/:component/variants": {
    GET: getDataTableDecisioningStudioAgentsAppGroupIdDsaIdCreativeComponentsComponentVariants,
    POST: postDecisioningStudioAgentsAppGroupIdDsaIdCreativeComponentsComponentVariants,
  },
  "/decisioning_studio_agents/:app_group_id/:dsa_id/creative_components/:component/variants/:variant_id": {
    DELETE: deleteDecisioningStudioAgentsAppGroupIdDsaIdCreativeComponentsComponentVariantsVariantId,
    PUT: putDecisioningStudioAgentsAppGroupIdDsaIdCreativeComponentsComponentVariantsVariantId,
  },
  "/decisioning_studio_agents/:app_group_id/:dsa_id/details": {
    GET: getDecisioningStudioAgentsAppGroupIdDsaIdDetails,
    PUT: putDecisioningStudioAgentsAppGroupIdDsaIdDetails,
  },
  "/decisioning_studio_agents/:app_group_id/:dsa_id/dimensions": {
    GET: getDecisioningStudioAgentsAppGroupIdDsaIdDimensions,
  },
  "/decisioning_studio_agents/:app_group_id/:dsa_id/dimensions/:dimension": {
    GET: getDecisioningStudioAgentsAppGroupIdDsaIdDimensionsDimension,
  },
  "/decisioning_studio_agents/:app_group_id/:dsa_id/dimensions/:dimension/actions": {
    GET: getDataTableDecisioningStudioAgentsAppGroupIdDsaIdDimensionsDimensionActions,
    PATCH: patchDecisioningStudioAgentsAppGroupIdDsaIdDimensionsDimensionActions,
    POST: postDecisioningStudioAgentsAppGroupIdDsaIdDimensionsDimensionActions,
  },
  "/decisioning_studio_agents/:app_group_id/:dsa_id/dimensions/:dimension/actions/:action_id": {
    GET: getDecisioningStudioAgentsAppGroupIdDsaIdDimensionsDimensionActionsActionId,
    PATCH: patchDecisioningStudioAgentsAppGroupIdDsaIdDimensionsDimensionActionsActionId,
  },
  "/decisioning_studio_agents/:app_group_id/:dsa_id/first_recommendation_run": {
    GET: getDecisioningStudioAgentsAppGroupIdDsaIdFirstRecommendationRun,
  },
  "/decisioning_studio_agents/:app_group_id/:dsa_id/insights/lift_decomposition": {
    GET: getDecisioningStudioLiftDecomposition,
  },
  "/decisioning_studio_agents/:app_group_id/:dsa_id/insights/personalization_explainer/:dimension/actions": {
    GET: getDecisioningStudioAgentsAppGroupIdDsaIdInsightsPersonalizationExplainerDimensionActions,
  },
  "/decisioning_studio_agents/:app_group_id/:dsa_id/insights/personalization_explainer/:dimension/uplift": {
    GET: getDecisioningStudioAgentsAppGroupIdDsaIdInsightsPersonalizationExplainerDimensionUplift,
  },
  "/decisioning_studio_agents/:app_group_id/:dsa_id/insights/personalization_explainer/available_dimensions": {
    GET: getPersonalizationExplainerAvailableDimensions,
  },
  "/decisioning_studio_agents/:app_group_id/:dsa_id/launch": {
    POST: postDecisioningStudioAgentsAppGroupIdDsaIdLaunch,
  },
  "/decisioning_studio_agents/:app_group_id/:dsa_id/launch_validation": {
    GET: getDecisioningStudioAgentsAppGroupIdDsaIdLaunchValidation,
  },
  "/decisioning_studio_agents/:app_group_id/:dsa_id/performance_report/data": {
    GET: getDecisioningStudioAgentsAppGroupIdDsaIdPerformanceReportData,
  },
  "/decisioning_studio_agents/:app_group_id/:dsa_id/performance_report/settings": {
    GET: getDecisioningStudioAgentsAppGroupIdDsaIdPerformanceReportSettings,
  },
  "/decisioning_studio_agents/:app_group_id/:dsa_id/resume": {
    POST: postDecisioningStudioAgentsAppGroupIdDsaIdResume,
  },
  "/decisioning_studio_agents/:app_group_id/:dsa_id/source_canvases": {
    GET: getDecisioningStudioAgentsAppGroupIdDsaIdSourceCanvases,
  },
  "/decisioning_studio_agents/:app_group_id/:dsa_id/stop": {
    POST: postDecisioningStudioAgentsAppGroupIdDsaIdStop,
  },
  "/decisioning_studio_agents/:app_group_id/:dsa_id/timing": {
    GET: getDecisioningStudioAgentsAppGroupIdDsaIdTiming,
  },
  "/decisioning_studio_agents/:app_group_id/:dsa_id/timing/quiet_hours": {
    GET: getDecisioningStudioAgentsAppGroupIdDsaIdTimingQuietHours,
    PUT: putDecisioningStudioAgentsAppGroupIdDsaIdTimingQuietHours,
  },
  "/decisioning_studio_agents/:app_group_id/:dsa_id/timing/schedule": {
    GET: getDecisioningStudioAgentsAppGroupIdDsaIdSchedule,
    PUT: putDecisioningStudioAgentsAppGroupIdDsaIdSchedule,
  },
  "/decisioning_studio_agents/:app_group_id/:dsa_id/workflows/": {
    POST: postDecisioningStudioAgentsAppGroupIdDsaIdWorkflows,
  },
  "/decisioning_studio_agents/:app_group_id/:id": {
    GET: getDecisioningStudioAgentsAppGroupIdId,
    PUT: putDecisioningStudioAgentsAppGroupIdId,
  },
  "/deliverability/email/:app_group_id/data": { GET: getDeliverabilityEmailAppGroupIdData },
  "/deliverability/email/:app_group_id/filters": { GET: getDeliverabilityEmailAppGroupIdFilters },
  "/deliverability/postmaster/:app_group_id/compliance_status": {
    GET: getDeliverabilityPostmasterAppGroupIdComplianceStatus,
  },
  "/deliverability/postmaster/:app_group_id/delivery_errors": {
    GET: getDataTableDeliverabilityPostmasterAppGroupIdDeliveryErrors,
  },
  "/deliverability/postmaster/:app_group_id/domain_reputation": {
    GET: getDataTableDeliverabilityPostmasterAppGroupIdDomainReputation,
  },
  "/deliverability/postmaster/:app_group_id/domains": { GET: getDeliverabilityPostmasterAppGroupIdDomains },
  "/deliverability/postmaster/:app_group_id/ip_reputation": {
    GET: getDataTableDeliverabilityPostmasterAppGroupIdIpReputation,
  },
  "/deliverability/postmaster/:app_group_id/ips": { GET: getDeliverabilityPostmasterAppGroupIdIps },
  "/deliverability/postmaster/:app_group_id/latest_event": { GET: getDeliverabilityPostmasterLatestEvent },
  "/deliverability/snds/:app_group_id/ips": { GET: getDeliverabilitySndsAppGroupIdIps },
  "/deliverability/snds/:app_group_id/latest_event": { GET: getDeliverabilitySndsLatestEvent },
  "/deliverability/snds/:app_group_id/snds_data": { GET: getDataTableDeliverabilitySndsAppGroupIdSndsData },
  "/demo_qr_code": { GET: getFreeTrialQrCode },
  "/developers": {
    PUT: putDeveloper,
  },
  "/dust/auth/:app_group_id": { GET: getDustConfig },
  "/email/ip_warming/:app_group_id/campaign_stats(/:plan_id)": { GET: getEmailIpWarmingCampaignStats },
  "/email/ip_warming/:app_group_id/delete/:plan_id": { POST: postEmailIpWarmingDelete },
  "/email/ip_warming/:app_group_id/engagement_data/begin_upload(/:plan_id)": {
    POST: postEmailIpWarmingAppGroupIdEngagementDataBeginUpload,
  },
  "/email/ip_warming/:app_group_id/engagement_data/chunk(/:plan_id)": {
    POST: postEmailIpWarmingAppGroupIdEngagementDataChunk,
  },
  "/email/ip_warming/:app_group_id/engagement_data/register(/:plan_id)": {
    POST: postEmailIpWarmingAppGroupIdEngagementDataRegister,
  },
  "/email/ip_warming/:app_group_id/ip_count": { GET: getEmailIpWarmingAppGroupIdIpCount },
  "/email/ip_warming/:app_group_id/launch(/:plan_id)": { POST: postEmailIpWarmingLaunch },
  "/email/ip_warming/:app_group_id/plan(/:plan_id)": { GET: getEmailIpWarmingAppGroupIdPlan },
  "/email/ip_warming/:app_group_id/plan_name_available": { GET: getEmailIpWarmingAppGroupIdPlanNameAvailable },
  "/email/ip_warming/:app_group_id/plans": { GET: getDataTableEmailIpWarmingAppGroupIdPlans },
  "/email/ip_warming/:app_group_id/required_email_templates": {
    GET: getEmailIpWarmingAppGroupIdRequiredEmailTemplates,
  },
  "/email/ip_warming/:app_group_id/schedule": { GET: getEmailIpWarmingAppGroupIdSchedule },
  "/email/ip_warming/:app_group_id/schedule_settings(/:plan_id)": {
    POST: postEmailIpWarmingAppGroupIdScheduleSettings,
  },
  "/email/ip_warming/:app_group_id/show_ip_warming_widget": { GET: getEmailIpWarmingAppGroupIdShowIpWarmingWidget },
  "/email/ip_warming/:app_group_id/stop(/:plan_id)": { POST: postEmailIpWarmingStop },
  "/engagement/:app_group_id/banner_templates": {
    GET: getDataTableEngagementAppGroupIdBannerTemplates,
    POST: postEngagementAppGroupIdBannerTemplates,
  },
  "/engagement/:app_group_id/banner_templates/:id": {
    GET: getEngagementAppGroupIdBannerTemplatesId,
    PUT: putEngagementAppGroupIdBannerTemplatesId,
  },
  "/engagement/:app_group_id/banner_templates/duplicate": {
    POST: postEngagementAppGroupIdBannerTemplatesDuplicate,
  },
  "/engagement/:app_group_id/banner_templates/update_archived_state": {
    POST: postEngagementAppGroupIdBannerTemplatesUpdateArchivedState,
  },
  "/engagement/:app_group_id/campaign/:campaign_id/message/:message_variation_id/latest_test_results": {
    GET: getEngagementAppGroupIdCampaignCampaignIdMessageMessageVariationIdLatestTestResults,
  },
  "/engagement/:app_group_id/campaign_country_performance/:campaign_id": {
    GET: getEngagementAppGroupIdCampaignCountryPerformanceCampaignId,
  },
  "/engagement/:app_group_id/canvas/:workflow_id/async_audience_preview": { POSTWS: postCanvasAudiencePreview },
  "/engagement/:app_group_id/canvas/:workflow_id/content_optimization/:step_id/performance_context": {
    GET: getContentOptimizationPerformanceContext,
  },
  "/engagement/:app_group_id/canvas/:workflow_id/content_optimization_launch_limit": {
    GET: getEngagementAppGroupIdCanvasWorkflowIdContentOptimizationLaunchLimit,
  },
  "/engagement/:app_group_id/canvas/:workflow_id/step/:step_id/preview_path": {
    POST: postEngagementCanvasStepPreviewPath,
  },
  "/engagement/:app_group_id/canvas/:workflow_id/versions": { GET: getCanvasVersions },
  "/engagement/:app_group_id/canvas/:workflow_id/versions/:version_id": {
    DELETE: discardCanvasVersion,
    GET: getCanvasVersion,
    PUT: putCanvasVersion,
  },
  "/engagement/:app_group_id/canvas/:workflow_id/versions/:version_id/steps": { GET: getCanvasVersionStepsChunked },
  "/engagement/:app_group_id/canvas/content_optimizer_steps": {
    GET: getEngagementAppGroupIdCanvasContentOptimizerSteps,
  },
  "/engagement/:app_group_id/canvas/step/batched_stats/:step_type": {
    GET: getEngagementAppGroupIdCanvasStepBatchedStatsStepType,
  },
  "/engagement/:app_group_id/canvas_country_performance/:workflow_id": {
    GET: getEngagementAppGroupIdCanvasCountryPerformanceWorkflowId,
  },
  "/engagement/:app_group_id/canvas_last_edit/:workflow_id": { GET: getCanvasLastEdit },
  "/engagement/:app_group_id/cj_credentials_data": { GET: getDataTableCjCredentials },
  "/engagement/:app_group_id/cloud_storage_capability": { GET: getCloudStorageCapability },
  "/engagement/:app_group_id/compiled_iam_custom_css": { POST: postCompiledIamCustomCss },
  "/engagement/:app_group_id/content_blocks/:id/preview_thumbnail": {
    GET: getEngagementAppGroupIdContentBlocksIdPreviewThumbnail,
  },
  "/engagement/:app_group_id/create_accessibility_test": { POST: postCreateAccessibilityTest },
  "/engagement/:app_group_id/create_email_test": { POST: postEngagementCreateEmailTest },
  "/engagement/:app_group_id/create_spam_test": { POST: postEngagementCreateSpamTest },
  "/engagement/:app_group_id/crop_image_asset": { POST: postEngagementAppGroupIdCropImageAsset },
  "/engagement/:app_group_id/destination_canvas_notification_dismissed/:workflow_id": {
    GET: getEngagementAppGroupIdDestinationCanvasNotificationDismissedWorkflowId,
    POST: postEngagementAppGroupIdDestinationCanvasNotificationDismissedWorkflowId,
  },
  "/engagement/:app_group_id/email_settings": { GET: getEmailSettingsApiEndpoint },
  "/engagement/:app_group_id/email_subscription_groups": {
    GET: getSubscriptionGroups,
  },
  "/engagement/:app_group_id/email_templates/:id/preview_thumbnail": {
    GET: getEngagementAppGroupIdEmailTemplatesIdPreviewThumbnail,
  },
  "/engagement/:app_group_id/feature_flag_limits": { GET: getEngagementAppGroupIdFeatureFlagLimits },
  "/engagement/:app_group_id/feature_flags/:rollout_id/dependencies": {
    GET: getEngagementAppGroupIdFeatureFlagsRolloutIdDependencies,
  },
  "/engagement/:app_group_id/feature_flags/:rollout_id/experiment_usage": {
    GET: getEngagementAppGroupIdFeatureFlagsRolloutIdExperimentUsage,
  },
  "/engagement/:app_group_id/feature_flags/tags": { GET: getEngagementAppGroupIdFeatureFlagsTags },
  "/engagement/:app_group_id/feature_flags/update_tags": { POST: postEngagementAppGroupIdFeatureFlagsUpdateTags },
  "/engagement/:app_group_id/feature_flags_info": { GET: getEngagementAppGroupIdFeatureFlagsInfo },
  "/engagement/:app_group_id/feature_limitations": { GET: getEngagementAppGroupIdFeatureLimitations },
  "/engagement/:app_group_id/from_email_domains": { GET: getFromEmailDomains },
  "/engagement/:app_group_id/generate_video_presigned_url/:asset_id": { GET: getVideoPresignedUrl },
  "/engagement/:app_group_id/get_accessibility_results/:id": {
    GET: getAccessibilityResults,
  },
  "/engagement/:app_group_id/get_asset_metadata": { GET: getEngagementAppGroupIdGetAssetMetadata },
  "/engagement/:app_group_id/get_email_client_metadata/:id": { GET: getEngagementGetEmailClientMetadata },
  "/engagement/:app_group_id/get_email_results/:id": { GET: getEngagementGetEmailResults },
  "/engagement/:app_group_id/get_spam_client_descriptions": { GET: getEngagementGetSpamClientDescriptions },
  "/engagement/:app_group_id/get_spam_results/:id": { GET: getEngagementGetSpamResultsId },
  "/engagement/:app_group_id/has_feature_flags": {
    GET: getEngagementAppGroupIdHasFeatureFlags,
  },
  "/engagement/:app_group_id/infobip_kakao_sender_keys_data": { GET: getDataTableInfobipKakaoSenderKeys },
  "/engagement/:app_group_id/kakao_sender_keys": { GET: getEngagementAppGroupIdKakaoSenderKeys },
  "/engagement/:app_group_id/library_delete": { POST: postEngagementAppGroupIdLibraryDelete },
  "/engagement/:app_group_id/library_edit": { PUT: putEngagementAppGroupIdLibraryEdit },
  "/engagement/:app_group_id/library_image": {
    POST: postImageData,
  },
  "/engagement/:app_group_id/library_replace_file": { PUT: putEngagementAppGroupIdLibraryReplaceFile },
  "/engagement/:app_group_id/library_update_tags": { POST: postEngagementAppGroupIdLibraryUpdateTags },
  "/engagement/:app_group_id/line_subscription_groups": {
    GET: getLineSubscriptionGroups,
  },
  "/engagement/:app_group_id/link_aliases/get_triggerable_links": {
    GET: getEngagementAppGroupIdLinkAliasesGetTriggerableLinks,
  },
  "/engagement/:app_group_id/list_email_settings": { GET: getEngagementListEmailSettings },
  "/engagement/:app_group_id/media_library_asset_data/:asset_id": { GET: getMediaLibraryAssetData },
  "/engagement/:app_group_id/media_library_sources": { GET: getMediaLibrarySources },
  "/engagement/:app_group_id/media_library_tags": {
    GET: getMediaLibraryTags,
  },
  "/engagement/:app_group_id/media_library_territories": {
    GET: getMediaLibraryTeams,
  },
  "/engagement/:app_group_id/preset_banner_templates": {
    GET: getDataTableEngagementAppGroupIdPresetBannerTemplates,
  },
  "/engagement/:app_group_id/preset_banner_templates/:id": { GET: getEngagementAppGroupIdPresetBannerTemplatesId },
  "/engagement/:app_group_id/push_settings": { GET: getEngagementAppGroupIdPushSettings },
  "/engagement/:app_group_id/random_user_id": { GET: getAppGroupRandomUserId },
  "/engagement/:app_group_id/shareable_preview": { POST: postEngagementAppGroupIdShareablePreviewLink },
  "/engagement/:app_group_id/shareable_preview/:context_id": {
    GET: getEngagementAppGroupIdShareablePreviewLinks,
  },
  "/engagement/:app_group_id/sms_inbound_message_keyword_categories": {
    GET: getEngagementAppGroupIdSmsInboundMessageKeywordCategories,
  },
  "/engagement/:app_group_id/sms_messaging_services": {
    GET: getSmsMessagingServices,
  },
  "/engagement/:app_group_id/structural_template/blank_canvas_template": { POST: postBlankCanvasTemplate },
  "/engagement/:app_group_id/structural_template/canvas_template": {
    POST: postEngagementAppGroupIdStructuralTemplateCanvasTemplate,
  },
  "/engagement/:app_group_id/structural_template/canvas_template/:id": { GET: getCanvasTemplatePreview },
  "/engagement/:app_group_id/structural_template/canvas_template/:template_id/canvas": {
    POST: postCanvasFromCanvasTemplate,
  },
  "/engagement/:app_group_id/structural_template/canvas_template/canvas/:canvas_id": {
    DELETE: deleteCanvasFromCanvasTemplate,
    POST: postEngagementAppGroupIdStructuralTemplateCanvasTemplateCanvasCanvasId,
  },
  "/engagement/:app_group_id/structural_template/canvas_template_clone": {
    POST: postEngagementAppGroupIdStructuralTemplateCanvasTemplateClone,
  },
  "/engagement/:app_group_id/structural_template/canvas_template_cloned_steps_data": {
    GET: getEngagementAppGroupIdStructuralTemplateCanvasTemplateClonedStepsData,
  },
  "/engagement/:app_group_id/structural_template/canvas_template_rename": {
    PUT: putEngagementAppGroupIdStructuralTemplateCanvasTemplateRename,
  },
  "/engagement/:app_group_id/structural_template/canvas_template_tags": {
    GET: getEngagementAppGroupIdStructuralTemplateCanvasTemplateTags,
  },
  "/engagement/:app_group_id/structural_template/canvas_template_territories": {
    GET: getEngagementAppGroupIdStructuralTemplateCanvasTemplateTerritories,
  },
  "/engagement/:app_group_id/structural_template/canvas_template_update_archived_state": {
    POST: postEngagementAppGroupIdStructuralTemplateCanvasTemplateUpdateArchivedState,
  },
  "/engagement/:app_group_id/structural_template/canvas_template_update_tags": {
    POST: postEngagementAppGroupIdStructuralTemplateCanvasTemplateUpdateTags,
  },
  "/engagement/:app_group_id/structural_template/canvas_template_upsert": {
    POST: postEngagementAppGroupIdStructuralTemplateCanvasTemplateUpsert,
  },
  "/engagement/:app_group_id/structural_template/canvas_templates_data": { GET: getDataTableCanvasTemplates },
  "/engagement/:app_group_id/suppression_rules": {
    GET: getDataTableEngagementAppGroupIdSuppressionRules,
    POST: postEngagementAppGroupIdSuppressionRules,
  },
  "/engagement/:app_group_id/suppression_rules/:id": {
    GET: getEngagementAppGroupIdSuppressionRulesId,
    PUT: putEngagementAppGroupIdSuppressionRulesId,
  },
  "/engagement/:app_group_id/survey/export_responses": { POST: postEngagementAppGroupIdSurveyExportResponses },
  "/engagement/:app_group_id/survey/question/chart": { GET: getEngagementSurveyQuestionChart },
  "/engagement/:app_group_id/survey/question/responses": {
    GET: getDataTableEngagementAppGroupIdSurveyQuestionResponses,
  },
  "/engagement/:app_group_id/survey/stats": { GET: getEngagementAppGroupIdSurveyStats },
  "/engagement/:app_group_id/surveys": { GET: getDataTableEngagementAppGroupIdSurveys },
  "/engagement/:app_group_id/surveys/survey_stats_summary": {
    GET: getEngagementAppGroupIdSurveysSurveyStatsSummary,
  },
  "/engagement/:app_group_id/templated_preview": {
    GET: getEngagementAppGroupIdTemplatedPreview,
    POST: postEngagementAppGroupIdTemplatedPreview,
  },
  "/engagement/:app_group_id/test_send": {
    POST: postEngagementTestSend,
  },
  "/engagement/:app_group_id/test_send/free_trial_allowed_domains": {
    GET: getEngagementAppGroupIdTestSendFreeTrialAllowedDomains,
  },
  "/engagement/:app_group_id/transactional_web_push_test": {
    POST: postEngagementAppGroupIdTransactionalWebPushTest,
  },
  "/engagement/:app_group_id/whats_app/accounts": {
    GET: getWhatsAppAccounts,
  },
  "/engagement/:app_group_id/whats_app/message_template/:id": {
    DELETE: deleteWhatsAppMessageTemplateDraft,
    GET: getWhatsAppMessageTemplateById,
  },
  "/engagement/:app_group_id/whats_app/message_templates": {
    GET: getEngagementAppGroupIdWhatsAppMessageTemplates,
    POST: postWhatsAppMessageTemplate,
  },
  "/engagement/:app_group_id/whats_app/message_templates/:external_account_id": {
    GET: getEngagementAppGroupIdWhatsAppMessageTemplatesExternalAccountId,
  },
  "/engagement/:app_group_id/whats_app/message_templates/save_as_draft": {
    POST: postSaveWhatsAppMessageTemplateAsDraft,
  },
  "/engagement/:app_group_id/whats_app/waba/creative_optimization_settings": {
    GET: getWabaCreativeOptimizationSettings,
    POST: postWabaCreativeOptimizationSettings,
  },
  "/engagement/:app_group_id/whats_app_subscription_groups": {
    GET: getWhatsAppSubscriptionGroups,
  },
  "/engagement/:app_group_id/whatsapp/flow_details/:messaging_service_id/:flow_id": {
    GET: getWhatsAppFlowDetails,
  },
  "/engagement/:app_group_id/whatsapp/flows/:messaging_service_id": {
    GET: getWhatsAppFlowList,
  },
  "/engagement/:app_group_id/whatsapp/flows/sg/:subscription_group_id": {
    GET: getWhatsAppFlowListBySubscriptionGroup,
  },
  "/engagement/:app_group_id/whatsapp/meta_api_scopes/:messaging_service_id": {
    GET: getWhatsAppMetaScopes,
  },
  "/engagement/:app_group_id/whatsapp/mm_lite_api_status": { GET: getEngagementAppGroupIdWhatsappMmLiteApiStatus },
  "/engagement/:app_group_id/whatsapp/mm_lite_api_status/:messaging_service_id": {
    GET: getWhatsAppMmLiteStatusForMessagingService,
  },
  "/engagement/:app_group_id/whatsapp/product_data/:messaging_service_id": {
    GET: getWhatsAppProductData,
  },
  "/engagement/:app_id/feature_flags_eligibility/:user_id/:device_id": {
    GET: getDataTableEngagementAppIdFeatureFlagsEligibilityUserIdDeviceId,
  },
  "/engagement/ab_testing_schedule_data": { GET: getEngagementAbTestingScheduleData },
  "/engagement/all_cards": {
    GET: getAllCards,
  },
  "/engagement/android_notification_channels": {
    GET: getAndroidNotificationChannels,
  },
  "/engagement/api/segment_cohorts": {
    GET: getSegmentCohorts,
    POST: createSegmentCohort,
  },
  "/engagement/api/segment_cohorts/:id": {
    GET: getSegmentCohort,
    PATCH: patchSegmentCohort,
  },
  "/engagement/api/segment_cohorts/:id/engagements": {
    GET: getSegmentCohortEngagements,
  },
  "/engagement/api/segment_cohorts/:id/refresh": {
    POST: refreshSegmentCohort,
  },
  "/engagement/api/segment_cohorts/billing_history": { GET: getEngagementApiSegmentCohortsBillingHistory },
  "/engagement/api/segment_cohorts/current_billing_cycle": {
    GET: getEngagementApiSqlSegmentCohortsAccountUsage,
  },
  "/engagement/api/segment_cohorts/preview_sql": { POSTWS: segmentCohortsPreviewSql },
  "/engagement/api/segment_cohorts/preview_sql/:query_id": { GET: segmentCohortsPreviewSqlResults },
  "/engagement/api/segment_cohorts/tags": { GET: getEngagementApiSegmentCohortsTags },
  "/engagement/api/suppression_lists": { GET: getEngagementApiSuppressionLists },
  "/engagement/api/suppression_lists/:id": { GET: getEngagementApiSuppressionListsId },
  "/engagement/api/suppression_lists_settings": { GET: getEngagementApiSuppressionListsSettings },
  "/engagement/approvals/:context_id/(:step)": {
    GET: getEngagementApprovalsStep,
    PATCH: patchEngagementApprovalsStep,
  },
  "/engagement/approvals/:context_id/approve_all": { PATCH: patchEngagementApprovalsContextIdApproveAll },
  "/engagement/async/apps_and_filters_preview/:app_group_id": {
    POSTWS: getAppsAndFiltersPreview,
  },
  "/engagement/async/campaign_preview/:app_group_id": { POSTWS: postwsEngagementAsyncCampaignPreviewAppGroupId },
  "/engagement/async/segment_insights_actual_stats": { POSTWS: getEngagementAsyncSegmentInsightsActualStats },
  "/engagement/async/segment_insights_stats/:app_group_id": {
    POSTWS: getEngagementAsyncSegmentInsightsStatsAppGroupId,
  },
  "/engagement/async/segments_and_filters_preview/:app_group_id": {
    POSTWS: engagementAsyncSegmentsAndFiltersPreviewAppGroupId,
  },
  "/engagement/audience_sync/:platform/ad_accounts": { GET: getEngagementAudienceSyncPlatformAdAccounts },
  "/engagement/audience_sync/:platform/ad_accounts/:ad_account_id": {
    GET: getEngagementAudienceSyncPlatformAdAccountsAdAccountId,
  },
  "/engagement/audience_sync/:platform/ad_accounts/:ad_account_id/audiences": {
    POST: postEngagementAudienceSyncPlatformAdAccountsAdAccountIdAudiences,
  },
  "/engagement/braze_report_dashboard": { POST: postEngagementBrazeReportDashboard },
  "/engagement/braze_report_dashboard/:type": { GET: getEngagementBrazeReportDashboardType },
  "/engagement/braze_report_dashboard_run_event/:dashboard_run_event_id/cancel": {
    POST: postEngagementBrazeReportDashboardRunEventDashboardRunEventIdCancel,
  },
  "/engagement/braze_report_dashboard_run_event/:dashboard_type(/:dashboard_id)": {
    GET: getReportDashboardRunEvent,
  },
  "/engagement/campaign/active_draft/:campaign_id": { DELETE: deleteEngagementCampaignActiveDraftCampaignId },
  "/engagement/campaign_banner_click_daily_stats/:campaign_id": {
    GET: getEngagementCampaignBannerClickDailyStatsCampaignId,
  },
  "/engagement/campaign_data(/:campaign_id)": { GET: getEngagementCampaignDataCampaignId },
  "/engagement/campaign_email_click_daily_stats/:campaign_id": { GET: getCampaignEmailClickDailyStats },
  "/engagement/campaign_iam_click_daily_stats/:campaign_id": {
    GET: getEngagementCampaignIamClickDailyStatsCampaignId,
  },
  "/engagement/campaign_schedule_summary": { PUT: putEngagementCampaignScheduleSummary },
  "/engagement/campaign_stats/:campaign_id": { GET: getEngagementCampaignStats },
  "/engagement/campaigns": { POST: postCampaign },
  "/engagement/campaigns/:app_group_id/:campaign_id/auto_stop_exemption": {
    PATCH: patchEngagementCampaignsAppGroupIdCampaignIdAutoStopExemption,
  },
  "/engagement/campaigns/:app_group_id/campaigns_with_exceptions": { GET: getCampaignsWithExceptions },
  "/engagement/campaigns/:app_group_id/eligible": {
    GET: getEligibleCampaigns,
  },
  "/engagement/campaigns/:app_group_id/update_archived_state": {
    POST: postEngagementCampaignsAppGroupIdUpdateArchivedState,
  },
  "/engagement/campaigns/:app_group_id/update_enabled_state": {
    POST: postEngagementCampaignsAppGroupIdUpdateEnabledState,
  },
  "/engagement/campaigns/:app_group_id/update_tags": {
    POST: postEngagementCampaignsUpdateTags,
  },
  "/engagement/campaigns/:campaign_id/export": { POST: postEngagementCampaignsCampaignIdExport },
  "/engagement/campaigns/aggregate_stats/:app_group_id": { GET: getCampaignAggregateStats },
  "/engagement/campaigns/campaign_alert_preferences_delete/:campaign_id": {
    DELETE: deleteEngagementCampaignsCampaignAlertPreferencesDeleteCampaignId,
  },
  "/engagement/campaigns/campaign_alert_preferences_update": {
    PUT: putEngagementCampaignsCampaignAlertPreferencesUpdate,
  },
  "/engagement/campaigns/campaign_limits/:app_group_id": { GET: getEngagementCampaignLimits },
  "/engagement/campaigns/campaign_occurrences/:app_group_id": { GET: getCampaignOccurrences },
  "/engagement/campaigns/campaign_territories": { GET: getEngagementCampaignsCampaignTerritories },
  "/engagement/campaigns/campaigns_with_carousel_slides": {
    GET: getEngagementCampaignsCampaignsWithCarouselSlides,
  },
  "/engagement/campaigns/campaigns_with_push_buttons": { GET: getEngagementCampaignsCampaignsWithPushButtons },
  "/engagement/campaigns/campaigns_with_replied_to_sms": { GET: getEngagementCampaignsCampaignsWithRepliedToSms },
  "/engagement/campaigns/carousel_slides_for_campaign": { GET: getEngagementCampaignsCarouselSlidesForCampaign },
  "/engagement/campaigns/clone": { POST: postEngagementCampaignsClone },
  "/engagement/campaigns/conversion_correlation_data/:campaign_id": {
    POST: getEngagementCampaignsConversionCorrelationDataCampaignId, // type is POST for typings reasons, this is a get request
  },
  "/engagement/campaigns/create_default": { POST: postEngagementCampaignsCreateDefault },
  "/engagement/campaigns/draft_active_campaign": { POST: postEngagementCampaignsDraftActiveCampaign },
  "/engagement/campaigns/experiment_data/:campaign_id": { GET: getEngagementCampaignsExperimentDataCampaignId },
  "/engagement/campaigns/global_frequency_caps/:app_group_id": { GET: getCampaignsGlobalFrequencyCaps },
  "/engagement/campaigns/global_rate_limits/:app_group_id": {
    GET: getEngagementCampaignsGlobalRateLimitsAppGroupId,
  },
  "/engagement/campaigns/push_buttons_for_campaign": { GET: getEngagementCampaignsPushButtonsForCampaign },
  "/engagement/campaigns/restore_campaign_retargeting_data": {
    POST: postEngagementCampaignsRestoreCampaignRetargetingData,
  },
  "/engagement/campaigns/set_global_frequency_caps": { PUT: putEngagementCampaignsSetGlobalFrequencyCaps },
  "/engagement/campaigns/set_global_rate_limits": { PUT: putEngagementCampaignsSetGlobalRateLimits },
  "/engagement/campaigns/tags": { GET: getEngagementCampaignsTags },
  "/engagement/campaigns/tags_with_ids": { GET: getEngagementCampaignsTagsWithIds },
  "/engagement/campaigns_data": {
    GET: getCampaignsData,
  },
  "/engagement/campaigns_data_filters": { POST: postEngagementCampaignsDataFilters },
  "/engagement/campaigns_data_get_saved_filters": { GET: getEngagementCampaignsDataGetSavedFilters },
  "/engagement/campaigns_data_v2": { GET: getDataTableEngagementCampaignsDataV2 },
  "/engagement/canvas": { POST: postEngagementCanvas },
  "/engagement/canvas/:app_group_id/eligible": { GET: getEligibleCanvas },
  "/engagement/canvas/:workflow_id/export": { POST: postEngagementCanvasExport },
  "/engagement/canvas/active_draft/:workflow_id": { DELETE: deleteEngagementCanvasActiveDraftWorkflowId },
  "/engagement/canvas/canvas_territories": { GET: getEngagementCanvasCanvasTerritories },
  "/engagement/canvas/carousel_slides_for_canvas": {
    GET: getEngagementCanvasCarouselSlides,
  },
  "/engagement/canvas/changelogs": { GET: getCanvasChangelogs },
  "/engagement/canvas/context_update_step_preview": {
    POST: postEngagementCanvasContextUpdateStepPreview,
  },
  "/engagement/canvas/items_blocking_steps_or_variations_deletion": {
    POST: postEngagementCanvasItemsBlockingStepsOrVariationsDeletion,
  },
  "/engagement/canvas/llm_step_preview": { POST: postEngagementCanvasLlmStepPreview },
  "/engagement/canvas/push_buttons_for_canvas": { GET: getEngagementCanvasPushButtons },
  "/engagement/canvas/restore_canvas_retargeting_data": { POST: postEngagementCanvasRestoreCanvasRetargetingData },
  "/engagement/canvas/send_to_destination_related_canvases(/:canvas_id)": {
    GET: getEngagementCanvasSendToDestinationRelatedCanvases,
  },
  "/engagement/canvas/stats/:workflow_id": { GET: getEngagementCanvasStatsWorkflowId },
  "/engagement/canvas/tags": { GET: getEngagementCanvasTags },
  "/engagement/canvas_comparison_reports/canvases(/:app_group_id)": {
    GET: getEngagementCanvasComparisonReportsCanvasesAppGroupId,
  },
  "/engagement/canvas_data(/:workflow_id)": { GET: getCanvas },
  "/engagement/canvas_steps/:workflow_id/:app_group_id": { POST: getCanvasStepsPost },
  "/engagement/canvases_data/": { GET: getDataTableEngagementCanvasesData },
  "/engagement/canvases_for_clicked_shortened_sms_link": { GET: getEngagementCanvasesForClickedShortenedSmsLink },
  "/engagement/canvases_with_replied_to_sms": { GET: getEngagementCanvasesWithRepliedToSms },
  "/engagement/changelogs": { GET: getChangelogs },
  "/engagement/content_block_inclusions/:id": { GET: getEngagementContentBlockInclusionsId },
  "/engagement/content_block_locales": { GET: getEngagementContentBlockLocales },
  "/engagement/content_blocks": { GET: getDataTableEngagementContentBlocks },
  "/engagement/content_blocks(/:id)": { POST: postEngagementContentBlocksId },
  "/engagement/content_blocks/:id": { GET: getEngagementContentBlocksId },
  "/engagement/content_blocks/content": { GET: getEngagementContentBlocksContent },
  "/engagement/content_blocks/duplicate": { POST: postEngagementContentBlocksDuplicate },
  "/engagement/content_blocks/names": { GET: getEngagementContentBlocksNames },
  "/engagement/content_blocks/select": { GET: getEngagementContentBlocksSelect },
  "/engagement/content_blocks/tags": { GET: getEngagementContentBlocksTags },
  "/engagement/content_blocks/territories": { GET: getEngagementContentBlocksTerritories },
  "/engagement/content_blocks/update_archived_state": { POST: postEngagementContentBlocksUpdateArchivedState },
  "/engagement/content_blocks/update_tags": { POST: postEngagementContentBlocksUpdateTags },
  "/engagement/conversion_filter_preview": { POST: postEngagementConversionFilterPreview },
  "/engagement/conversion_report": { POST: postEngagementConversionReport, PUT: putEngagementConversionReport },
  "/engagement/conversion_report/:report_id/cancel": { POST: postEngagementCancelConversionReport },
  "/engagement/create_location_set": { POST: postEngagementCreateLocationSet },
  "/engagement/draganddrop_content_blocks": {
    GET: getDragAndDropContentBlocks,
  },
  "/engagement/edit_locations_apps": { PUT: putEngagementEditLocationsApps },
  "/engagement/email_template_sources": { GET: getEmailTemplateSources },
  "/engagement/email_templates": { GET: getDataTableEngagementEmailTemplates },
  "/engagement/email_templates/:id": { GET: getEngagementEmailTemplatesId, POST: postEngagementEmailTemplatesId },
  "/engagement/email_templates/duplicate": { POST: postEngagementEmailTemplatesDuplicate },
  "/engagement/email_templates/tags": { GET: getEngagementEmailTemplatesTags },
  "/engagement/email_templates/territories": { GET: getEngagementEmailTemplatesTerritories },
  "/engagement/email_templates/update_archived_state": { POST: postEngagementEmailTemplatesUpdateArchivedState },
  "/engagement/email_templates/update_tags": { POST: postEngagementEmailTemplatesUpdateTags },
  "/engagement/email-message/dnd-editor/access-token": {
    GET: getEngagementEmailMessageDndEditorAccessToken,
  },
  "/engagement/email-message/dnd-editor/simple-to-full-json": {
    POST: postEngagementEmailMessageDndEditorSimpleToFullJson,
  },
  "/engagement/export_logs": { GET: getDataTableExportLogs },
  "/engagement/export_logs/:log_id/:app_group_id": { GET: getExportLogsResult },
  "/engagement/export_logs/:log_id/:app_group_id/cancel": { POST: postExportLogsCancel },
  "/engagement/expressive_report/table_definitions": { GET: getEngagementGetTableDefinitions },
  "/engagement/expressive_reports": { GET: getEngagementQueryBuilderReports },
  "/engagement/expressive_reports/:report_id": {
    DELETE: deleteQueryBuilderReport,
    GET: getEngagementQueryBuilderReport,
  },
  "/engagement/expressive_reports/:report_id/archive": {
    POST: archiveQueryBuilderReport,
  },
  "/engagement/feature_flag_rollout_upsert": { POST: postEngagementFeatureFlagRolloutUpsert },
  "/engagement/feature_flag_rollouts_data": { GET: getFeatureFlagRolloutsData },
  "/engagement/feature_flag_rollouts_data/:feature_flag_bson_id/:app_group_id": {
    GET: getEngagementFeatureFlagRolloutsDataFeatureFlagBsonIdAppGroupId,
  },
  "/engagement/filter_groups": { GET: getEngagementFilterGroups },
  "/engagement/filter_type": {
    GET: getEngagementFilterType,
  },
  "/engagement/geofences_data(/:location_set_id)": { GET: getEngagementGeofencesData },
  "/engagement/get_canvases_for_filter": { GET: getEngagementGetCanvasesForFilter },
  "/engagement/get_changelogs": { GET: getEngagementGetChangelogs },
  "/engagement/get_product_recommender_properties": { GET: getEngagementGetProductRecommenderProperties },
  "/engagement/global_control_settings": {
    GET: getGlobalControlSettings,
  },
  "/engagement/in_app_message_campaigns_and_workflows_data": {
    GET: getEngagementInAppMessageCampaignsAndWorkflowsData,
  },
  "/engagement/in_app_message_color_profiles": { GET: getDataTableEngagementInAppMessageColorProfiles },
  "/engagement/in_app_message_color_profiles(/:id)": {
    GET: getEngagementInAppMessageColorProfilesId,
    POST: postEngagementInAppMessageColorProfilesId,
  },
  "/engagement/in_app_message_color_profiles/default": { GET: getEngagementInAppMessageColorProfilesDefault },
  "/engagement/in_app_message_color_profiles/duplicate": { POST: postEngagementInAppMessageColorProfilesDuplicate },
  "/engagement/in_app_message_color_profiles/tags": { GET: getEngagementInAppMessageColorProfilesTags },
  "/engagement/in_app_message_color_profiles/territories": {
    GET: getEngagementInAppMessageColorProfilesTerritories,
  },
  "/engagement/in_app_message_color_profiles/update_archived_state": {
    POST: postEngagementInAppMessageColorProfilesUpdateArchivedState,
  },
  "/engagement/in_app_message_color_profiles/update_tags": {
    POST: postEngagementInAppMessageColorProfilesUpdateTags,
  },
  "/engagement/intelligent_delivery_preview/:app_group_id": { POST: postEngagementIntelligentDeliveryPreview },
  "/engagement/invalid_attribute_names": { GET: getEngagementInvalidAttributeNames },
  "/engagement/ios_notification_groups": { GET: getIosNotificationGroups },
  "/engagement/jumpstart_content_blocks/:id": { GET: getEngagementJumpstartContentBlocks },
  "/engagement/jumpstart_email_templates/:id": { GET: getEngagementJumpstartEmailTemplates },
  "/engagement/landing_page_data": { GET: getEngagementLandingPageData },
  "/engagement/landing_page_template(/:id)": { PUT: putEngagementLandingPageTemplateId },
  "/engagement/landing_page_templates/duplicate": { POST: postEngagementLandingPageTemplatesDuplicate },
  "/engagement/landing_page_templates/update_archived_state": {
    POST: postEngagementLandingPageTemplatesUpdateArchivedState,
  },
  "/engagement/landing_page_templates_data": { GET: getDataTableEngagementLandingPageTemplatesData },
  "/engagement/landing_page_templates_data/:id": { GET: getEngagementLandingPageTemplatesDataId },
  "/engagement/landing_pages/:app_group_id/:landing_page_bson_id": {
    PUT: putEngagementLandingPagesAppGroupIdLandingPageId,
  },
  "/engagement/landing_pages/:app_group_id/:landing_page_bson_id/copy/:target_app_group_id": {
    POST: postEngagementLandingPagesAppGroupIdLandingPageIdCopyTargetAppGroupId,
  },
  "/engagement/landing_pages/:app_group_id/:landing_page_bson_id/post_launch_draft": {
    DELETE: deleteLandingPagePostLaunchDraft,
    POST: postLandingPageSavePostLaunchDraft,
  },
  "/engagement/landing_pages/:app_group_id/:landing_page_bson_id/preview": {
    GET: getEngagementLandingPagesAppGroupIdLandingPageIdPreview,
  },
  "/engagement/landing_pages/:app_group_id/create": {
    POST: postEngagementLandingPagesAppGroupIdLandingPageId,
  },
  "/engagement/landing_pages/:app_group_id/create_landing_page_app": {
    POST: postEngagementLandingPagesAppGroupIdCreateLandingPageApp,
  },
  "/engagement/landing_pages/:app_group_id/custom_domain_limits": { GET: getLandingPagesCustomDomainLimits },
  "/engagement/landing_pages/:app_group_id/custom_subdomain": {
    DELETE: deleteLandingPagesCustomSubdomain,
    GET: getLandingPagesCustomSubdomain,
    POST: postLandingPagesCustomSubdomain,
  },
  "/engagement/landing_pages/:app_group_id/custom_subdomain/reactivate": {
    POST: postLandingPagesCustomSubdomainReactivate,
  },
  "/engagement/landing_pages/:app_group_id/duplicate": { POST: postEngagementLandingPagesAppGroupIdDuplicate },
  "/engagement/landing_pages/:app_group_id/landing_page_stats/:landing_page_id": {
    GET: getEngagementLandingPageStats,
  },
  "/engagement/landing_pages/:app_group_id/limits": { GET: getEngagementLandingPagesAppGroupIdLimits },
  "/engagement/landing_pages/:app_group_id/select": { GET: getEngagementLandingPagesAppGroupIdSelect },
  "/engagement/landing_pages/:app_group_id/size_limits": { GET: getEngagementLandingPagesAppGroupIdSizeLimits },
  "/engagement/landing_pages/:app_group_id/survey_landing_pages_with_question": {
    GET: getDataTableEngagementLandingPagesAppGroupIdSurveyLandingPagesWithQuestion,
  },
  "/engagement/landing_pages/:app_group_id/update_archived_state": {
    POST: postEngagementLandingPagesAppGroupIdUpdateArchivedState,
  },
  "/engagement/landing_pages/select": { GET: getLandingPageNamesForSelect },
  "/engagement/landing_pages_data": { GET: getDataTableEngagementLandingPagesData },
  "/engagement/link_alias_campaign_email_click_daily_stats/:campaign_id/:mv_id": {
    GET: getLinkAliasCampaignEmailClickDailyStats,
  },
  "/engagement/link_aliases/get_tracked_links": {
    GET: getTrackedLinks,
  },
  "/engagement/link_aliases/update_links": {
    POST: postLinkAliasLinks,
  },
  "/engagement/link_aliases/upsert_lid": { GET: getEngagementLinkAliasesUpsertLid, POST: postLinkAliasMarkup },
  "/engagement/link_templates(/:id)": { GET: getEngagementLinkTemplatesId, POST: postEngagementLinkTemplatesId },
  "/engagement/link_templates/select": { GET: getEngagementLinkTemplates },
  "/engagement/link_templates/tags": { GET: getEngagementLinkTemplatesTags },
  "/engagement/link_templates/territories": { GET: getEngagementLinkTemplatesTerritories },
  "/engagement/link_templates/update_tags": { POST: postEngagementLinkTemplatesUpdateTags },
  "/engagement/list_campaigns_for_report_builder": { GET: getListCampaignsForReportBuilder },
  "/engagement/location_set_data": { GET: getEngagementLocationSetData },
  "/engagement/location_set_triggers": {
    GET: getLocationSetTriggers,
  },
  "/engagement/location_sets_data": { GET: getDataTableEngagementLocationSetsData },
  "/engagement/location_sets_update_archived_state": { POST: postEngagementLocationSetsUpdateArchivedState },
  "/engagement/locations_apps": { GET: getEngagementLocationsApps },
  "/engagement/locations_tags": { GET: getEngagementLocationsTags },
  "/engagement/media_library_data": {
    GET: getFileList,
  },
  "/engagement/messaging_services": { GET: getMessagingServices },
  "/engagement/placement_campaign_bases_data_v2": { GET: getDataTableEngagementPlacementCampaignBasesDataV2 },
  "/engagement/prediction/clone": { POST: postEngagementPredictionClone },
  "/engagement/prediction_app_group_data": { GET: getEngagementPredictionAppGroupData },
  "/engagement/prediction_data(/:prediction_id)": { GET: getEngagementPrediction },
  "/engagement/prediction_filters_preview/:app_group_id": {
    GET: getEngagementPredictionFiltersPreviewAppGroupId,
  },
  "/engagement/prediction_stats(/:prediction_id)": { GET: getEngagementPredictionStatsPredictionId },
  "/engagement/predictions": { POST: postEngagementPredictions },
  "/engagement/predictions/get_custom_event_names": { GET: getEngagementPredictionsGetCustomEventNames },
  "/engagement/predictions_data": { GET: getDataTableEngagementPredictionsData },
  "/engagement/preset_draganddrop_templates": { GET: getEngagementPresetDraganddropTemplates },
  "/engagement/preset_email_templates": { GET: getDataTableEngagementPresetEmailTemplates },
  "/engagement/preset_email_templates/:id": { GET: getEngagementPresetEmailTemplatesId },
  "/engagement/preset_iam_templates": { GET: getDataTableEngagementPresetIamTemplates },
  "/engagement/preset_landing_page_templates_data": { GET: getDataTableEngagementPresetLandingPageTemplatesData },
  "/engagement/preset_landing_page_templates_data/:id": { GET: getEngagementPresetLandingPageTemplatesDataId },
  "/engagement/preset_webhook_templates": { GET: getDataTableEngagementPresetWebhookTemplates },
  "/engagement/preset_webhook_templates/:id": { GET: getEngagementPresetWebhookTemplatesId },
  "/engagement/product_recommendations": { POST: postEngagementProductRecommendations },
  "/engagement/product_recommendations(/:recommender_id)": {
    GET: getEngagementProductRecommendationsRecommenderId,
  },
  "/engagement/product_recommender_names": { GET: getEngagementProductRecommenderNames },
  "/engagement/query_builder/:app_group_id/:report_id/schedule": {
    POST: postEngagementQueryBuilderAppGroupIdReportIdSchedule,
  },
  "/engagement/query_builder/:report_id/:app_group_id/export": {
    POST: postEngagementQueryBuilderReportIdAppGroupIdExport,
  },
  "/engagement/query_builder/credits": { GET: getEngagementQueryBuilderCredits },
  "/engagement/recommendations_metadata": { GET: getEngagementRecommendationsMetadata },
  "/engagement/recommender_analytics": { GET: getEngagementRecommenderAnalytics },
  "/engagement/remote_filter_query": { GET: getEngagementRemoteFilterQuery },
  "/engagement/remote_filter_shells": { GET: getEngagementRemoteFilterShells },
  "/engagement/remote_segment_search": { GET: getEngagementRemoteSegmentSearch },
  "/engagement/remove_all_content_cards": { POST: postEngagementRemoveAllContentCards },
  "/engagement/reorder_in_app_messages": { POST: postEngagementReorderInAppMessages },
  "/engagement/report_builder_2/:app_group_id/clone": { POST: postEngagementReportBuilder2Clone },
  "/engagement/report_builder_2/:app_group_id/developers": { GET: getEngagementReportBuilder2Developers },
  "/engagement/report_builder_2/:app_group_id/new_report": {
    POST: postEngagementReportBuilder2AppGroupIdNewReport,
  },
  "/engagement/report_builder_2/:app_group_id/segment_analytics_tracking_windows": {
    GET: getEngagementReportBuilder2AppGroupIdSegmentAnalyticsTrackingWindows,
  },
  "/engagement/report_builder_2/:app_group_id/segment_identities": {
    GET: getEngagementReportBuilder2AppGroupIdSegmentIdentities,
  },
  "/engagement/report_builder_2/:app_group_id/tags": { GET: getEngagementReportBuilder2Tags },
  "/engagement/report_builder_2/:app_group_id/update_archived_state": { POST: postReportBuilder2Archive },
  "/engagement/report_builder_2/:app_group_id/update_tags": { PUT: putReportBuilder2BulkUpdateTags },
  "/engagement/report_builder_2/:report_id/:app_group_id": {
    GET: getEngagementReportBuilder2AppGroupIdReportId,
    PUT: putEngagementReportBuilder2AppGroupIdReportId,
  },
  "/engagement/report_builder_2/:report_id/:app_group_id/cancel": {
    POST: postReportBuilder2CancelReport,
  },
  "/engagement/report_builder_2/:report_id/:app_group_id/result": {
    GET: getReportBuilderReportResults,
  },
  "/engagement/report_builder_2/:report_id/:app_group_id/run": {
    POST: postEngagementReportBuilder2ReportIdAppGroupIdRun,
    POSTWS: postwsEngagementReportBuilder2Run,
  },
  "/engagement/report_builder_2_reports": { GET: getDataTableEngagementReportBuilder2Reports },
  "/engagement/report_dashboard": { POST: postEngagementReportDashboard },
  "/engagement/report_dashboard/:dashboard_id": {
    DELETE: deleteEngagementReportDashboardDashboardId,
    GET: getEngagementReportDashboardDashboardId,
    PUT: putEngagementReportDashboardDashboardId,
  },
  "/engagement/report_dashboard/:dashboard_id/:app_group_id/create_tile_from_report_builder_report": {
    POST: postEngagementReportDashboardDashboardIdCreateTileFromReportBuilderReport,
  },
  "/engagement/report_dashboard/:dashboard_id/create_tile_data_query": {
    POST: postEngagementReportDashboardDashboardIdCreateTileDataQuery,
  },
  "/engagement/report_dashboard/latest": { GET: getEngagementReportDashboardLatest },
  "/engagement/report_dashboard/run_dashboard/:dashboard_type(/:dashboard_id)": {
    POST: postReportDashboardRunDashboard,
  },
  "/engagement/report_dashboards": { GET: getDataTableEngagementReportDashboards },
  "/engagement/report_dashboards/:app_group_id/update_archived_state": {
    POST: postEngagementReportDashboardsAppGroupIdUpdateArchivedState,
  },
  "/engagement/report_dashboards/tags": { GET: getDashboardReportTags },
  "/engagement/report_dashboards/update_tags": { PUT: putReportDashboardsUpdateTags },
  "/engagement/report_tile": { POST: postEngagementReportTile },
  "/engagement/report_tile/:tile_id": {
    DELETE: deleteEngagementReportTileTileId,
    PUT: putEngagementReportTileTileId,
  },
  "/engagement/sdk_auth/changelogs": { GET: getSdkAuthChangelogs },
  "/engagement/segment_data": { GET: getEngagementSegmentData },
  "/engagement/segment_insights_actual_statistics": { POSTWS: postEngagementSegmentInsightsActualStatistics },
  "/engagement/segment_preview/:app_group_id": { GET: getEngagementSegmentPreview },
  "/engagement/segment_stats": { GET: getSegmentStats },
  "/engagement/segments": { GET: getEngagementSegments, POST: postEngagementSegments },
  "/engagement/segments/:app_group_id/mark_as_archived": { POST: postEngagementSegmentsMarkAsArchived },
  "/engagement/segments/:app_group_id/mark_as_unarchived": { POST: postEngagementSegmentsMarkAsUnarchived },
  "/engagement/segments/:app_group_id/update_tags": { POST: engagementSegmentsUpdateTags },
  "/engagement/segments/:id/engagements": { GET: getSegmentEngagements },
  "/engagement/segments/:segment_id": { PUT: putEngagementSegmentsSegmentId },
  "/engagement/segments/:segment_id/download_selector": { GET: getEngagementSegmentsSegmentIdDownloadSelector },
  "/engagement/segments/:segment_id/export": { POST: postEngagementSegmentsExport },
  "/engagement/segments/:segment_id/facebook_export": { POST: postEngagementSegmentsFacebookExport },
  "/engagement/segments/:segment_id/migrate_filters": { POST: engagementSegmentsMigrateFilters },
  "/engagement/segments/campaign_sentence/:app_group_id": { GET: getEngagementSegmentsCampaignSentenceAppGroupId },
  "/engagement/segments/campaigns_for_link_segmentation": {
    GET: getEngagementSegmentsCampaignsForLinkSegmentation,
  },
  "/engagement/segments/can_export_all_attributes": { GET: getEngagementSegmentsCanExportAllAttributes },
  "/engagement/segments/clone": { POST: postEngagementSegmentsClone },
  "/engagement/segments/segment_territories": { GET: getEngagementSegmentsSegmentTerritories },
  "/engagement/segments/star": { POST: postEngagementSegmentsStar },
  "/engagement/segments/tags": { GET: getEngagementSegmentsTags },
  "/engagement/segments/unstar": { POST: postEngagementSegmentsUnstar },
  "/engagement/segments/workflows_for_link_segmentation": {
    GET: getEngagementSegmentsWorkflowsForLinkSegmentation,
  },
  "/engagement/segments_and_filters_sentence_array/:app_group_id": {
    GET: getEngagementSegmentsAndFiltersSentenceArray,
    POST: postEngagementSegmentsAndFiltersSentenceArray,
  },
  "/engagement/segments_count": { GET: getEngagementSegmentsCount },
  "/engagement/sparse_segments_data": { GET: getEngagementSparseSegmentsData },
  "/engagement/sql_queries": { GET: getSqlQueries },
  "/engagement/sql_queries/:query_id": { GET: getEngagementSqlQueriesQueryId },
  "/engagement/tags_with_replied_to_sms": { GET: getEngagementTagsWithRepliedToSms },
  "/engagement/update_android_notification_channels": {
    POST: updateAndroidNotificationChannels,
  },
  "/engagement/update_feature_flag_rollout_archived_state": {
    POST: postEngagementUpdateFeatureFlagRolloutArchivedState,
  },
  "/engagement/update_ios_notification_groups": { POST: updateIosNotificationGroups },
  "/engagement/update_location_set/:location_set_id": { POST: postEngagementUpdateLocationSetLocationSetId },
  "/engagement/upload_asset": {
    POST: postEngagementUploadAsset,
  },
  "/engagement/user/matcher": { GET: getEngagementUserMatcher, POST: postEngagementUserMatcher },
  "/engagement/user_directory_preview/:app_group_id": {
    POSTWS: requestUserDirectoryPreview,
  },
  "/engagement/v2/link_templates": { GET: getDataTableEngagementV2LinkTemplates },
  "/engagement/webhook_templates": {
    GET: getWebhookMessageTemplates,
  },
  "/engagement/webhook_templates/:id": { GET: getWebhookMessageTemplateId, POST: postEngagementWebhookTemplatesId },
  "/engagement/webhook_templates/duplicate": { POST: postEngagementWebhookTemplatesDuplicate },
  "/engagement/webhook_templates/tags": { GET: getEngagementWebhookTemplatesTags },
  "/engagement/webhook_templates/territories": { GET: getEngagementWebhookTemplatesTerritories },
  "/engagement/webhook_templates/update_archived_state": {
    POST: postEngagementWebhookTemplatesUpdateArchivedState,
  },
  "/engagement/webhook_templates/update_tags": { POST: postEngagementWebhookTemplatesUpdateTags },
  "/engagement/whatsapp/account_data": { GET: getDataTableIntegrationsGetWhatsAppData },
  "/engagement/whatsapp/message_templates/:messaging_service_id": {
    GET: getWhatsAppMessageTemplates,
  },
  "/engagement/whatsapp/messaging_services": {
    GET: getWhatsAppMessagingServices,
  },
  "/free_trial/submit_pre_verification": { POST: postFreeTrialSubmitPreVerification },
  "/free_trial/submit_registration": {
    POST: submitRegistrationData,
  },
  "/free_trial/validate_email": {
    POST: validateEmail,
  },
  "/free_trial/validate_sms": {
    POST: validateSms,
  },
  "/free_trial/verify_email": {
    POST: verifyEmail,
  },
  "/free_trial/verify_sms": {
    POST: verifySms,
  },
  "/funnel_reports/:app_group_id/create": { POST: postGlobalFunnelRun },
  "/funnel_reports/:report_id/:app_group_id/details": { GET: getFunnelReportDetails },
  "/funnel_reports/:run_id/:app_group_id/status": { GET: getGlobalFunnelRun },
  "/generative_ai/agent": { POST: postGenerativeAiAgent },
  "/generative_ai/agent/:id": { GET: getGenerativeAiAgentId },
  "/generative_ai/agent/:id/copy/:target_app_group_id": { POST: postGenerativeAiAgentIdCopyTargetAppGroupId },
  "/generative_ai/agent/:id/execution_stats": { GET: getGenerativeAiAgentIdExecutionStats },
  "/generative_ai/agent/:id/logs": { GET: getDataTableGenerativeAiAgentIdLogs },
  "/generative_ai/agent/:id/logs/:invocation_id": { GET: getGenerativeAiAgentIdLogsDetail },
  "/generative_ai/agent/:id/logs/batch_details": { GET: getGenerativeAiAgentIdLogsBatchDetails },
  "/generative_ai/agent/:id/logs/calling_locations": { GET: getGenerativeAiAgentIdLogsCallingLocations },
  "/generative_ai/agent/:id/logs/runs": { GET: getDataTableGenerativeAiAgentIdLogRuns },
  "/generative_ai/agent/:id/version/:version/diff": { GET: getGenerativeAiAgentIdVersionDiff },
  "/generative_ai/agent/:id/versions": { GET: getDataTableGenerativeAiAgentIdVersions },
  "/generative_ai/agent/clone": { POST: postGenerativeAiAgentClone },
  "/generative_ai/agent_update_archived_state": { PUT: putGenerativeAiAgentUpdateArchivedState },
  "/generative_ai/agents": { GET: getDataTableGenerativeAiAgents },
  "/generative_ai/agents/agent_console_credit_ratios": { GET: getAgentConsoleCreditRatios },
  "/generative_ai/agents/catalogs": { GET: getGenerativeAiAgentsCatalogs },
  "/generative_ai/agents/models": { GET: getGenerativeAiAgentsModels },
  "/generative_ai/agents/standards_settings": { GET: getGenerativeAiAgentsStandardsSettings },
  "/generative_ai/agents/tags": { GET: getGenerativeAiAgentsTags },
  "/generative_ai/agents/territories": { GET: getGenerativeAiAgentsTerritories },
  "/generative_ai/agents/tools": { GET: getGenerativeAiAgentsTools },
  "/generative_ai/agents/unique_name": { GET: getGenerativeAiAgentsUniqueName },
  "/generative_ai/brand_guideline": { GET: getGenerativeAiBrandGuideline },
  "/generative_ai/brand_guideline_document": {
    DELETE: deleteGenerativeAiBrandGuidelineDocument,
    POST: postGenerativeAiBrandGuidelineDocument,
  },
  "/generative_ai/brand_guideline_update_archived_state": {
    PUT: putGenerativeAiBrandGuidelineUpdateArchivedState,
  },
  "/generative_ai/brand_guidelines": { POST: postGenerativeAiBrandGuidelines },
  "/generative_ai/list_brand_guidelines": { GET: listBrandGuidelines },
  "/generative_ai/rate_limit_stats": {
    GET: getOpenAiRateLimitStats,
  },
  "/inbox_vision/:app_group_id/create_email_test": { POST: postInboxVisionAppGroupIdCreateEmailTest },
  "/inbox_vision/:app_group_id/get_inbox_vision_data": { GET: getInboxVisionAppGroupIdGetInboxVisionData },
  "/inbox_vision/:app_group_id/set_default_preview_ids": { POST: postInboxVisionAppGroupIdSetDefaultPreviewIds },
  "/integrations/currents_integration_data/:id": { GET: getIntegrationsCurrentsIntegrationDataId },
  "/integrations/currents_integrations_config": { GET: getIntegrationsCurrentsIntegrationsConfig },
  "/integrations/direct/cdi/aws-account-id": { GET: getIntegrationsDirectCdiAwsAccountId },
  "/integrations/direct/cdi/catalog_schema_diff": { POST: postIntegrationsDirectCdiCatalogSchemaDiff },
  "/integrations/direct/cdi/gcp-wif-principal/:app_group_id": {
    GET: getIntegrationsDirectCdiGcpWifPrincipalAppGroupId,
  },
  "/integrations/direct/cdi/import-keys/:app_group_id": { GET: getIntegrationsDirectCdiImportKeysAppGroupId },
  "/integrations/direct/cdi/import-keys/:key_id/delete": { POST: postImportKeysDelete },
  "/integrations/direct/cdi/import-keys/:key_id/regenerate": {
    POST: postCdiKeyRegenerate,
  },
  "/integrations/direct/cdi/import-keys/:key_id/test": { POST: postIntegrationsDirectCdiImportKeysKeyIdTest },
  "/integrations/direct/cdi/import-keys/:key_id/update": { PUT: putImportKeysUpdate },
  "/integrations/direct/cdi/import-keys-generate": {
    POST: postIntegrationsDirectCdiImportKeysGenerate,
  },
  "/integrations/direct/cdi/import-syncs": {
    POST: createCdiImportSync,
  },
  "/integrations/direct/cdi/import-syncs/:import_sync_id": {
    DELETE: deleteCdiImportSync,
    PUT: updateCdiImportSync,
  },
  "/integrations/direct/cdi/import-syncs/:import_sync_id/connection": {
    POST: postCdiTestConnection,
  },
  "/integrations/direct/cdi/import-syncs/:import_sync_id/infer_catalog_fields": { GET: getCdiInferCatalogFields },
  "/integrations/direct/cdi/import-syncs/:import_sync_id/status": {
    PUT: updateCdiImportSyncStatus,
  },
  "/integrations/direct/cdi/import-syncs/:import_sync_id/sync_now": {
    POST: postIntegrationCdiSyncNow,
  },
  "/integrations/direct/cdi/import-syncs/all": { GET: getCdiImportSyncsAll },
  "/integrations/direct/cdi/import-syncs/connection": { POST: postIntegrationsDirectCdiImportSyncsConnection },
  "/integrations/direct/cdi/import-syncs/test_sync_connection": {
    POST: postIntegrationsDirectCdiImportSyncsTestConnection,
  },
  "/integrations/direct/cdi/initialize_map": { POST: postIntegrationsDirectCdiInitializeMap },
  "/integrations/direct/cdi/job_sync_status_summary": { GET: getCdiJobSyncStatusSummary },
  "/integrations/direct/cdi/jobs": { GET: getCdiJobs },
  "/integrations/direct/cdi/jobs/:job_id": { GET: getCdiJobById },
  "/integrations/direct/cdi/jobs/:job_id/errors": { GET: getCdiJobErrors },
  "/integrations/direct/cdi/jobs/:job_id/errors/request_export": {
    POST: postIntegrationsDirectCdiJobsJobIdErrorsRequestExport,
  },
  "/integrations/direct/cdi/jobs/:job_id/sink_logs": { GET: getCdiJobsSinkLogs },
  "/integrations/direct/cdi/jobs/:job_id/sink_logs/request_export": {
    POST: postIntegrationsDirectCdiJobsJobIdSinkLogsRequestExport,
  },
  "/integrations/direct/cdi/segments_config": {
    GET: getCdiSegmentsConfig,
  },
  "/integrations/direct/cdi/snowflake-wif-principal/:app_group_id": {
    GET: getIntegrationsDirectCdiSnowflakeWifPrincipalAppGroupId,
  },
  "/integrations/direct/cdi/sources": {
    GET: getIntegrationsDirectCdiSources,
    POST: postIntegrationsDirectCdiSources,
  },
  "/integrations/direct/cdi/sources/:source_id": {
    DELETE: deleteCdiSourcesConfig,
    PATCH: patchIntegrationsDirectCdiSourcesSourceId,
  },
  "/integrations/direct/cdi/sources/:source_id/distinct_column_values": {
    GET: getIntegrationsDirectCdiSourcesSourceIdDistinctColumnValues,
  },
  "/integrations/direct/cdi/sources/:source_id/preview_and_validate": {
    POST: postIntegrationsDirectCdiSourcesSourceIdPreviewAndValidate,
  },
  "/integrations/direct/cdi/sources/:source_id/refresh_schemas": {
    POST: postIntegrationsDirectCdiSourcesSourceIdRefreshSchemas,
  },
  "/integrations/direct/cdi/sources/:source_id/test_connection": {
    POST: postIntegrationsDirectCdiSourcesSourceIdTestConnection,
  },
  "/integrations/direct/cdi/sources/test_connection": { POST: postIntegrationsDirectCdiSourcesTestConnection },
  "/integrations/direct/cdi/validation-overrides": { GET: getIntegrationsDirectCdiValidationOverrides },
  "/integrations/get_technology_partner_data(/:pill)(/:app_group_id)": {
    GET: getIntegrationsGetTechnologyPartnerData,
  },
  "/integrations/get_technology_partners_data": { GET: getIntegrationsGetTechnologyPartnersData },
  "/integrations/scim/scim_destroy": { POST: postIntegrationsScimScimDestroy },
  "/integrations/scim/scim_edit_settings": { POST: postIntegrationsScimScimEditSettings },
  "/integrations/scim/scim_info": { GET: getIntegrationsScimScimInfo },
  "/integrations/scim/scim_install": { POST: postIntegrationsScimScimInstall },
  "/integrations/scim/scim_reset_token": { POST: postIntegrationsScimScimResetToken },
  "/integrations/voucher_group/:id/:app_group_id": { GET: getIntegrationsVoucherGroupIdAppGroupId },
  "/integrations/voucher_groups": { GET: getDataTableIntegrationsVoucherGroups },
  "/integrations/voucher_groups/:id/:app_group_id/unused_voucher_codes_export": {
    POST: postIntegrationsVoucherGroupsIdAppGroupIdUnusedVoucherCodesExport,
  },
  "/integrations/voucher_groups/tags": { POST: postIntegrationsVoucherGroupsTags },
  "/internal_user_groups/:internal_user_group_id": {
    GET: getAppSettingsInternalUserGroupsInternalUserGroupId,
  },
  "/internal_user_groups/:internal_user_group_id/test_users_v2": {
    GET: getDataTableAppSettingsInternalUserGroupsInternalUserGroupIdV2TestUsers,
  },
  "/internal_user_groups/anonymous_users": {
    GET: getAppSettingsInternalUserGroupsAnonymousUsers,
    PUT: putAppSettingsInternalUserGroupsAnonymousUsers,
  },
  "/internal_user_groups/bulk_add_users_to_group_v2/:app_group_id": {
    POST: postAppSettingsInternalUserGroupsBulkAddUsersToGroupV2AppGroupId,
  },
  "/internal_user_groups/delete_internal_user_groups": {
    POST: postAppSettingsInternalUserGroupsDeleteInternalUserGroups,
  },
  "/internal_user_groups/delete_test_user": {
    POST: deleteTestUser,
  },
  "/internal_user_groups/extract_users_from_ids": {
    POST: postAppSettingsInternalUserGroupsExtractUsersFromIds,
  },
  "/internal_user_groups/internal_user_group_create": {
    POST: postAppSettingsInternalUserGroupsInternalUserGroupCreate,
  },
  "/internal_user_groups/internal_user_group_update": {
    PUT: putAppSettingsInternalUserGroupsInternalUserGroupUpdate,
  },
  "/internal_user_groups/internal_user_group_upsert": {
    POST: postAppSettingsInternalUserGroupsInternalUserGroupUpsert,
  },
  "/internal_user_groups/internal_user_groups_data": {
    GET: getInternalUserGroups,
  },
  "/internal_user_groups/internal_user_groups_data_v2": {
    GET: getDataTableAppSettingsV2InternalUserGroupsInternalUserGroups,
  },
  "/internal_user_groups/remove_test_users_from_internal_user_group": {
    POST: postAppSettingsInternalUserGroupsRemoveTestUsersFromInternalUserGroup,
  },
  "/internal_user_groups/test_user": {
    PATCH: patchAppSettingsInternalUserGroupsTestUser,
    POST: postTestUser,
  },
  "/internal_user_groups/test_user_app_data": { GET: getAppSettingsInternalUserGroupsTestUserAppData },
  "/internal_user_groups/test_user_names": {
    GET: getTestUserNames,
  },
  "/milestone_checklist": {
    GET: getMilestoneChecklist,
    PATCH: patchMilestoneChecklist,
    POST: postMilestoneChecklist,
  },
  "/milestone_checklist_settings": {
    GET: getMilestoneChecklistSettings,
  },
  "/oauth/applications/:client_id": { GET: getOAuthApplicationData },
  "/oauth/authorize": { POST: postOAuthAuthorize },
  "/oauth/validate_authorization_request": { GET: getOAuthValidateAuthorizationRequest },
  "/oauth/validate_developer_permissions": { GET: getOAuthValidateDeveloperPermissions },
  "/oauth/validate_scopes": { GET: getOAuthValidateScopes },
  "/offerfit/:app_group_id/get_primary_kpi/:use_case_id": { GET: getOfferfitAppGroupIdGetPrimaryKpi },
  "/offerfit/:app_group_id/use_cases": { GET: getDataTableOfferfitAppGroupIdUseCases },
  "/offerfit/:app_group_id/use_cases/:use_case_id": { GET: getOfferfitAppGroupIdUseCasesUseCaseId },
  "/offerfit/:app_group_id/use_cases/:use_case_id/campaign_data": {
    GET: getOfferfitAppGroupIdUseCasesUseCaseIdCampaignData,
  },
  "/offerfit/:app_group_id/use_cases/:use_case_id/token": {
    GET: getOfferfitAppGroupIdUseCasesUseCaseIdToken,
  },
  "/offerfit/:app_group_id/use_cases/:use_case_id/unpromoted_customer_changes": {
    GET: getOfferfitAppGroupIdUseCasesUseCaseIdUnpromotedCustomerChanges,
  },
  "/pilot_deep_link_qr_code": { GET: getFreeTrialPilotDeepLinkQrCode },
  "/product_alerts": { GET: getProductAlerts, POST: postProductAlert },
  "/product_alerts/:id": {
    DELETE: deleteProductAlert,
    GET: getProductAlert,
    PATCH: patchProductAlert,
    PUT: putProductAlert,
  },
  "/product_alerts/overrides": { GET: getProductAlertOverrides },
  "/product_alerts/overrides/:alert_id/:canvas_id": { PUT: putProductAlertOverridesAlertIdCanvasId },
  "/recent_interactions": { GET: getRecentInteractions },
  "/recently_visited": { GET: getRecentlyVisited },
  "/recently_visited/visit": { POST: postRecentlyVisitedVisit },
  // REMOTE_LOOKUP_SCAFFOLD_START
  "/remote_lookup/:app_group_id/app/find": { GET: remoteLookupFindFetchers.app },
  "/remote_lookup/:app_group_id/app/search": { GET: remoteLookupSearchFetchers.app },
  "/remote_lookup/:app_group_id/campaign/find": { GET: remoteLookupFindFetchers.campaign },
  "/remote_lookup/:app_group_id/campaign/search": { GET: remoteLookupSearchFetchers.campaign },
  "/remote_lookup/:app_group_id/canvas/find": { GET: remoteLookupFindFetchers.canvas },
  "/remote_lookup/:app_group_id/canvas/search": { GET: remoteLookupSearchFetchers.canvas },
  "/remote_lookup/:app_group_id/canvas_step/find": { GET: remoteLookupFindFetchers.canvas_step },
  "/remote_lookup/:app_group_id/canvas_step/search": { GET: remoteLookupSearchFetchers.canvas_step },
  "/remote_lookup/:app_group_id/cohort/find": { GET: remoteLookupFindFetchers.cohort },
  "/remote_lookup/:app_group_id/cohort/search": { GET: remoteLookupSearchFetchers.cohort },
  "/remote_lookup/:app_group_id/csv_import/find": { GET: remoteLookupFindFetchers.csv_import },
  "/remote_lookup/:app_group_id/csv_import/search": { GET: remoteLookupSearchFetchers.csv_import },
  "/remote_lookup/:app_group_id/custom_attribute/find": { GET: remoteLookupFindFetchers.custom_attribute },
  "/remote_lookup/:app_group_id/custom_attribute/search": { GET: remoteLookupSearchFetchers.custom_attribute },
  "/remote_lookup/:app_group_id/custom_event/find": { GET: remoteLookupFindFetchers.custom_event },
  "/remote_lookup/:app_group_id/custom_event/search": { GET: remoteLookupSearchFetchers.custom_event },
  "/remote_lookup/:app_group_id/developer/find": { GET: remoteLookupFindFetchers.developer },
  "/remote_lookup/:app_group_id/developer/search": { GET: remoteLookupSearchFetchers.developer },
  "/remote_lookup/:app_group_id/purchase/find": { GET: remoteLookupFindFetchers.purchase },
  "/remote_lookup/:app_group_id/purchase/search": { GET: remoteLookupSearchFetchers.purchase },
  "/remote_lookup/:app_group_id/segment_cohort/find": { GET: remoteLookupFindFetchers.segment_cohort },
  "/remote_lookup/:app_group_id/segment_cohort/search": { GET: remoteLookupSearchFetchers.segment_cohort },
  "/remote_lookup/:app_group_id/sparse_segment/find": { GET: remoteLookupFindFetchers.sparse_segment },
  "/remote_lookup/:app_group_id/sparse_segment/search": { GET: remoteLookupSearchFetchers.sparse_segment },
  "/remote_lookup/:app_group_id/tag/find": { GET: remoteLookupFindFetchers.tag },
  "/remote_lookup/:app_group_id/tag/search": { GET: remoteLookupSearchFetchers.tag },
  "/remote_lookup/:app_group_id/territory/find": { GET: remoteLookupFindFetchers.territory },
  "/remote_lookup/:app_group_id/territory/search": { GET: remoteLookupSearchFetchers.territory },
  // REMOTE_LOOKUP_SCAFFOLD_END
  "/reporting/:app_group_id/metrics/query": { POST: postReportingAppGroupIdMetricsQuery },
  "/resources/productboard_auth": { GET: getResourcesProductboardAuth },
  "/sdk/debugger/:app_group_id/all": { GET: getDataTableSdkDebuggerAppGroupIdAll },
  "/sdk/debugger/:recording_id/logs": { GET: getSdkDebuggerRecordingIdLogs },
  "/sdk/debugger/:recording_id/session": { GET: getSdkDebuggerRecordingId },
  "/sdk/debugger/:recording_id/stop": { PUT: putSdkDebuggerRecordingIdStop },
  "/sdk/debugger/document": { PUT: putSdkDebuggerDocument },
  "/search": { GET: getGlobalSearch },
  "/subscription_group_analytics/:app_group_id": { GET: getSubscriptionGroupAnalytics },
  "/support/cases/:app_group_id": { POST: postSupportCasesAppGroupId },
  "/two-factor/disable": {
    POST: disableMultiFactorAuth,
  },
  "/users/preference_center": { GET: getUsersPreferenceCenter, POST: postUsersPreferenceCenter },
  "/users/preference_center/select": { GET: getUsersPreferenceCenterSelect },
  "/users/preference_centers": { GET: getUsersPreferenceCenters },
  "/users/sms_subscription_groups_for_filter": { GET: getUsersSmsSubscriptionGroupsForFilter },
  "/users/subscription_group/double_opt_in_enabled": { GET: getUsersSubscriptionGroupDoubleOptInEnabled },
  "/users/subscription_group_current_day_stats/:subscription_group_id": {
    POSTWS: postwsUsersSubscriptionGroupCurrentDayStatsSubscriptionGroupId,
  },
  "/users/subscription_group_data": { GET: getUsersSubscriptionGroupData },
  "/users/subscription_group_stats": { GET: getUsersSubscriptionGroupStats },
  "/users/subscription_groups/(:id)": { POST: postUsersSubscriptionGroupsId },
  "/users/subscription_groups/update_archived_state/:id": {
    POST: postUsersSubscriptionGroupsUpdateArchivedStateId,
  },
  "/users/subscription_groups/usage/:id": { GET: getUsersSubscriptionGroupsUsageId },
  "/users/subscription_groups_data": { GET: getSubscriptionGroupsData },
} as const);
/**
 * This pass-through function gives us strict typing AND perfect inference of the `dashboardApiEndpoints` declaration
 */
function makeDashboardApiEndpoints<T>(endpointDefinitions: VerifyDashboardApiEndpointDefinitions<T>): T {
  return endpointDefinitions as T;
}
